/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/* i18n helper (global so every IIFE sees it) */
if(typeof window!=="undefined" && typeof window.T==="undefined"){window.T=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var T=window.T;
// app/js/interactions.js — per-page logic (each block no-ops off its page). [Step 4]

/* ===== category taxonomy (shared helper) ===== */
var _gsCats=null;
async function gsCategories(){ if(_gsCats)return _gsCats; var r=await GS.api('/categories'); _gsCats=(r.ok&&r.data&&r.data.categories)||[]; return _gsCats; }
function fillCategorySelect(sel,selected){ if(!sel)return; gsCategories().then(function(cats){
  var html='<option value="">Choose a category…</option>';
  cats.forEach(function(m){ html+='<optgroup label="'+m.name+'"><option value="'+m.id+'">'+m.name+' (all)</option>';
    (m.subs||[]).forEach(function(s){ html+='<option value="'+s.id+'">'+s.name+'</option>'; }); html+='</optgroup>'; });
  sel.innerHTML=html; if(selected!=null&&selected!=='') sel.value=String(selected);
}); }

/* ===== auth ===== */
// auth.js — login / register / forgot-password
document.addEventListener('DOMContentLoaded', () => {
  const btn = GSUI.gs('submit'); if(!btn) return;
  const err = GSUI.gs('error'), ok = GSUI.gs('ok');
  /* Bail out on the verify screen.
   *
   * This handler binds to data-gs="submit", which the verify page also uses — so both were attached
   * to one button. And the matcher below ends in `|| 'login'`, meaning any page it does not recognise
   * is TREATED as login: on /verify-email that made the button fire a login attempt with an email
   * field that does not exist. Presence of the code field is the reliable signal, since it says what
   * the page IS rather than what its URL happens to look like. */
  if (GSUI.gs('code')) return;

  const page = (location.pathname.match(/(login|register|forgot-password)/)||[])[1]
    || (location.search.match(/page=([a-z-]+)/)||[])[1] || 'login';
  btn.addEventListener('click', async () => {
    GSUI.show(err,false);
    const email = GSUI.gs('email') && GSUI.gs('email').value;
    if (page === 'login') {
      const r = await GS.api('/auth/login',{method:'POST',body:JSON.stringify({email,password:GSUI.gs('password').value})});
      if (r.ok) { location.href = gsRawReturn() ? gsReturnTarget() : '/sites'; return; }
      /* Unverified: send them to the code screen rather than showing "invalid credentials" for a
         password that was correct. A fresh code went out with the 403. */
      if (r.status === 403 && r.data && r.data.error === 'verify_required') {
        location.href = gsCarry(r.data.verify_url || '/verify-email');
        return;
      }
      else { err.textContent = r.data && r.data.error==='invalid_credentials' ? 'Wrong email or password.' : T('ix.sign_in_failed'); GSUI.show(err,true); }
    } else if (page === 'register') {
      const r = await GS.api('/auth/register',{method:'POST',body:JSON.stringify({ref:(new URLSearchParams(location.search).get("ref")||""),coupon:(GSUI.gs('coupon')?GSUI.gs('coupon').value.trim():""),email,password:GSUI.gs('password').value})});
      /* Straight to the code screen, carrying the return so the connect flow survives. Registration
         does not sign you in, and the verify page accepts ?uid= precisely for this hop. */
      if (r.ok){
        GSUI.show(ok,true);
        var d = r.data || {};
        if (d.verification_sent === false){
          ok.textContent = T('ix.account_created_but_we_could_not_send_the_ve')
                         + 'You can request a new code on the next screen.';
        }
        var dest = d.verify_url || '/verify-email';
        setTimeout(()=>location.href=gsCarry(dest),1400);
      }
      else {
        var e = (r.data && r.data.error) || '';
        err.textContent = e==='email_taken'    ? 'That email is already registered.'
                        : e==='weak_password'  ? 'Password must be at least '+((r.data&&r.data.min)||10)+' characters.'
                        : e==='rate_limited'   ? 'Too many attempts from this address. Try again later.'
                        : e==='invalid_email'  ? 'That email address is not valid.'
                        : 'Could not create account'+(e?' ('+e+')':'')+'.';
        GSUI.show(err,true);
      }
    } else if (page === 'forgot-password') {
      await GS.api('/auth/request-reset',{method:'POST',body:JSON.stringify({email})});
      GSUI.show(ok,true);  // always show success (no account enumeration)
    }
  });
});

/* ── ?return= across the sign-in <-> sign-up hops ─────────────────────────────
 * Someone arriving from a partner with no GhostStat account lands here as
 * /?page=login&return=<the /id/start URL>. They click "Create one", register, and get sent back to
 * login — and every one of those hops dropped the return URL, so after finally signing in they
 * landed on the dashboard and the connect flow they started was silently abandoned.
 *
 * This lived in app/js/auth.js, which nothing loads: interactions.js is what actually runs the auth
 * pages. It never executed. */
function gsRawReturn(){ const m = location.search.match(/[?&]return=([^&]+)/); return m ? m[1] : ''; }

function gsCarry(href){
  const r = gsRawReturn();
  if (!r) return href;
  return href + (href.indexOf('?') === -1 ? '?' : '&') + 'return=' + r;
}

/* Only same-origin paths or the GhostStat API host. An open redirector on a sign-in page hands an
   attacker a credible phishing hop through your own domain. */
function gsReturnTarget(){
  const raw = gsRawReturn();
  if (!raw) return '/?page=dashboard';
  let url;
  try { url = decodeURIComponent(raw); } catch (e) { return '/?page=dashboard'; }
  if (url.startsWith('/') && !url.startsWith('//')) return url;
  try {
    const u = new URL(url);
    const host = u.hostname.toLowerCase();
    const okHost = host === 'ghoststat.me' || host.endsWith('.ghoststat.me');
    if (u.protocol === 'https:' && okHost) return u.href;
  } catch (e) {}
  return '/?page=dashboard';
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href="/register"], a[href="/login"]').forEach((a) => {
    a.setAttribute('href', gsCarry(a.getAttribute('href')));
  });
});

/* ── verify-email: 6-digit code ───────────────────────────────────────────────
 * Its own handler, not a branch above: that one reads an email field this page does not have and
 * would fail before reaching any branch.
 *
 * ?uid= covers arriving straight from a signup mail with no session; otherwise the endpoint falls
 * back to the session, so a signed-in person needs nothing in the URL. */
document.addEventListener('DOMContentLoaded', function(){
  var codeEl = GSUI.gs('code'); if (!codeEl) return;

  var ok = GSUI.gs('ok'), err = GSUI.gs('err'), sent = GSUI.gs('sent');
  var submit = GSUI.gs('submit'), resend = GSUI.gs('resend');
  var uid = (location.search.match(/[?&]uid=(\d+)/) || [])[1] || null;

  function payload(extra){
    var b = extra || {};
    if (uid) b.user_id = Number(uid);
    return JSON.stringify(b);
  }
  function hideAll(){ [ok,err,sent].forEach(function(el){ if(el) GSUI.show(el,false); }); }

  /* Strip non-digits as they type: codes get pasted with spaces, and some clients hand over
     "424 242". Rejecting that would be pedantry. */
  codeEl.addEventListener('input', function(){
    var v = codeEl.value.replace(/\D+/g,'').slice(0,6);
    if (v !== codeEl.value) codeEl.value = v;
    if (v.length === 6) verify();          // no reason to make someone press a button as well
  });

  async function verify(){
    var code = codeEl.value.replace(/\D+/g,'');
    if (code.length !== 6){ err.textContent = T('ix.enter_the_6_digit_code_from_your_email'); GSUI.show(err,true); return; }
    hideAll(); submit.disabled = true;
    var r = await GS.api('/auth/verify-otp',{method:'POST',body:payload({code:code})});
    submit.disabled = false;
    if (r.ok && r.data && r.data.verified){
      /* Long enough to read. Safari autofills one-time-code fields from the mail that just arrived,
         which fires the input listener, which verifies and redirects — so the screen flashed past and
         you could not tell whether anything had happened. Verification DID happen; it just looked
         like a glitch. */
      /* The response carries a session — verifying signs you in, so this lands in the app rather
         than at another login form. */
      ok.textContent = T('ix.email_confirmed_signing_you_in');
      GSUI.show(ok,true);
      codeEl.disabled = true; submit.disabled = true;
      setTimeout(function(){
        location.href = gsRawReturn() ? gsReturnTarget() : '/sites';
      }, 1600);
      return;
    }
    var e = (r.data && r.data.error) || '';
    err.textContent = e === 'too_many_attempts' ? 'Too many attempts. Wait a few minutes and try again.'
      : e === 'invalid_or_expired' ? 'That code is wrong or has expired. Request a new one below.'
      : T('ix.could_not_confirm_your_email');
    GSUI.show(err,true);
    codeEl.select();
  }

  submit.addEventListener('click', function(ev){ ev.preventDefault(); verify(); });

  resend.addEventListener('click', async function(ev){
    ev.preventDefault(); hideAll();
    var r = await GS.api('/auth/resend-otp',{method:'POST',body:payload()});
    if (r.ok && r.data && r.data.already_verified){
      ok.textContent = T('ix.this_email_is_already_confirmed'); GSUI.show(ok,true);
      setTimeout(function(){ location.href = gsReturnTarget(); }, 1200); return;
    }
    if (r.ok){ GSUI.show(sent,true); codeEl.value=''; codeEl.focus(); return; }
    var e = (r.data && r.data.error) || '';
    /* A throttle is not a failure — say when, not "something went wrong". */
    err.textContent = e === 'too_soon'
      ? 'A code was just sent. Try again in ' + (r.data.retry_after || 60) + ' seconds.'
      : e === 'send_failed' ? 'We could not send the email. Check the address, or contact support.'
      : T('ix.could_not_send_a_new_code');
    GSUI.show(err,true);
  });

  codeEl.focus();
});

/* Signup coupon — prefill from ?coupon=, live-validate, show the special plan */
document.addEventListener('DOMContentLoaded', function(){
  var cf=GSUI.gs('coupon'), card=GSUI.gs('coupon-card'); if(!cf||!card) return;
  var pre=(location.search.match(/[?&]coupon=([^&]+)/)||[])[1]; if(pre) cf.value=decodeURIComponent(pre);
  function money(c){ return '$'+(Number(c||0)/100).toFixed(2); }
  function num(n){ return Number(n||0).toLocaleString(); }
  function feats(p){ try{ var f=typeof p.features_json==='string'?JSON.parse(p.features_json):p.features_json;
    if(f&&typeof f==='object') return Object.keys(f).filter(function(k){return f[k];}).slice(0,6).map(function(k){return '<li>'+k.replace(/_/g,' ')+'</li>';}).join(''); }catch(e){} return ''; }
  async function check(){
    var code=cf.value.trim(); if(!code){ card.innerHTML=''; return; }
    var r=await GS.api('/coupon/validate',{method:'POST',body:JSON.stringify({code:code,context:'signup'})});
    if(!r.ok||!r.data||!r.data.ok){ card.innerHTML='<div class="gs-muted small">That code isn\'t valid.</div>'; return; }
    var c=r.data.coupon;
    if(c.kind==='plan'&&c.plan){ var p=c.plan;
      card.innerHTML='<div class="coupon-plan"><div class="cp-badge">'+(p.is_lifetime?'Lifetime deal':T('ix.special_plan'))+'</div>'
        +'<div class="cp-name">'+p.name+'</div><div class="cp-price">'+money(p.price_cents)+(p.is_lifetime?' once':'/mo')+'</div>'
        +'<ul class="cp-feats"><li>'+num(p.max_sites)+' sites</li><li>'+(p.max_events?num(p.max_events)+' events/mo':T('ix.unlimited_events'))+'</li>'
        +'<li>'+(p.retention_days?p.retention_days+' days retention':T('ix.unlimited_retention'))+'</li>'+feats(p)+'</ul>'
        +'<div class="cp-note">'+(p.price_cents>0?('Create your account, then pay '+money(p.price_cents)+(p.is_lifetime?' once':'/mo')+' under Billing to get this plan.'):'You\'ll get this plan when you create your account with this code.')+'</div></div>';
    } else if(c.kind==='percent'){ card.innerHTML='<div class="coupon-plan"><div class="cp-badge">'+T('ix.discount')+'</div><div class="cp-name">'+c.percent_off+'% off</div><div class="cp-note">'+(c.description||'')+' — applies at upgrade.</div></div>';
    } else if(c.kind==='fixed'){ card.innerHTML='<div class="coupon-plan"><div class="cp-badge">'+T('ix.discount')+'</div><div class="cp-name">'+money(c.amount_off_cents)+' off</div><div class="cp-note">'+(c.description||'')+' — applies at upgrade.</div></div>'; }
  }
  var t; cf.addEventListener('input',function(){ clearTimeout(t); t=setTimeout(check,400); });
  if(cf.value.trim()) check();
});

/* dashboard controller now lives in js/dashboard-v8.js */


/* ===== sites — All Websites overview ===== */
(function(){
  function ymd(d){return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2)}
  function shift(iso,n){var p=iso.split('-'),d=new Date(+p[0],+p[1]-1,+p[2]);d.setDate(d.getDate()+n);return ymd(d)}
  var today=ymd(new Date()), day=today, all=[];
  function dayLabel(){if(day===today)return T('dash.today','Today');if(day===shift(today,-1))return T('dash.yesterday','Yesterday');
    var p=day.split('-');try{return new Date(+p[0],+p[1]-1,+p[2]).toLocaleDateString((window.GS&&GS.locale==='nl')?'nl-NL':'en-US',{weekday:'short',day:'numeric',month:'short',year:'numeric'})}catch(e){return day}}
  function setDay(d){if(!d)return;if(d>today)d=today;day=d;load()}
  function fmt(n){return (Number(n)||0).toLocaleString('en')}
  function spark(data){var W=110,H=32;if(!data||data.length<2)data=[0,0];var n=data.length,mn=Math.min.apply(null,data),mx=Math.max.apply(null,data);
    var x=function(i){return i/(n-1)*W},y=function(v){return H-2-((v-mn)/(mx-mn||1))*(H-4)};
    var line=data.map(function(v,i){return(i?'L':'M')+x(i).toFixed(1)+' '+y(v).toFixed(1)}).join(' ');
    return '<svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="none"><path d="'+line+' L '+W+' '+H+' L 0 '+H+' Z" fill="#2A6FE8" opacity=".08"/><path d="'+line+'" fill="none" stroke="#2A6FE8" stroke-width="1.6"/></svg>'}
  function deltaEl(el,pct){if(!el)return;var up=pct>0,dn=pct<0;el.className='aw-stat-d '+(up?'up':dn?'down':'');el.innerHTML=(up?'\u25B2 ':dn?'\u25BC ':'')+Math.abs(pct)+'% <span style="color:var(--muted);font-weight:400">'+T('ix.from_previous_day')+'</span>'}
  function pctSpan(pct){var up=pct>0,dn=pct<0;return '<span class="pct '+(up?'up':dn?'down':'flat')+'">'+(up?'\u25B2':dn?'\u25BC':'')+Math.abs(pct)+'%</span>'}
  function render(){
    var se=GSUI.gs('aw-search'),q=((se&&se.value)||'').toLowerCase();
    var rows=all.filter(function(s){return !q||((s.name||'')+' '+(s.domain||'')).toLowerCase().indexOf(q)>=0});
    var tb=GSUI.gs('aw-rows');if(!tb)return;
    tb.innerHTML=rows.length?rows.map(function(s){return '<tr><td class="site"><a href="/dashboard?s='+s.public_key+'" data-key="'+s.public_key+'"><i class="bi bi-box-arrow-up-right"></i>'+(s.domain||s.name)+'</a><a class="site-cog" href="/site-settings?s='+s.public_key+'" title="'+T('ix.url_settings')+'"><i class="bi bi-gear"></i></a></td><td class="r">'+fmt(s.visits)+'</td><td class="r">'+fmt(s.pageviews)+'</td><td class="r">'+fmt(s.ai)+'</td><td class="r">'+fmt(s.hits)+'</td><td class="r">$'+fmt(s.revenue)+'</td><td class="r"><div class="aw-evo">'+pctSpan(s.d_visits)+spark(s.spark)+'</div></td></tr>'}).join(''):'<tr><td colspan="7" class="text-center gs-muted">No sites yet — add one.</td></tr>';
    GSUI.qa('[data-gs="aw-rows"] a[data-key]').forEach(function(a){a.addEventListener('click',function(){GS.site=a.dataset.key; try{localStorage.setItem('gs_site',a.dataset.key)}catch(e){}})});
  }
  async function load(){
    var tb=GSUI.gs('aw-rows');if(!tb)return;var dl=GSUI.gs('aw-day');if(dl)dl.textContent=dayLabel();var nb=GSUI.gs('day-next');if(nb)nb.disabled=day>=today;
    GSUI.qa('[data-gs="aw-dpmenu"] .rm').forEach(function(b){b.classList.toggle('on',shift(today,-(+b.dataset.day))===day)});var di=GSUI.gs('aw-dpdate');if(di){di.max=today;di.value=day}
    var r=await GS.api('/sites/overview?day='+day);
    if(!(r.ok&&r.data)){tb.innerHTML='<tr><td colspan="7" class="text-center gs-muted">'+T('ix.could_not_load')+'</td></tr>';return;}
    all=r.data.sites||[];var t=r.data.totals||{};
    ['visits','pageviews','ai','hits','revenue'].forEach(function(k){var el=GSUI.gs('t-'+k);if(el)el.textContent=(k==='revenue'?'$':'')+fmt(t[k]||0)});
    deltaEl(GSUI.gs('td-visits'),t.d_visits||0);deltaEl(GSUI.gs('td-pageviews'),t.d_pageviews||0);deltaEl(GSUI.gs('td-hits'),t.d_hits||0);deltaEl(GSUI.gs('td-ai'),t.d_ai||0);deltaEl(GSUI.gs('td-revenue'),0);
    render();
  }
  document.addEventListener('gs:ready', load);
  document.addEventListener('DOMContentLoaded', function(){
    var se=GSUI.gs('aw-search');if(se)se.addEventListener('input',render);
    var pv=GSUI.gs('day-prev'),nx=GSUI.gs('day-next');
    if(pv)pv.addEventListener('click',function(){setDay(shift(day,-1))});
    if(nx)nx.addEventListener('click',function(){setDay(shift(day,1))});
    /* the day picker: same pill + menu as the range pickers elsewhere, for one day */
    var dp=GSUI.gs('aw-dp'),dm=GSUI.gs('aw-dpmenu');
    function dpOpen(on){if(!dm)return;dm.hidden=!on;dp.setAttribute('aria-expanded',on?'true':'false')}
    if(dp&&dm){
      dp.addEventListener('click',function(e){if(dm.contains(e.target))return;dpOpen(dm.hidden)});
      dp.addEventListener('keydown',function(e){if(e.target!==dp)return;if(e.key==='Enter'||e.key===' '){e.preventDefault();dpOpen(dm.hidden)}else if(e.key==='Escape')dpOpen(false)});
      dm.addEventListener('keydown',function(e){if(e.key==='Escape'){dpOpen(false);dp.focus()}});
      document.addEventListener('click',function(e){if(!dp.contains(e.target))dpOpen(false)});
      GSUI.qa('[data-gs="aw-dpmenu"] .rm').forEach(function(b){b.addEventListener('click',function(){dpOpen(false);setDay(shift(today,-(+b.dataset.day)))})});
      var go=GSUI.gs('aw-dpgo'),di=GSUI.gs('aw-dpdate');
      if(go)go.addEventListener('click',function(){if(di&&di.value){dpOpen(false);setDay(di.value)}});
      if(di)di.addEventListener('keydown',function(e){if(e.key==='Enter'&&di.value){e.preventDefault();dpOpen(false);setDay(di.value)}});
    }
    fillCategorySelect(GSUI.gs('new-category'));
    var c=GSUI.gs('create-site');if(c)c.addEventListener('click',async function(){
      var err=GSUI.gs('site-error');GSUI.show(err,false);
      var r=await GS.api('/sites',{method:'POST',body:JSON.stringify({name:GSUI.gs('new-name').value,domain:GSUI.gs('new-domain').value,category_id:(GSUI.gs('new-category')||{}).value||''})});
      if(r.ok){var m=bootstrap.Modal.getInstance(document.getElementById('newSite'));if(m)m.hide();load()}
      else{err.textContent=(r.data&&r.data.error==='site_limit_reached')?'Site limit reached for your plan.':T('ix.could_not_create_site');GSUI.show(err,true)}
    });
  });
})();

/* ===== admin ===== — lives in admin.js (loaded only on the admin page); the old copy here called /admin/overview on every page. */

/* ===== counter ===== */
// counter.js — counter customizer: tabs, steppers, segmented controls, drag-drop BG,
// live preview, save, and per-format embed. No dependencies beyond GS / GSUI.
(function () {
  var SLUG = 'visitors';
  var C = function (n) { return document.querySelector('[data-c="' + n + '"]'); };
  var Cq = function (n) { return document.querySelectorAll('[data-c="' + n + '"]'); };

  // ---- state (mirrors Counter::config) ----
  var st = {
    label: T('ix.visitors'), mode: 'hits', start_value: 0,
    style: {
      color: '#12172A', bg_color: '#FFFFFF', bg_image: null,
      font: "Open Sans, sans-serif", font_size: 28, radius: 8,
      padding: 12, shape: 'rounded', shadow: true, animation: true,
      weight: 700, letter_spacing: 0, glow: false, bg2: '', transparent: false,
      border_w: 0, border_style: 'solid', border_color: '#E9EDF3',
      ghost: false, ghost_color: '#1FA463', anim: 'pop', digits: 0
    }
  };
  var embed = null;               // {image,script,iframe,json} after save/load
  var embedFmt = 'image';

  var MODE_HINT = {
    hits: T('ix.increments_once_every_time_the_counter_is_vi'),
    pageviews: T('ix.mirrors_your_site_s_real_pageview_total_from'),
    manual: 'Only changes when you call the increment API — e.g. downloads or sign-ups.'
  };

  // ---- helpers ----
  function isHex(v) { return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v); }
  function radiusFor() {
    return st.style.shape === 'square' ? 0 : st.style.shape === 'pill' ? 999 : st.style.radius;
  }
  function segSet(name, v) {
    var wrap = C(name); if (!wrap) return;
    wrap.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', b.dataset.v === v); });
  }
  function toggleSet(name, on) {
    var b = C(name); if (!b) return;
    b.classList.toggle('on', !!on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  // ---- live preview ----
  function ghostSvg(px){ px=Math.max(12,px||22);
    return '<svg width="'+px+'" height="'+px+'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'
      +'<path d="M12 2a8 8 0 0 0-8 8v10.2c0 .9 1 1.4 1.8 1l1.6-.9 1.7.9c.4.2.9.2 1.3 0l1.6-.9 1.6.9c.4.2.9.2 1.3 0l1.7-.9 1.6.9c.8.4 1.8-.1 1.8-1V10a8 8 0 0 0-8-8Z"/>'
      +'<circle cx="9.2" cy="10" r="1.4" fill="#0B0F0A"/><circle cx="14.8" cy="10" r="1.4" fill="#0B0F0A"/></svg>'; }
  var ANIMS = {pop:'gsc-pop .42s cubic-bezier(.16,1,.3,1) both',pulse:'gsc-pulse 1.6s ease-in-out infinite',
    blink:'gsc-blink 1.1s step-end infinite',glow:'gsc-glow 1.8s ease-in-out infinite',count:'gsc-pop .5s ease both'};
  function preview() {
    var p = C('preview'); if (!p) return;
    var s = st.style, rad = radiusFor();
    p.style.color = s.color;
    p.style.fontFamily = s.font;
    p.style.fontSize = s.font_size + 'px';
    p.style.fontWeight = s.weight || 700;
    p.style.letterSpacing = (s.letter_spacing || 0) + 'px';
    var scene = s.bg_scene && s.bg_scene !== 'none';
    var winFill = s.transparent ? 'transparent' : (s.bg2 ? 'linear-gradient(135deg,' + s.bg_color + ',' + s.bg2 + ')' : s.bg_color);
    if (scene && s.bg_image) {                                  // window (bg_color) grows with digits; art layers over it
      p.style.background = s.bg_full
        ? "url('" + s.bg_image + "') center/cover, " + winFill                                                    // full fun background
        : "url('" + s.bg_image + "') center 8px / auto " + (s.bg_art_h || 60) + "px no-repeat, " + winFill;        // top emblem (gauges)
    } else if (s.transparent) {
      p.style.background = 'transparent';
    } else if (s.bg_image) {
      p.style.background = "url('" + s.bg_image + "') center/cover";   // custom uploaded image
    } else {
      p.style.background = winFill;
    }
    p.style.padding = s.padding + 'px';
    p.style.paddingTop = (scene && !s.bg_full) ? (s.padding + Math.round((s.bg_art_h || 60) * 0.5)) + 'px' : '';   // emblem scenes push digits below the arc
    p.style.borderRadius = (rad === 999 ? 999 : rad) + 'px';
    p.style.border = (s.border_w > 0) ? (s.border_w + 'px ' + (s.border_style || 'solid') + ' ' + (s.border_color || '#E9EDF3')) : 'none';
    p.style.textShadow = s.glow ? '0 0 .35em ' + s.color : 'none';
    p.style.boxShadow = s.shadow ? '0 8px 16px rgba(0,0,0,.15)' : 'none';
    // animation type
    var an = s.anim || (s.animation ? 'pop' : 'none');
    p.style.animation = 'none';
    if (ANIMS[an]) { void p.offsetWidth; p.style.animation = ANIMS[an]; }
    // outside ghost
    var wrap = C('preview-wrap'), gh = document.getElementById('cc-ghost');
    if (s.ghost && wrap) {
      if (!gh) { gh = document.createElement('span'); gh.id = 'cc-ghost'; gh.className = 'cc-ghost'; wrap.appendChild(gh); }
      gh.style.color = s.ghost_color || '#1FA463'; gh.innerHTML = ghostSvg(Math.round((s.font_size || 28) * 0.9));
    } else if (gh) { gh.remove(); }
    var _n = (parseInt(st.start_value, 10) || 0);
    var sample = (st.style.digits > 0) ? String(_n).padStart(st.style.digits, '0') : _n.toLocaleString();
    var lbl = st.label ? '<span class="lbl" style="font-family:\'Open Sans\',sans-serif;font-weight:700;letter-spacing:normal">' + escapeHtml(st.label) + '</span>' : '';
    if (s.flip) {                                   // flip-board face — each digit is a card
      p.style.background = 'transparent'; p.style.boxShadow = 'none'; p.style.paddingTop = ''; p.style.gap = '4px'; p.style.animation = 'none';
      p.innerHTML = lbl + buildFlipCards(sample, s);
    } else {
      p.style.gap = '';
      var ox = parseInt(s.offset_x, 10) || 0, oy = parseInt(s.offset_y, 10) || 0;
      var num = (ox || oy) ? '<span style="display:inline-block;transform:translate(' + ox + 'px,' + oy + 'px)">' + sample + '</span>' : sample;
      p.innerHTML = lbl + num;
      var _nc = (s.bg_scene && s.bg_scene !== 'none' && s.scene_anim) ? _NEEDLE[s.bg_scene] : null;   // sweeping needle, Animated gauge only
      if (_nc) { var fx = document.createElement('span'); fx.className = 'cc-scene-fx'; fx.innerHTML = needleSvg(_nc, true); p.appendChild(fx); }
    }
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---- premade counters (20): old-fashioned -> modern ----
  var _DIGITAL = "'DSEG7 Classic', ui-monospace, monospace";
  var _MONO = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
  var _SERIF = "Georgia, 'Times New Roman', serif";
  var _SANS = "Open Sans, sans-serif";
  function _pb(o){ return Object.assign({color:'#12172A',bg_color:'#FFFFFF',bg_image:null,font:_SANS,font_size:28,radius:8,padding:12,shape:'rounded',shadow:true,animation:true,weight:700,letter_spacing:0,glow:false,bg2:'',transparent:false,border_w:0,border_style:'solid',border_color:'#E9EDF3',ghost:false,ghost_color:'#1FA463',anim:'pop',flip:false,flip_anim:false,flip_n:10}, o); }
  var PRESETS = [
    {id:'flip', name:'Flip Board', tag:'retro', style:_pb({flip:true, flip_anim:true, flip_n:10, font:_MONO, color:'#F4F4F5', bg_color:'#1B1B1F', shadow:false, weight:800, padding:12, shape:'rounded'})},
    {id:'led-green', name:'Classic LED', tag:'retro', style:_pb({font:_DIGITAL,color:'#39FF14',bg_color:'#0B0F0A',glow:true,shape:'square',padding:14,letter_spacing:2,border_color:'#1B2118',border_w:2,shadow:false,weight:400})},
    {id:'led-amber', name:'Amber Console', tag:'retro', style:_pb({font:_DIGITAL,color:'#FFB000',bg_color:'#160F02',glow:true,shape:'square',padding:14,letter_spacing:2,border_color:'#2A1E06',border_w:2,shadow:false,weight:400})},
    {id:'vfd-cyan', name:'Blue VFD', tag:'retro', style:_pb({font:_DIGITAL,color:'#35D6FF',bg_color:'#04121A',glow:true,shape:'square',padding:14,letter_spacing:2,border_color:'#0A2634',border_w:2,shadow:false,weight:400})},
    {id:'nixie-red', name:'Ruby Tube', tag:'retro', style:_pb({font:_DIGITAL,color:'#FF3B30',bg_color:'#120404',glow:true,shape:'rounded',radius:6,padding:14,letter_spacing:2,shadow:false,weight:400})},
    {id:'odometer', name:'Odometer', tag:'retro', style:_pb({font:_MONO,color:'#FFFFFF',bg_color:'#111417',shape:'square',padding:12,letter_spacing:1,border_color:'#333A42',border_w:2,weight:800,shadow:false})},
    {id:'terminal', name:'Retro Terminal', tag:'retro', style:_pb({font:_MONO,color:'#33FF66',bg_color:'#04120A',glow:true,shape:'rounded',radius:4,padding:12,weight:700,shadow:false})},
    {id:'vintage', name:'Vintage Paper', tag:'retro', style:_pb({font:_SERIF,color:'#5A3E1B',bg_color:'#F3E9D2',border_color:'#C9B38A',border_w:2,shape:'rounded',radius:4,padding:12,weight:700,shadow:false})},
    {id:'casino', name:'Casino Gold', tag:'retro', style:_pb({font:_SERIF,color:'#FFD54A',bg_color:'#7A0C17',border_color:'#FFD54A',border_w:2,shape:'rounded',radius:6,padding:13,weight:800})},
    {id:'chalk', name:'Chalkboard', tag:'retro', style:_pb({font:_SERIF,color:'#EDEDE0',bg_color:'#26302B',shape:'rounded',radius:6,padding:13,weight:700,shadow:false})},
    {id:'arcade', name:'Arcade Score', tag:'retro', style:_pb({font:_MONO,color:'#FFE500',bg_color:'#0A0A12',shape:'square',padding:12,letter_spacing:2,glow:true,weight:800,shadow:false})},
    {id:'min-light', name:'Minimal Light', tag:'modern', style:_pb({font:_SANS,color:'#12172A',bg_color:'#FFFFFF',shape:'rounded',radius:8,padding:12,weight:700})},
    {id:'min-dark', name:'Minimal Dark', tag:'modern', style:_pb({font:_SANS,color:'#FFFFFF',bg_color:'#12172A',shape:'rounded',radius:8,padding:12,weight:700})},
    {id:'pill', name:T('ix.accent_pill'), tag:'modern', style:_pb({font:_SANS,color:'#FFFFFF',bg_color:'#1FA463',shape:'pill',padding:12,weight:800,shadow:false})},
    {id:'soft', name:'Soft Card', tag:'modern', style:_pb({font:_SANS,color:'#12172A',bg_color:'#FFFFFF',shape:'rounded',radius:14,padding:16,weight:700})},
    {id:'grad-green', name:'Green Gradient', tag:'modern', style:_pb({font:_SANS,color:'#FFFFFF',bg_color:'#25C87A',bg2:'#127A4B',shape:'pill',padding:13,weight:800,shadow:false})},
    {id:'grad-violet', name:'Violet Gradient', tag:'modern', style:_pb({font:_SANS,color:'#FFFFFF',bg_color:'#7C5CFC',bg2:'#4B2ED6',shape:'rounded',radius:10,padding:13,weight:800,shadow:false})},
    {id:'neon', name:'Neon Modern', tag:'modern', style:_pb({font:_MONO,color:'#1FA463',bg_color:'#0E1116',glow:true,shape:'rounded',radius:10,padding:13,weight:700,shadow:false})},
    {id:'glass', name:T('ix.glass'), tag:'modern', style:_pb({font:_SANS,color:'#12172A',bg_color:'#FFFFFF',border_color:'#E9EDF3',border_w:2,shape:'rounded',radius:14,padding:14,weight:700})},
    {id:'mono-chip', name:'Mono Chip', tag:'modern', style:_pb({font:_MONO,color:'#12172A',bg_color:'#F4F6F8',shape:'rounded',radius:6,padding:11,letter_spacing:1,weight:700,shadow:false})},
    {id:'bold', name:'Bold Statement', tag:'modern', style:_pb({font:_SANS,color:'#1FA463',bg_color:'#FFFFFF',shape:'rounded',radius:4,padding:10,font_size:34,weight:900,shadow:false})}
  ];
  function _miniStyle(s){
    var rad = s.shape==='square'?0:s.shape==='pill'?999:s.radius;
    var bg = s.bg2 ? 'linear-gradient(135deg,'+s.bg_color+','+s.bg2+')' : s.bg_color;
    return 'display:inline-flex;align-items:center;color:'+s.color+';background:'+bg+';font-family:'+s.font
      +';font-size:'+s.font_size+'px;font-weight:'+(s.weight||700)+';letter-spacing:'+(s.letter_spacing||0)+'px;'
      +'border-radius:'+rad+'px;padding:'+s.padding+'px;'
      +(s.shadow?'box-shadow:0 8px 16px rgba(0,0,0,.15);':'')
      +((s.border_w||0)>0?'border:'+s.border_w+'px '+(s.border_style||'solid')+' '+(s.border_color||'#E9EDF3')+';':'')
      +(s.glow?'text-shadow:0 0 .35em '+s.color+';':'');
  }
  // ---- background scenes: a decoupled BACKGROUND layer (top emblem + window). ----
  // The digit style (font/colour/size/glow) comes from Presets or the Style tab and paints ON TOP,
  // so a preset now projects onto whatever scene is active. The window = the counter's own bg, so it
  // grows with the number of digits. Gauge scenes get an animated needle overlay (Style > Animated gauge).
  function sem(inner){ return "data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 72">' + inner + '</svg>'); }
  var _EMB = {
    vintage:  sem('<path d="M40 60 A118 118 0 0 1 260 60" fill="none" stroke="#C7452F" stroke-width="4" stroke-linecap="round"/><path d="M52 62 A104 104 0 0 1 248 62" fill="none" stroke="#8A6A34" stroke-width="3" stroke-dasharray="2 13"/><circle cx="150" cy="64" r="6" fill="#3A2A14"/>'),
    muscle:   sem('<path d="M40 60 A120 120 0 0 1 260 60" fill="none" stroke="#FF7A18" stroke-width="4" stroke-linecap="round"/><path d="M56 62 A104 104 0 0 1 244 62" fill="none" stroke="#C85A10" stroke-width="3" stroke-dasharray="2 13"/><path d="M212 32 A118 118 0 0 1 252 56" fill="none" stroke="#E23B3B" stroke-width="4"/><circle cx="150" cy="64" r="6" fill="#1A1A1E"/>'),
    lcd:      sem('<rect x="8" y="8" width="284" height="56" rx="6" fill="none" stroke="#12452A" stroke-width="3"/><text x="150" y="50" text-anchor="middle" font-family="monospace" font-size="38" letter-spacing="8" fill="#0F3A22">88888</text>'),
    cluster:  sem('<g stroke="#39414C" stroke-width="1" opacity=".55"><path d="M0 22H300M0 42H300"/></g><path d="M40 60 A122 122 0 0 1 260 60" fill="none" stroke="#DCE6F2" stroke-width="4" stroke-linecap="round"/><path d="M54 62 A106 106 0 0 1 246 62" fill="none" stroke="#5A6472" stroke-width="2" stroke-dasharray="2 12"/><circle cx="150" cy="64" r="6" fill="#0C0E12"/>'),
    ev:       sem('<path d="M48 62 A116 116 0 0 1 252 62" fill="none" stroke="#22D3EE" stroke-width="9" stroke-linecap="round" opacity=".14"/><path d="M48 62 A116 116 0 0 1 252 62" fill="none" stroke="#22D3EE" stroke-width="3" stroke-linecap="round"/><path d="M62 64 A102 102 0 0 1 238 64" fill="none" stroke="#2A6473" stroke-width="2" stroke-dasharray="1 16"/>'),
    aviation: sem('<rect x="26" y="22" width="248" height="28" rx="4" fill="none" stroke="#3A434C" stroke-width="2"/><g stroke="#8A939C" stroke-width="2"><path d="M60 22V50M100 22V50M150 22V50M200 22V50M240 22V50"/></g><path d="M150 6 l-7 12 h14 z" fill="#E6EDF3"/>'),
    race:     sem('<path d="M40 60 A120 120 0 0 1 260 60" fill="none" stroke="#F2C200" stroke-width="4" stroke-linecap="round"/><path d="M210 30 A120 120 0 0 1 258 56" fill="none" stroke="#E23B3B" stroke-width="5"/><path d="M56 62 A104 104 0 0 1 244 62" fill="none" stroke="#7A6A20" stroke-width="2" stroke-dasharray="2 12"/><circle cx="150" cy="64" r="6" fill="#0A0A0C"/>'),
    arcade:   sem('<rect x="6" y="6" width="288" height="58" rx="8" fill="none" stroke="#FF3DAE" stroke-width="2"/><rect x="10" y="10" width="280" height="50" rx="6" fill="none" stroke="#38E1FF" stroke-width="1.5" opacity=".7"/><g fill="#FFE500"><rect x="20" y="16" width="6" height="6"/><rect x="28" y="16" width="6" height="6"/><rect x="268" y="16" width="6" height="6"/><rect x="276" y="16" width="6" height="6"/></g>')
  };
  var _NEEDLE = { vintage:'#C7452F', muscle:'#FF7A18', cluster:'#E23B3B', ev:'#22D3EE', race:'#FFE500' };
  function sfull(inner){ return "data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 150">' + inner + '</svg>'); }
  var _FULL = {
    synthwave: sfull('<defs><linearGradient id="sw" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2B0B4E"/><stop offset=".55" stop-color="#7A1E6E"/><stop offset="1" stop-color="#12061F"/></linearGradient><linearGradient id="su" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FFD84D"/><stop offset="1" stop-color="#FF477E"/></linearGradient></defs><rect width="320" height="150" fill="url(#sw)"/><circle cx="160" cy="58" r="34" fill="url(#su)"/><g stroke="#2B0B4E" stroke-width="3"><path d="M126 64H194"/><path d="M126 72H194"/><path d="M126 80H194"/><path d="M126 88H194"/></g><g stroke="#FF3DAE" stroke-width="1.2" opacity=".85"><path d="M0 96H320"/><path d="M-60 150 L160 96"/><path d="M20 150 L160 96"/><path d="M80 150 L160 96"/><path d="M160 150V96"/><path d="M240 150 L160 96"/><path d="M300 150 L160 96"/><path d="M380 150 L160 96"/><path d="M0 106H320"/><path d="M0 120H320"/><path d="M0 138H320"/></g>'),
    starfield: sfull('<defs><radialGradient id="sf" cx="50%" cy="38%" r="85%"><stop offset="0" stop-color="#152A5A"/><stop offset="1" stop-color="#05070F"/></radialGradient></defs><rect width="320" height="150" fill="url(#sf)"/><circle cx="232" cy="44" r="60" fill="#5B3B8C" opacity=".20"/><circle cx="78" cy="112" r="52" fill="#2A6AA0" opacity=".16"/><g fill="#FFFFFF"><circle cx="105.7" cy="26.8" r="0.6" opacity="0.44"/><circle cx="171.1" cy="56.5" r="0.6" opacity="0.95"/><circle cx="72.1" cy="17.9" r="1.2" opacity="0.44"/><circle cx="33.9" cy="64.6" r="1.4" opacity="0.47"/><circle cx="74.8" cy="92.6" r="0.6" opacity="0.75"/><circle cx="128.2" cy="140.7" r="0.6" opacity="0.73"/><circle cx="47.0" cy="63.8" r="1.4" opacity="0.47"/><circle cx="101.0" cy="118.6" r="0.8" opacity="0.46"/><circle cx="181.9" cy="31.9" r="0.6" opacity="0.73"/><circle cx="25.3" cy="14.2" r="0.8" opacity="0.70"/><circle cx="169.8" cy="113.3" r="1.2" opacity="0.75"/><circle cx="145.6" cy="47.4" r="0.8" opacity="0.82"/><circle cx="81.2" cy="85.3" r="1.4" opacity="0.70"/><circle cx="111.8" cy="67.9" r="1.4" opacity="0.99"/><circle cx="42.4" cy="63.7" r="1.0" opacity="0.49"/><circle cx="156.6" cy="11.4" r="0.6" opacity="0.86"/><circle cx="182.5" cy="126.8" r="1.0" opacity="0.60"/><circle cx="113.9" cy="74.5" r="1.2" opacity="0.44"/><circle cx="34.8" cy="43.3" r="0.6" opacity="0.44"/><circle cx="222.1" cy="95.3" r="1.2" opacity="0.57"/><circle cx="124.8" cy="98.3" r="0.6" opacity="0.96"/><circle cx="115.5" cy="90.3" r="1.2" opacity="0.44"/><circle cx="242.6" cy="23.8" r="0.8" opacity="0.64"/><circle cx="288.4" cy="74.5" r="0.8" opacity="0.67"/><circle cx="175.2" cy="127.9" r="1.2" opacity="0.92"/><circle cx="91.8" cy="63.3" r="1.0" opacity="0.81"/><circle cx="123.2" cy="37.8" r="0.6" opacity="0.51"/><circle cx="77.4" cy="38.2" r="1.2" opacity="0.90"/><circle cx="62.2" cy="44.9" r="0.8" opacity="0.65"/><circle cx="119.7" cy="84.2" r="0.8" opacity="0.81"/></g>'),
    crt: sfull('<defs><pattern id="scan" width="1" height="4" patternUnits="userSpaceOnUse"><rect width="1" height="2" fill="#0F3320" opacity=".5"/></pattern><radialGradient id="vg" cx="50%" cy="50%" r="72%"><stop offset=".5" stop-color="#0A140D" stop-opacity="0"/><stop offset="1" stop-color="#000000" stop-opacity=".72"/></radialGradient></defs><rect width="320" height="150" fill="#0A140D"/><ellipse cx="160" cy="75" rx="130" ry="56" fill="#1E7A3E" opacity=".12"/><rect width="320" height="150" fill="url(#scan)"/><rect width="320" height="150" fill="url(#vg)"/>'),
    circuit: sfull('<rect width="320" height="150" fill="#07130E"/><g stroke="#1FA463" stroke-width="1.4" fill="none" opacity=".7"><path d="M8 28H70V66H128"/><path d="M312 40H244V92H176"/><path d="M18 122H92V96"/><path d="M300 124H206V142"/><path d="M150 8V34H116"/><path d="M40 150V110H96"/></g><g fill="#35E39A"><circle cx="70" cy="66" r="3"/><circle cx="128" cy="66" r="3"/><circle cx="244" cy="92" r="3"/><circle cx="176" cy="92" r="3"/><circle cx="92" cy="96" r="3"/><circle cx="116" cy="34" r="3"/><circle cx="96" cy="110" r="3"/></g>'),
    confetti: sfull('<rect width="320" height="150" fill="#FBFBFD"/><circle cx="278" cy="69" r="3" fill="#C77DFF"/><circle cx="63" cy="113" r="3" fill="#6A8DFF"/><rect x="240" y="20" width="8" height="4" rx="1" fill="#FFD166" transform="rotate(137 244 22)"/><circle cx="244" cy="98" r="3" fill="#FF6B6B"/><rect x="190" y="116" width="8" height="4" rx="1" fill="#FF6B6B" transform="rotate(48 194 118)"/><rect x="265" y="86" width="8" height="4" rx="1" fill="#FF8C42" transform="rotate(112 269 88)"/><circle cx="181" cy="33" r="3" fill="#4ECDC4"/><circle cx="142" cy="44" r="3" fill="#C77DFF"/><circle cx="253" cy="100" r="3" fill="#FFD166"/><circle cx="158" cy="12" r="3" fill="#C77DFF"/><rect x="125" y="118" width="8" height="4" rx="1" fill="#6A8DFF" transform="rotate(4 129 120)"/><circle cx="255" cy="8" r="3" fill="#4ECDC4"/><rect x="23" y="57" width="8" height="4" rx="1" fill="#2ECC71" transform="rotate(18 27 59)"/><rect x="173" y="34" width="8" height="4" rx="1" fill="#2ECC71" transform="rotate(22 177 36)"/><circle cx="99" cy="10" r="3" fill="#6A8DFF"/><rect x="42" y="40" width="8" height="4" rx="1" fill="#FF6B6B" transform="rotate(119 46 42)"/><rect x="241" y="31" width="8" height="4" rx="1" fill="#C77DFF" transform="rotate(130 245 33)"/><rect x="64" y="103" width="8" height="4" rx="1" fill="#4ECDC4" transform="rotate(98 68 105)"/><rect x="42" y="63" width="8" height="4" rx="1" fill="#4ECDC4" transform="rotate(151 46 65)"/><rect x="97" y="123" width="8" height="4" rx="1" fill="#4ECDC4" transform="rotate(154 101 125)"/><rect x="195" y="21" width="8" height="4" rx="1" fill="#4ECDC4" transform="rotate(66 199 23)"/><rect x="11" y="87" width="8" height="4" rx="1" fill="#FF8C42" transform="rotate(18 15 89)"/><rect x="30" y="35" width="8" height="4" rx="1" fill="#2ECC71" transform="rotate(153 34 37)"/><circle cx="45" cy="84" r="3" fill="#FF8C42"/><rect x="261" y="32" width="8" height="4" rx="1" fill="#4ECDC4" transform="rotate(58 265 34)"/><rect x="247" y="40" width="8" height="4" rx="1" fill="#4ECDC4" transform="rotate(161 251 42)"/>'),
    blueprint: sfull('<defs><pattern id="bp" width="16" height="16" patternUnits="userSpaceOnUse"><path d="M16 0H0V16" fill="none" stroke="#3E74B0" stroke-width=".7" opacity=".6"/></pattern></defs><rect width="320" height="150" fill="#0E3A6B"/><rect width="320" height="150" fill="url(#bp)"/><g stroke="#7FB0E0" stroke-width="1.2" opacity=".55"><path d="M0 50H320"/><path d="M0 102H320"/><path d="M96 0V150"/><path d="M224 0V150"/></g><g stroke="#CFE3FA" stroke-width="1.5" fill="none"><path d="M10 10h16M10 10v16"/><path d="M310 140h-16M310 140v-16"/></g>')
  };
  _FULL.clock = sfull('<rect width="320" height="150" rx="16" fill="#161619"/><rect x="8" y="8" width="304" height="134" rx="12" fill="#0B0B0E"/><rect x="22" y="34" width="276" height="82" rx="8" fill="#070709"/><text x="160" y="90" text-anchor="middle" font-family="monospace" font-size="48" letter-spacing="10" fill="#2A0E0E">88888</text><circle cx="40" cy="24" r="3" fill="#FF453A"/><text x="52" y="27" font-family="monospace" font-size="9" fill="#7A2A2A">ALARM</text><text x="298" y="132" text-anchor="end" font-family="monospace" font-size="10" fill="#7A2A2A">PM</text>');
  var SCENES = [
    {id:'vintage',  name:'Vintage Speedo',  era:'classic', tag:'retro',  art:_EMB.vintage,  h:58, window:'#17110A', color:'#F3C25C', pad:30, radius:16, shape:'rounded'},
    {id:'muscle',   name:'Muscle Odometer', era:'70s',     tag:'retro',  art:_EMB.muscle,   h:58, window:'#0E0E10', color:'#FFB259', pad:30, radius:12, shape:'rounded'},
    {id:'lcd',      name:'80s Digital Dash',era:'80s',     tag:'retro',  art:_EMB.lcd,      h:64, window:'#0C2415', color:'#79F27A', pad:26, radius:10, shape:'square'},
    {id:'cluster',  name:'90s Cluster',     era:'90s',     tag:'retro',  art:_EMB.cluster,  h:58, window:'#12161C', color:'#EAF1FB', pad:30, radius:12, shape:'rounded'},
    {id:'ev',       name:'Modern EV',       era:'modern',  tag:'modern', art:_EMB.ev,       h:54, window:'#0B0F14', color:'#7FE9F5', pad:30, radius:18, shape:'rounded'},
    {id:'aviation', name:'Cockpit Gauge',   era:'other',   tag:'modern', art:_EMB.aviation, h:56, window:'#0B0D0F', color:'#E6EDF3', pad:28, radius:12, shape:'rounded'},
    {id:'race',     name:'Race Carbon',     era:'sport',   tag:'modern', art:_EMB.race,     h:58, window:'#121317', color:'#FFE500', pad:30, radius:10, shape:'rounded'},
    {id:'arcade',   name:'Arcade Score',    era:'other',   tag:'retro',  art:_EMB.arcade,   h:60, window:'#0A0A12', color:'#FFE500', pad:26, radius:10, shape:'square'},
    {id:'synthwave',name:'Synthwave',      era:'neon',    tag:'retro',  art:_FULL.synthwave, full:true, glow:true,  window:'#1A0B2E', color:'#66F0FF', pad:26, radius:14, shape:'rounded'},
    {id:'starfield',name:'Starfield',      era:'space',   tag:'modern', art:_FULL.starfield, full:true, glow:true,  window:'#070B1A', color:'#DCEBFF', pad:26, radius:14, shape:'rounded'},
    {id:'crt',      name:'CRT Terminal',   era:'retro',   tag:'retro',  art:_FULL.crt,       full:true, glow:true,  window:'#0A140D', color:'#79F27A', pad:26, radius:10, shape:'square'},
    {id:'circuit',  name:'Circuit Board',  era:'tech',    tag:'modern', art:_FULL.circuit,   full:true, glow:false, window:'#07130E', color:'#4DE1A0', pad:26, radius:12, shape:'rounded'},
    {id:'confetti', name:'Confetti',       era:'party',   tag:'modern', art:_FULL.confetti,  full:true, glow:false, window:'#FBFBFD', color:'#12172A', pad:26, radius:14, shape:'rounded'},
    {id:'blueprint',name:'Blueprint',      era:'draft',   tag:'modern', art:_FULL.blueprint, full:true, glow:false, window:'#0E3A6B', color:'#EAF3FF', pad:26, radius:10, shape:'rounded'},
    {id:'clock',    name:'Digital Clock',   era:'LED',     tag:'retro',  art:_FULL.clock,     full:true, glow:true,  font:_DIGITAL, window:'#070709', color:'#FF453A', pad:28, radius:16, shape:'rounded'}
  ];
  function needleSvg(color, anim){
    var body = anim
      ? '<g><line x1="100" y1="118" x2="100" y2="30" stroke="'+color+'" stroke-width="3.5" stroke-linecap="round"/>'
        +'<animateTransform attributeName="transform" attributeType="XML" type="rotate" values="-52 100 118;52 100 118;-52 100 118" keyTimes="0;0.5;1" dur="3.4s" calcMode="spline" keySplines="0.45 0 0.55 1;0.45 0 0.55 1" repeatCount="indefinite"/></g>'
      : '<g transform="rotate(-16 100 118)"><line x1="100" y1="118" x2="100" y2="30" stroke="'+color+'" stroke-width="3.5" stroke-linecap="round"/></g>';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" preserveAspectRatio="xMidYMax meet" style="overflow:visible">'
      + body + '<circle cx="100" cy="118" r="5.5" fill="'+color+'"/></svg>';
  }
  function _sceneMini(p){
    var rad = p.shape==='square'?0:p.shape==='pill'?999:p.radius;
    var bg = p.full ? ("url('"+p.art+"') center/cover, "+p.window)
                    : ("url('"+p.art+"') center 4px / auto 24px no-repeat, "+p.window);
    return 'display:inline-flex;align-items:center;justify-content:center;color:'+p.color+';background:'+bg
      + ';border-radius:'+rad+'px;padding:'+(p.full?'16px 14px':'20px 14px 12px')+';font-family:'+_MONO+';font-size:22px;font-weight:700'
      + (p.glow?';text-shadow:0 0 .35em '+p.color:'');
  }
  function markScene(id){ var host=C('scenes'); if(host) host.querySelectorAll('.cc-preset').forEach(function(b){ b.classList.toggle('on', b.getAttribute('data-scene')===(id||'none')); }); }
  function renderScenes(){
    var host = C('scenes'); if(!host) return;
    var noneMini='display:inline-flex;align-items:center;justify-content:center;color:#12172A;background:repeating-conic-gradient(#E9EDF3 0% 25%,#fff 0% 50%) 0/14px 14px;border-radius:8px;padding:16px 14px;font-family:'+_MONO+';font-weight:700;font-size:22px';
    var cards='<button type="button" class="cc-preset" data-scene="none"><span class="cc-preset-stage"><span class="cc-mini" style="'+noneMini+'">1,234</span></span><span class="cc-preset-name">Transparent<span class="cc-tag modern">default</span></span></button>';
    cards+=SCENES.map(function(p){
      return '<button type="button" class="cc-preset" data-scene="'+p.id+'">'
        +'<span class="cc-preset-stage"><span class="cc-mini" style="'+_sceneMini(p)+'">1,234</span></span>'
        +'<span class="cc-preset-name">'+escapeHtml(p.name)+'<span class="cc-tag '+p.tag+'">'+escapeHtml(p.era)+'</span></span>'
        +'</button>';
    }).join('');
    host.innerHTML=cards;
    host.querySelectorAll('.cc-preset').forEach(function(b){ b.addEventListener('click', function(){ applyScene(b.getAttribute('data-scene')); }); });
    markScene(st.style.bg_scene || 'none');
  }
  function applyScene(id){
    if (id==='none'){
      st.style.bg_scene='none'; st.style.bg_image=null; st.style.bg_art_h=0; st.style.bg_full=false;
      if (window.GSUI && GSUI.toast) GSUI.toast('Background cleared');
    } else {
      var p = SCENES.filter(function(x){return x.id===id;})[0]; if(!p) return;
      st.style.bg_scene=id; st.style.bg_image=p.art; st.style.bg_art_h=p.h||0; st.style.bg_full=!!p.full;
      st.style.bg_color=p.window; st.style.color=p.color;   // readable surface + digits; font/size stay
      st.style.padding=p.pad; st.style.radius=p.radius; st.style.shape=p.shape; st.style.transparent=false;
      if ('glow' in p) st.style.glow=p.glow;
      if (p.font) st.style.font=p.font;
      if (window.GSUI && GSUI.toast) GSUI.toast('Applied "'+p.name+'"');
    }
    markScene(id); fill();
  }
  // split-flap flip cards; the last flip_n digits flip in on (re)insert when flip_anim is on
  function buildFlipCards(str, s){
    var n = Math.max(1, Math.min(parseInt(s.flip_n,10)||10, 20));
    var chars = String(str).split('');
    var digitIdx = []; chars.forEach(function(ch,i){ if(ch>='0'&&ch<='9') digitIdx.push(i); });
    var start = Math.max(0, digitIdx.length - n);
    var flipSet = {}; digitIdx.slice(start).forEach(function(i,k){ flipSet[i]=k; });
    var cardBg = s.transparent ? 'transparent' : s.bg_color;
    var out = '';
    chars.forEach(function(ch,i){
      if (ch>='0'&&ch<='9') {
        var an = (s.flip_anim && (i in flipSet)) ? 'animation:gsc-flip .5s cubic-bezier(.2,.7,.2,1) both;animation-delay:'+(flipSet[i]*70)+'ms;' : '';
        out += '<span class="gsc-fd" style="background:'+cardBg+';color:'+s.color+';'+an+'">'+ch+'</span>';
      } else {
        out += '<span class="gsc-fsep">'+ch+'</span>';
      }
    });
    return out;
  }
  function renderPresets(){
    var host = C('presets'); if(!host) return;
    host.innerHTML = PRESETS.map(function(p){
      return '<button type="button" class="cc-preset" data-preset="'+p.id+'">'
        +'<span class="cc-preset-stage"><span class="cc-mini" style="'+_miniStyle(p.style)+'">1,234</span></span>'
        +'<span class="cc-preset-name">'+escapeHtml(p.name)+'<span class="cc-tag '+p.tag+'">'+p.tag+'</span></span>'
        +'</button>';
    }).join('');
    host.querySelectorAll('.cc-preset').forEach(function(b){
      b.addEventListener('click', function(){ applyPreset(b.getAttribute('data-preset')); });
    });
  }
  function applyPreset(id){
    var p = PRESETS.filter(function(x){return x.id===id;})[0]; if(!p) return;
    var keep = { bg_scene:st.style.bg_scene, bg_image:st.style.bg_image, bg_art_h:st.style.bg_art_h, bg_full:st.style.bg_full, scene_anim:st.style.scene_anim };
    st.style = Object.assign({}, st.style, p.style);
    if (keep.bg_scene && keep.bg_scene !== 'none') {   // keep the active scene; the preset paints the digits on top of it
      st.style.bg_scene=keep.bg_scene; st.style.bg_image=keep.bg_image; st.style.bg_art_h=keep.bg_art_h; st.style.bg_full=keep.bg_full; st.style.scene_anim=keep.scene_anim;
    }
    var host = C('presets'); if(host) host.querySelectorAll('.cc-preset').forEach(function(b){ b.classList.toggle('on', b.getAttribute('data-preset')===id); });
    fill();
    var bgTab = document.querySelector('.cc-tabs [data-tab="background"]');   // pick a preset -> go tune the background
    if (bgTab) bgTab.click();
    if (window.GSUI && GSUI.toast) GSUI.toast('Applied "'+p.name+'"');
  }

  // ensure the pop keyframes exist (preview reuses the public counter animation)
  (function ensureKeyframes() {
    if (document.getElementById('gsc-kf')) return;
    var s = document.createElement('style'); s.id = 'gsc-kf';
    s.textContent = '@keyframes gsc-pop{from{opacity:0;transform:scale(.96)}to{opacity:1;transform:scale(1)}}';
    document.head.appendChild(s);
  })();

  // ---- populate controls from state (after load) ----
  function fill() {
    if (C('label')) C('label').value = st.label || '';
    if (C('color')) { C('color').value = st.style.color; C('color-hex').value = st.style.color; }
    if (C('bg_color')) { C('bg_color').value = st.style.bg_color; C('bg_color-hex').value = st.style.bg_color; }
    if (C('font')) C('font').value = st.style.font;
    setStep('font_size', st.style.font_size);
    setStep('radius', st.style.radius);
    setStep('padding', st.style.padding);
    segSet('shape', st.style.shape);
    segSet('mode', st.mode);
    if (C('mode-hint')) C('mode-hint').textContent = MODE_HINT[st.mode] || '';
    if (C('start_value')) C('start_value').value = st.start_value || 0;
    if (C('offset_x')) C('offset_x').value = st.style.offset_x || 0;
    if (C('offset_y')) C('offset_y').value = st.style.offset_y || 0;
    ['shadow', 'ghost', 'transparent', 'glow', 'scene_anim', 'flip', 'flip_anim'].forEach(function (n) { if (C(n)) C(n).checked = !!st.style[n]; });
    segSet('anim', st.style.anim || 'pop');
    segSet('border_style', st.style.border_style || 'solid');
    setStep('border_w', st.style.border_w || 0);
    setStep('letter_spacing', st.style.letter_spacing || 0);
    setStep('digits', st.style.digits || 0);
    setStep('flip_n', st.style.flip_n || 10);
    if (C('bg2')) { C('bg2').value = st.style.bg2 || '#127A4B'; if (C('bg2-hex')) C('bg2-hex').value = st.style.bg2 || ''; }
    if (C('border_color')) { C('border_color').value = st.style.border_color || '#E9EDF3'; if (C('border_color-hex')) C('border_color-hex').value = st.style.border_color || '#E9EDF3'; }
    if (C('ghost_color')) { C('ghost_color').value = st.style.ghost_color || '#1FA463'; if (C('ghost_color-hex')) C('ghost_color-hex').value = st.style.ghost_color || '#1FA463'; }
    reflectBg();
    markScene(st.style.bg_scene || 'none');
    preview();
  }
  function setStep(name, val) {
    var box = C(name); if (!box) return;
    var v = box.querySelector('.val'); if (!v) return;
    var unit = (box.dataset.unit != null) ? box.dataset.unit : 'px';   // digits stepper sets data-unit=""
    v.innerHTML = val + (unit ? '<i class="u">' + unit + '</i>' : '');
  }
  function reflectBg() {
    var thumb = C('bg-thumb'), actions = C('bg-actions');
    if (st.style.bg_image) {
      if (thumb) { thumb.style.backgroundImage = "url('" + st.style.bg_image + "')"; thumb.innerHTML = ''; }
      if (actions) actions.hidden = false;
    } else {
      if (thumb) { thumb.style.backgroundImage = ''; thumb.innerHTML = thumbIcon(); }
      if (actions) actions.hidden = true;
    }
  }
  function thumbIcon() {
    return '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.6"/><path d="M21 15l-5-5L5 21"/></svg>';
  }

  // ---- tabs ----
  function initTabs() {
    var tabs = document.querySelectorAll('.cc-tabs [data-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        document.querySelectorAll('[data-panel]').forEach(function (sec) {
          sec.hidden = sec.dataset.panel !== t.dataset.tab;
        });
      });
    });
  }

  // ---- steppers ----
  function initSteppers() {
    document.querySelectorAll('.gs-step').forEach(function (box) {
      var name = box.dataset.c, min = +box.dataset.min, max = +box.dataset.max, step = +box.dataset.step || 1;
      function cur() { return st.style[name]; }
      function apply(v) {
        v = Math.max(min, Math.min(max, v));
        st.style[name] = v; setStep(name, v); preview();
      }
      box.querySelector('[data-step-dn]').addEventListener('click', function () { apply(cur() - step); });
      box.querySelector('[data-step-up]').addEventListener('click', function () { apply(cur() + step); });
    });
  }

  // ---- segmented + toggles + colors + font + label + start ----
  function initControls() {
    // shape
    bindSeg('shape', function (v) { st.style.shape = v; preview(); });
    // mode
    bindSeg('mode', function (v) { st.mode = v; if (C('mode-hint')) C('mode-hint').textContent = MODE_HINT[v] || ''; });
    // embed format
    bindSeg('embed-fmt', function (v) { embedFmt = v; renderEmbed(); });

    ['shadow', 'ghost', 'transparent', 'glow', 'scene_anim', 'flip', 'flip_anim'].forEach(function (name) {
      var b = C(name); if (!b) return;
      b.addEventListener('change', function () { st.style[name] = b.checked; preview(); });
    });

    ['offset_x', 'offset_y'].forEach(function (name) {
      var el = C(name); if (!el) return;
      el.addEventListener('input', function () { st.style[name] = parseInt(el.value, 10) || 0; preview(); });
    });

    bindSeg('anim', function (v) { st.style.anim = v; preview(); });
    bindSeg('border_style', function (v) { st.style.border_style = v; preview(); });

    bindColor('color', 'color-hex', 'color');
    bindColor('bg_color', 'bg_color-hex', 'bg_color');
    bindColor('bg2', 'bg2-hex', 'bg2');
    bindColor('border_color', 'border_color-hex', 'border_color');
    bindColor('ghost_color', 'ghost_color-hex', 'ghost_color');

    if (C('font')) C('font').addEventListener('change', function () { st.style.font = this.value; preview(); });
    if (C('label')) C('label').addEventListener('input', function () { st.label = this.value; preview(); });
    if (C('start_value')) C('start_value').addEventListener('input', function () {
      var v = Math.max(0, parseInt(this.value, 10) || 0); st.start_value = v; preview();
    });

    if (C('embed-copy')) C('embed-copy').addEventListener('click', function () {
      var out = C('embed-out'); if (!out || !embed) return;
      var txt = out.textContent;
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(flashCopied);
    });
  }
  function bindSeg(name, cb) {
    var wrap = C(name); if (!wrap) return;
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        wrap.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on'); cb(b.dataset.v);
      });
    });
  }
  function bindColor(colorName, hexName, key) {
    var col = C(colorName), hex = C(hexName); if (!col) return;
    col.addEventListener('input', function () { st.style[key] = col.value.toUpperCase(); if (hex) hex.value = st.style[key]; preview(); });
    if (hex) hex.addEventListener('input', function () {
      var v = hex.value.trim(); if (!isHex(v)) return;
      st.style[key] = v.toUpperCase(); col.value = st.style[key]; preview();
    });
  }
  function flashCopied() {
    var b = C('embed-copy'); if (!b) return; var t = b.textContent; b.textContent = T('ix.copied');
    setTimeout(function () { b.textContent = t; }, 1400);
  }

  // ---- background image: drag-drop + upload ----
  function initBg() {
    var drop = C('bg-drop'), input = C('bg-input'), rm = C('bg-remove'), err = C('bg-error');
    if (!drop) return;
    function showErr(m) { if (!err) return; err.textContent = m || ''; err.hidden = !m; }
    drop.addEventListener('click', function () { input.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === TR('js.enter') || e.key === ' ') { e.preventDefault(); input.click(); } });
    input.addEventListener('change', function () { if (input.files[0]) upload(input.files[0]); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) upload(f); });
    if (rm) rm.addEventListener('click', function (e) { e.stopPropagation(); removeBg(); });

    function upload(file) {
      showErr('');
      if (!/^image\//.test(file.type)) return showErr(T('ix.please_choose_an_image_file'));
      if (file.size > 3 * 1024 * 1024) return showErr(T('ix.image_must_be_under_3_mb'));
      if (!GS.site) return showErr(T('ix.select_a_site_first'));
      var fd = new FormData(); fd.append('bg', file); fd.append('site', GS.site);
      fetch((GS.apiBase || '') + '/counter/bg', {
        method: 'POST', credentials: 'include',
        headers: GS.csrf ? { 'X-CSRF-Token': GS.csrf } : {}, body: fd
      }).then(function (r) { return r.json().catch(function () { return null; }).then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (res.ok && res.d && res.d.url) {
            st.style.bg_image = (GS.apiBase || '') + res.d.url; st.style.bg_scene='none'; st.style.bg_art_h=0; reflectBg(); preview();
          } else {
            var e = res.d && res.d.error;
            showErr(e === 'too_large' ? 'Image must be under 3 MB.' : e === 'bad_type' ? 'Unsupported image type.' : T('ix.upload_failed'));
          }
        }).catch(function () { showErr(T('ix.upload_failed')); });
    }
    function removeBg() {
      var url = st.style.bg_image; st.style.bg_image = null; st.style.bg_scene='none'; st.style.bg_art_h=0; reflectBg(); preview();
      if (url && GS.site && /\/uploads\/counters\//.test(url)) {
        var rel = url.replace(GS.apiBase || '', '');
        GS.api('/counter/bg?site=' + encodeURIComponent(GS.site) + '&url=' + encodeURIComponent(rel), { method: 'DELETE' });
      }
    }
  }

  // ---- load existing config ----
  function load() {
    if (!GS.site) return;
    if (!document.querySelector('[data-c]')) return;   // only run on the counter customizer page
    GS.api('/counter/config?site=' + encodeURIComponent(GS.site) + '&slug=' + SLUG).then(function (r) {
      if (r.ok && r.data && r.data.slug) {
        st.label = r.data.label || '';
        st.mode = r.data.mode || 'hits';
        st.start_value = +r.data.start_value || 0;
        st.style = Object.assign({}, st.style, r.data.style || {});
        paintEnable(r.data);       // reflect the stored on/off, not an assumed default
        loadEmbed();               // counter exists → we can show embed
      } else {
        embed = null; renderEmbed();
      }
      fill();
    });
  }
  function loadEmbed() {
    GS.api('/counter/embed?site=' + encodeURIComponent(GS.site) + '&slug=' + SLUG).then(function (r) {
      if (r.ok && r.data && r.data.embed) { embed = r.data.embed; renderEmbed(); }
    });
  }
  function renderEmbed() {
    var out = C('embed-out'); if (!out) return;
    out.textContent = embed ? (embed[embedFmt] || '') : T('ix.save_the_counter_to_generate_its_embed_code');
  }

  /* ---------------------------------------------------- per-site enable + list ----
   * NOTE ON WHERE THIS LIVES: the counter customizer's logic is inlined here, in interactions.js.
   * app/js/counter.js is a second copy that NOTHING loads — I put this feature there first and it silently
   * did nothing, which is exactly how it reached you unsaved. Edit this file.
   *
   * The counters table was always per-site with its own style_json, so styles were already independent;
   * what was missing was an off switch and any view of the account.
   */
  function paintEnable(cfg) {
    var t = document.querySelector('[data-c="enabled"]');
    var nm = document.querySelector('[data-c="en-site"]');
    var note = document.querySelector('[data-c="en-note"]');
    if (nm) {
      var site = (GS.sites || []).filter(function (x) { return x.public_key === GS.site; })[0];
      nm.textContent = site ? (site.name || site.domain) : 'this site';
    }
    if (!t) return;
    var on = cfg ? !!+cfg.enabled : true;
    t.checked = on;
    if (note) note.textContent = on
      ? 'The embed renders and counts views on this site. Turning it off stops both.'
      : T('ix.off_u2014_the_embed_returns_nothing_and_no_v');
  }

  function loadCounterSites() {
    function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
    var menu   = document.querySelector('[data-c="site-menu"]');
    var toggle = document.querySelector('[data-c="site-toggle"]');
    var dd     = document.querySelector('[data-c="site-dd"]');
    var card   = document.querySelector('[data-c="sites-card"]');
    if (card) card.hidden = true;                 // the pulldown replaces the old scrolling list
    if (!menu) return;
    GS.api('/counter/sites?slug=' + encodeURIComponent(SLUG)).then(function (r) {
      var list = (r && r.ok && r.data && r.data.sites) || [];
      var multi = list.length >= 2;               // one site is not a list worth a menu
      if (toggle) toggle.disabled = !multi;
      if (dd) dd.classList.toggle('has-menu', multi);
      if (!multi) { menu.innerHTML = ''; return; }
      menu.innerHTML = list.map(function (x) {
        var state = x.configured
          ? (x.enabled ? '<span class="cc-st on">On</span>' : '<span class="cc-st off">Off</span>')
          : '<span class="cc-st none">' + T('ix.not_set_up') + '</span>';
        var styled = x.styled ? '<span class="cc-st styled">' + T('ix.styled') + '</span>' : '';
        var cur = x.public_key === GS.site ? ' is-cur' : '';
        return '<li><button type="button" class="dropdown-item cc-srow' + cur + '" data-key="' + esc(x.public_key) + '">' +
          '<span class="cc-sn">' + esc(x.name || x.domain) + '<i>' + esc(x.domain) + '</i></span>' +
          state + styled + '</button></li>';
      }).join('');
      menu.querySelectorAll('.cc-srow').forEach(function (row) {
        row.addEventListener('click', function () {
          var k = row.getAttribute('data-key');
          if (!k || k === GS.site) return;
          try { localStorage.setItem('gs_site', k); } catch (e) {}
          location.search = '?site=' + encodeURIComponent(k);
        });
      });
    });
  }

  /* Saves on the spot. A toggle that silently needs a separate Save press is how people come away
     believing they turned something off when they did not. */
  function initEnable() {
    var t = document.querySelector('[data-c="enabled"]');
    if (!t || t._w) return;
    t._w = 1;
    t.addEventListener('change', function () {
      if (!GS.site) { t.checked = !t.checked; GSUI.toast(T('ix.select_a_site_first'), 'error'); return; }
      var want = t.checked;
      t.disabled = true;
      GS.api('/counter/config', {
        method: 'POST',
        body: JSON.stringify({ site: GS.site, slug: SLUG, enabled: want ? 1 : 0 })
      }).then(function (r) {
        t.disabled = false;
        if (r && r.ok && r.data && r.data.ok) {
          paintEnable(r.data.counter || { enabled: want ? 1 : 0 });
          GSUI.toast(want ? 'Counter enabled for this site' : T('ix.counter_disabled_for_this_site'));
          loadCounterSites();
        } else {
          t.checked = !want;                  /* the server refused: show the truth, not the intent */
          GSUI.toast(T('ix.could_not_change_that'), 'error');
        }
      }).catch(function () { t.disabled = false; t.checked = !want; GSUI.toast(T('ix.could_not_change_that'), 'error'); });
    });
  }

  // ---- save ----
  function initSave() {
    var b = C('save'); if (!b) return;
    b.addEventListener('click', function () {
      if (!GS.site) { GSUI.toast(T('ix.select_a_site_first'), 'error'); return; }
      b.disabled = true;
      GS.api('/counter/config', {
        method: 'POST',
        body: JSON.stringify({ site: GS.site, slug: SLUG, label: st.label, mode: st.mode,
          start_value: st.start_value, style: st.style,
          enabled: (function () { var t = document.querySelector('[data-c="enabled"]'); return t ? (t.checked ? 1 : 0) : 1; })() })
      }).then(function (r) {
        b.disabled = false;
        if (r.ok && r.data && r.data.ok) {
          var saved = C('saved'); if (saved) { saved.hidden = false; setTimeout(function () { saved.hidden = true; }, 2000); }
          GSUI.toast(T('ix.counter_saved'));
          loadEmbed();
        } else {
          GSUI.toast((r.data && r.data.error) ? 'Save failed: ' + r.data.error : T('ix.save_failed'), 'error');
        }
      }).catch(function () { b.disabled = false; GSUI.toast(T('ix.save_failed'), 'error'); });
    });
  }

  // ---- boot ----
  document.addEventListener('DOMContentLoaded', function () {
    if (!C('preview')) return;               // only on the customizer page
    initTabs(); initSteppers(); initControls(); initBg(); initSave(); initEnable(); renderPresets(); renderScenes();
    loadCounterSites();
    fill();                                   // render defaults immediately
  });
  // once the site selector is ready / changes, pull that site's saved counter
  document.addEventListener('gs:ready', load);
  document.addEventListener('gs:site-change', load);
})();

/* ===== plugins ===== */
// plugins catalog — categorized cards/table, layout switcher (saved to DB), enable + dashboard toggles,
// free-quota badges, dependency-aware disable. Runs only on the /plugins page (host present).
(function(){
  "use strict";
  var CATS=[["visitors",T('ix.visitors')],["acquisition",T('ix.acquisition')],["behaviour",T('ix.behaviour')],["intelligence",T('ix.intelligence')],["experience",T('ix.experience')],["seo","SEO"],["conversions",T('ix.conversions')],["tools",T('ix.tools')],["other",T('ix.more')]];
  var GRID={grid4:"col-6 col-md-4 col-xl-3",grid5:"col-6 col-md-4 col-xl gs-w5",grid6:"col-6 col-md-3 col-xl-2 gs-w6"};
  var state={items:[],layout:"grid5"};
  function esc(x){return String(x==null?"":x).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}
  function host(){return document.querySelector('[data-gs="plugin-catalog"]');}
  function curSite(){return (GS.sites||[]).filter(function(s){return s.public_key===GS.site;})[0]||(GS.sites||[])[0]||null;}
  function siteId(){var s=curSite();return s?s.id:0;}
  function cdnBase(){return ((GS.apiBase)||"https://api.ghoststat.me").replace("//api.","//cdn.");}
  function iconUrl(p){return cdnBase().replace(/\/$/,"")+"/"+(p.icon_path||("plugins/"+p.slug+"/assets/icons/"+p.slug+".svg"));}
  var FB="data:image/svg+xml;utf8,"+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#1F5FD0" stroke-width="1.7"><path d="M14 7h5a1 1 0 0 1 1 1v5m-6 4H5a1 1 0 0 1-1-1V8a4 4 0 0 1 4-4"/></svg>');
  function ico(p,w){ w=w||28; var bi=p.icon_bi||'bi-puzzle';
    return p.icon_path
      ? '<img class="gs-plug-ico" data-bi="'+bi+'" src="'+esc(iconUrl(p))+'" width="'+w+'" height="'+w+'" style="width:'+w+'px;height:'+w+'px;object-fit:contain;flex:0 0 auto" alt="">'
      : '<span class="gs-plug-ico gs-plug-bi" style="width:'+w+'px;height:'+w+'px;display:inline-flex;align-items:center;justify-content:center;background:#EEF3FB;border-radius:6px"><i class="bi '+bi+'" style="font-size:'+Math.round(w*0.55)+'px;color:#1F5FD0"></i></span>';
  }
  document.addEventListener("error", function(e){ var t=e.target; if(!t||t.tagName!=="IMG"||!t.getAttribute) return;
    var bi=t.getAttribute("data-bi"); if(!bi) return;
    if(t.classList.contains("gs-nav-ico")){ var i=document.createElement("i"); i.className="bi "+bi+" gs-nav-ico"; if(t.parentNode)t.parentNode.replaceChild(i,t); }
    else if(t.classList.contains("gs-plug-ico")){ var sp=document.createElement("span"); sp.className="gs-plug-ico gs-plug-bi"; sp.style.width=(t.width||24)+"px"; sp.style.height=(t.height||24)+"px"; sp.innerHTML='<i class="bi '+bi+'"></i>'; if(t.parentNode)t.parentNode.replaceChild(sp,t); }
  }, true);
  function byslug(sl){return state.items.filter(function(x){return x.slug===sl;})[0];}
  function enable(p,on){
    if(!on&&p.dependents&&p.dependents.length){ if(!confirm('"'+p.name+'" is used by: '+p.dependents.join(", ")+'.\nDisabling it will also disable those plugins. Continue?')){render();return;} }
    var reset=!on?confirm('Also clear "'+p.name+'" stored data for your sites? (keeps your database clean)'):false;
    GS.api(on?'/plugins/enable':'/plugins/disable',{method:'POST',body:JSON.stringify({site_id:siteId(),slug:p.slug,reset:reset})}).then(function(r){
      var d=r&&r.data; if(d&&d.ok){p.enabled=on; if(!on&&d.cascade)d.cascade.forEach(function(cs){var q=byslug(cs);if(q)q.enabled=false;});} render();
    });
  }
  function widget(p,show){GS.api('/plugins/widget',{method:'POST',body:JSON.stringify({site_id:siteId(),slug:p.slug,show:show})}).then(function(){p.show_widget=show;});}
  function setLayout(l){state.layout=l; document.querySelectorAll('[data-gs="plugin-layout"] [data-layout]').forEach(function(b){b.classList.toggle("active",b.getAttribute("data-layout")===l);}); GS.api('/plugins/layout',{method:'POST',body:JSON.stringify({layout:l})}); render();}
  /* The free-plan allowance badge, resolved for this user this month. Three shapes:
       - paid account (is_free false): nothing — every plugin is unlimited for them.
       - free account, numeric quota: "used / quota" + remaining, and a warm/critical tint as it
         runs low, so /plugins is where a free member checks what they have left.
       - free account, no numeric quota (Pro-only): a plain "Pro" badge — the page itself shows the
         upgrade prompt, there is nothing to count down. */
  /* The views-remaining square shown before each plugin's title on /plugins. For a free account it's
     the headline of this page — big number = views LEFT, small "of N" = the monthly total. The colour
     grades continuously with the fraction left: full green, ~half orange, empty red (hue 0..120 with a
     slight curve so the middle reads orange, not yellow). Hovering explains it and points to credits /
     upgrade. Paid accounts get no square (they're unlimited — the plugin icon shows instead). A free
     account's Pro-only plugin (no numeric allowance) gets a small locked "Pro" square. */
  function quotaSquare(p){
    if(!p.is_free) return '';                                   // paid: unlimited — icon shows, not a square
    if(+p.free_quota<0){                                        // unlimited on the free plan (sentinel -1)
      return '<span class="gs-pq gs-pq-unl" style="color:hsl(120,72%,30%);background:hsl(120,75%,94%);border-color:hsl(120,58%,72%)" title="'+T('ix.unlimited_on_the_free_plan')+'"><b class="gs-pq-n" style="font-size:1.5rem">&infin;</b><i class="gs-pq-of">free</i></span>';
    }
    if(p.free_remaining==null){                                 // no numeric monthly allowance
      return (p.free_quota==null||+p.free_quota<=0)
        ? '<span class="gs-pq gs-pq-pro" title="'+T('ix.pro_plan_only_upgrade_to_unlock')+'"><i class="bi bi-lock-fill gs-pq-lock"></i><i class="gs-pq-of">'+TR('js.pro')+'</i></span>'
        : '';
    }
    var quota=+p.free_quota||0, rem=Math.max(0,+p.free_remaining);
    var ratio=quota>0?Math.max(0,Math.min(1,rem/quota)):0;
    var h=Math.round(120*Math.pow(ratio,1.6));                  // 0 red · ~40 orange at half · 120 green
    var st='color:hsl('+h+',72%,30%);background:hsl('+h+',75%,94%);border-color:hsl('+h+',58%,72%)';
    var tip=(rem<=0?('No free views left of '+quota+' this month'):(rem+' of '+quota+' free views left this month'))+' — buy credits or upgrade';
    return '<span class="gs-pq" style="'+st+'" title="'+tip+'"><b class="gs-pq-n">'+rem+'</b><i class="gs-pq-of">of '+quota+'</i></span>';
  }
  /* Leading visual for a catalog row/card: the views square for a metered free account, otherwise the
     plugin's own icon (paid accounts, and unlimited plugins). */
  function lead(p,size){ return quotaSquare(p)||ico(p,size); }
  /* ---- per-site plugin options ---------------------------------------------------------------
     Declared by each plugin's manifest and rendered here, so /plugins is the one place a site's
     plugin settings live. Saved through POST /plugins/config, which has existed all along with
     nothing calling it: four plugins shipped a frontend/settings.php that no loader ever included,
     so their options were unreachable and every new plugin had to grow its own settings page. */
  function optBtn(p){
    /* settings_mode is the server's answer to "can this panel actually be driven": 'options' when
       the manifest declares a schema /plugins renders itself, 'template' when the plugin's own
       settings.php carries the script that binds it, 'none' when neither. 34 plugins ship a
       settings.php of markup whose data- attributes appear in no JavaScript in the tree — offering
       a gear for those put a Save button on screen that could never save. No button is honest;
       a dead button is not. */
    if((!p.options||!p.options.length) && !p.has_settings) return '';
    return '<button type="button" class="btn btn-sm btn-link p-0 ms-2 gs-popt-btn" data-popt="'+esc(p.slug)+'" '
      +(p.enabled?'':'disabled ')+'title="'+(p.enabled?'Options for this site':T('ix.enable_the_plugin_first'))+'">'
      +'<i class="bi bi-sliders"></i></button>';
  }
  /* How much of the track is behind the thumb, as a percentage. A range input with an unstyled
     track reads as a lone dot floating in space — nothing says it is draggable, and nothing shows
     where the current value sits between the ends. */
  function rangeFill(min,max,v){
    min=+min; max=+max; v=+v;
    if(!isFinite(min)||!isFinite(max)||max<=min) return 0;
    return Math.max(0,Math.min(100,((v-min)/(max-min))*100));
  }

  function optVal(p,o){
    var c=p.config||{}, v=(c[o.key]===undefined||c[o.key]===null)?o.default:c[o.key];
    if(o.type==='text') return Array.isArray(v)?v.join(', '):String(v==null?'':v);
    if(o.type==='switch') return (+v)?1:0;
    return (v===''||v==null)?o.default:v;
  }
  function optField(p,o){
    var id='po-'+p.slug+'-'+o.key, v=optVal(p,o);
    var help=o.help?'<div class="gs-muted small mt-1">'+esc(o.help)+'</div>':'';
    if(o.type==='switch')
      return '<div class="mb-2"><div class="form-check form-switch mb-0">'
        +'<input class="form-check-input" type="checkbox" id="'+esc(id)+'" data-pofield="'+esc(o.key)+'" '+(v?'checked':'')+'>'
        +'<label class="form-check-label small" for="'+esc(id)+'">'+esc(o.label)+'</label></div>'+help+'</div>';
    if(o.type==='text')
      return '<div class="mb-2"><label class="form-label small mb-1" for="'+esc(id)+'">'+esc(o.label)+'</label>'
        +'<input class="form-control form-control-sm" type="text" id="'+esc(id)+'" data-pofield="'+esc(o.key)+'" '
        +'value="'+esc(v)+'" placeholder="'+esc(o.placeholder||'')+'">'+help+'</div>';
    if(o.type==='range')
      return '<div class="mb-2"><label class="form-label small mb-1 d-flex justify-content-between" for="'+esc(id)+'">'
        +'<span>'+esc(o.label)+'</span><b data-poout="'+esc(o.key)+'">'+esc(v)+esc(o.unit||'')+'</b></label>'
        +'<input class="form-range gs-popt-range" type="range" id="'+esc(id)+'" data-pofield="'+esc(o.key)+'" '
        +'min="'+o.min+'" max="'+o.max+'" step="'+o.step+'" value="'+esc(v)+'" '
        +'style="--pofill:'+rangeFill(o.min,o.max,v)+'%">'+help+'</div>';
    return '<div class="mb-2"><label class="form-label small mb-1" for="'+esc(id)+'">'+esc(o.label)+'</label>'
      +'<div class="input-group input-group-sm" style="max-width:220px">'
      +'<input class="form-control" type="number" id="'+esc(id)+'" data-pofield="'+esc(o.key)+'" '
      +'min="'+o.min+'" max="'+o.max+'" step="'+o.step+'" value="'+esc(v)+'">'
      +(o.unit?'<span class="input-group-text">'+esc(o.unit)+'</span>':'')+'</div>'+help+'</div>';
  }
  function optPanel(p){
    /* A plugin with no manifest options but with its own frontend/settings.php gets an empty shell;
       the template is fetched and injected the first time the panel is opened. 59 of the 64 plugins
       shipping such a file had no loader at all, so this is the only thing that reaches them. */
    if((!p.options||!p.options.length) && p.has_settings)
      return '<div class="gs-popt" data-poptpanel="'+esc(p.slug)+'" data-potpl="1" hidden>'
        +'<div class="gs-muted small">Loading settings…</div></div>';
    if(!p.options||!p.options.length) return '';
    return '<div class="gs-popt" data-poptpanel="'+esc(p.slug)+'" hidden>'
      +p.options.map(function(o){return optField(p,o);}).join('')
      +'<div class="d-flex align-items-center gap-2 mt-2">'
      +'<button type="button" class="btn btn-primary btn-sm" data-posave="'+esc(p.slug)+'">'+T('ix.save')+'</button>'
      +'<span class="gs-muted small" data-postatus="'+esc(p.slug)+'"></span></div></div>';
  }
  function optRead(slug){
    var panel=document.querySelector('[data-poptpanel="'+slug+'"]'); if(!panel) return null;
    var cfg={};
    panel.querySelectorAll('[data-pofield]').forEach(function(el){
      var k=el.getAttribute('data-pofield');
      if(el.type==='checkbox') cfg[k]=el.checked?1:0;
      else if(el.type==='number'||el.type==='range') cfg[k]=parseFloat(el.value);
      else cfg[k]=el.value;
    });
    return cfg;
  }
  /* Fetch and mount a plugin's own settings template.
     innerHTML does not execute <script>, and most of these templates carry their own inline script
     to read the form and save it — mounted without re-executing them the panel renders and does
     nothing at all. Each script is therefore recreated as a fresh element so the browser runs it. */
  function loadTpl(slug, pn){
    pn.setAttribute('data-poloaded','1');
    GS.api('/plugins/settings-html?slug='+encodeURIComponent(slug)+'&site_id='+siteId()).then(function(r){
      var d=r&&r.data;
      if(!d||!d.ok||!d.html){
        pn.innerHTML='<div class="gs-muted small">Settings could not be loaded'
          +((d&&d.error)?(' — '+esc(d.error)):'')+'.</div>';
        pn.removeAttribute('data-poloaded');
        return;
      }
      pn.innerHTML=d.html;
      pn.querySelectorAll('script').forEach(function(old){
        var n=document.createElement('script');
        for(var i=0;i<old.attributes.length;i++) n.setAttribute(old.attributes[i].name, old.attributes[i].value);
        n.textContent=old.textContent;
        old.parentNode.replaceChild(n,old);
      });
    },function(){ pn.innerHTML='<div class="gs-muted small">'+T('ix.settings_request_failed')+'</div>';
                  pn.removeAttribute('data-poloaded'); });
  }

  function optSave(slug){
    var cfg=optRead(slug); if(!cfg) return;
    var st=document.querySelector('[data-postatus="'+slug+'"]');
    if(st) st.textContent='Saving…';
    GS.api('/plugins/config',{method:'POST',body:JSON.stringify({site_id:siteId(),slug:slug,config:cfg})})
      .then(function(r){
        /* The API answers 200 with {ok:false} when a plugin is not available to this account, so a
           200 alone is not a save — check the payload or a refused save looks like a successful one. */
        var d=r&&r.data, good=d&&d.ok;
        if(st) st.textContent=good?'Saved':'Not saved — '+((d&&d.error)||'failed');
        var p=byslug(slug); if(good&&p) p.config=d.config||cfg;
        if(st) setTimeout(function(){st.textContent='';},2500);
      },function(){ if(st) st.textContent='Not saved — request failed'; });
  }

  function pName(p){ var k='plugin.'+(p.slug||''); var tr=(window.GS&&GS.t)?GS.t(k):k; return (tr&&tr!==k)?tr:(p.name||p.slug||''); }
  function pDesc(p){ var k='plugin.'+(p.slug||'')+'.desc'; var tr=(window.GS&&GS.t)?GS.t(k):k; return (tr&&tr!==k)?tr:(p.description||''); }
  function card(p){
    var uo=p.user_enable_only?'<span class="badge bg-warning-subtle text-warning-emphasis ms-1" title="'+T('ix.off_by_default')+'">opt-in</span>':'';
    var open=p.has_page&&p.enabled;
    var head=lead(p,28)
      +'<div class="flex-grow-1" style="min-width:0"><h2 class="h6 mb-0 text-truncate">'+esc(pName(p))+uo
      +(open?' <i class="bi bi-box-arrow-up-right gs-plug-open"></i>':'')
      +'</h2><div class="gs-muted small">v'+esc(p.version)+'</div></div>';
    var headWrap=open
      ? '<a class="d-flex align-items-start gap-2 mb-2 text-reset text-decoration-none gs-plug-link" href="/'+esc(p.slug)+'" title="Open '+esc(pName(p))+'">'+head+'</a>'
      : '<div class="d-flex align-items-start gap-2 mb-2">'+head+'</div>';
    return '<div class="'+GRID[state.layout]+' mb-3"><div class="gs-card h-100"><div class="gs-card-body d-flex flex-column">'
      +headWrap
      +'<p class="gs-muted small flex-grow-1 mb-2">'+esc(pDesc(p).slice(0,140))+'</p>'
      +'<div class="d-flex align-items-center justify-content-between">'
      +'<div class="form-check form-switch mb-0"><input class="form-check-input" type="checkbox" '+(p.enabled?"checked":"")+' data-pen="'+esc(p.slug)+'"><label class="form-check-label small">'+((window.GS&&GS.t)?GS.t('plugins.enabled'):T('ix.enabled'))+'</label></div>'
      +optBtn(p)
      +'</div>'+optPanel(p)+'</div></div></div>';
  }
  function table(list){
    return '<div class="gs-table-wrap gs-plugtable-wrap"><table class="gs-table gs-plugtable align-middle"><thead><tr><th></th><th>'+T('plugins.col_plugin')+'</th><th>'+T('plugins.col_version')+'</th><th>'+T('plugins.col_desc')+'</th><th class="text-center">'+T('plugins.enabled')+'</th><th class="text-center">'+T('plugins.col_options')+'</th></tr></thead><tbody>'
      +list.map(function(p){
        var open=p.has_page&&p.enabled;
        var nm=open?('<a class="text-reset gs-plug-link" href="/'+esc(p.slug)+'" title="Open '+esc(pName(p))+'">'+esc(pName(p))+' <i class="bi bi-box-arrow-up-right gs-plug-open"></i></a>'):esc(pName(p));
        var pn=optPanel(p);
        return '<tr><td>'+lead(p,22)+'</td>'
        +'<td class="fw-semibold">'+nm+(p.user_enable_only?' <span class="badge bg-warning-subtle text-warning-emphasis">opt-in</span>':'')+'</td>'
        +'<td class="gs-muted">v'+esc(p.version)+'</td><td class="gs-muted small">'+esc(pDesc(p).slice(0,90))+'</td>'
        +'<td class="text-center"><input class="form-check-input" type="checkbox" '+(p.enabled?"checked":"")+' data-pen="'+esc(p.slug)+'"></td>'
        +'<td class="text-center">'+optBtn(p)+'</td></tr>'
        /* Emit the panel row whenever there IS a panel — not only for manifest-driven ones. The old
           test was `p.options.length`, so a plugin whose settings come from its own template got a
           gear button and no panel underneath: the button was there, clicking it did nothing. */
        +(pn?'<tr class="gs-popt-row"><td colspan="6">'+pn+'</td></tr>':'');
      }).join('')+'</tbody></table></div>';
  }
  function render(){
    var h=host(); if(!h)return;
    if(!state.items.length){h.innerHTML='<div class="gs-card"><div class="gs-card-body gs-muted">'+T('ix.no_plugins_available_on_your_plan_yet')+'</div></div>';return;}
    var byCat={}; state.items.forEach(function(p){(byCat[p.category]=byCat[p.category]||[]).push(p);});
    var out=""; CATS.forEach(function(c){var list=byCat[c[0]]; if(!list||!list.length)return;
      out+='<section class="mb-4"><h2 class="h5 gs-cat-title mb-2">'+esc(c[1])+' <span class="gs-muted small">('+list.length+')</span></h2>';
      out+=(state.layout==='table')?table(list):('<div class="row g-0 gx-3">'+list.map(card).join('')+'</div>'); out+='</section>';
    }); h.innerHTML=out;
  }
  function load(){ if(!host())return;
    GS.api('/plugins'+(siteId()?('?site_id='+siteId()):'')).then(function(r){
      var d=r&&r.data; state.items=(d&&d.plugins)||[]; if(d&&d.layout)state.layout=d.layout;
      document.querySelectorAll('[data-gs="plugin-layout"] [data-layout]').forEach(function(b){b.classList.toggle('active',b.getAttribute('data-layout')===state.layout);}); render();
    });
  }
  document.addEventListener('change',function(e){var t=e.target;
    if(t&&t.matches&&t.matches('[data-pen]')){var p=byslug(t.getAttribute('data-pen'));if(p)enable(p,t.checked);}
    else if(t&&t.matches&&t.matches('[data-pwidget]')){var q=byslug(t.getAttribute('data-pwidget'));if(q)widget(q,t.checked);}
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('[data-popt]'):null;
    if(b){ e.preventDefault();
      var slug=b.getAttribute('data-popt');
      var pn=document.querySelector('[data-poptpanel="'+slug+'"]');
      if(pn){ pn.hidden=!pn.hidden; b.classList.toggle('active',!pn.hidden);
        /* In table mode the panel lives in its own <tr>. Hiding only the div leaves the row in the
           layout, and every plugin with a gear sat a few pixels taller than the rest — visible as
           uneven spacing down the table. The row carries the open state so a closed one occupies
           nothing at all. */
        var tr=pn.closest?pn.closest('tr.gs-popt-row'):null;
        if(tr){ tr.classList.toggle('open',!pn.hidden);
          // drop the divider on the plugin's own row so it and its panel read as one block
          var prev=tr.previousElementSibling;
          if(prev) prev.classList.toggle('has-open',!pn.hidden); }
        if(!pn.hidden && pn.getAttribute('data-potpl')==='1' && !pn.getAttribute('data-poloaded')) loadTpl(slug,pn); }
      return; }
    var sv=e.target.closest?e.target.closest('[data-posave]'):null;
    if(sv){ e.preventDefault(); optSave(sv.getAttribute('data-posave')); }
  });
  document.addEventListener('input',function(e){
    var el=e.target; if(!el||!el.matches||!el.matches('input[type="range"][data-pofield]')) return;
    el.style.setProperty('--pofill', rangeFill(el.min,el.max,el.value)+'%');
    var pn=el.closest('[data-poptpanel]'); if(!pn) return;
    var out=pn.querySelector('[data-poout="'+el.getAttribute('data-pofield')+'"]');
    if(out) out.textContent=el.value+(out.textContent.replace(/^[0-9.]+/,'')||'');
  });
  document.addEventListener('click',function(e){var b=e.target&&e.target.closest&&e.target.closest('[data-gs="plugin-layout"] [data-layout]');if(b)setLayout(b.getAttribute('data-layout'));});
  document.addEventListener('gs:ready', load);
})();

/* ===== settings ===== */
/* settings.js — account settings (profile, avatar, billing, invoices, address, email reports, delete) */
(function(){
  'use strict';
  var g=function(k){return GSUI.gs(k)};
  function show(el,on){ if(el) el.classList.toggle('d-none',!on) }
  function initial(s){ return (s||'?').charAt(0).toUpperCase() }
  function avUrl(p){ return p ? ((GS.apiBase||'')+p) : '' }
  function money(c,cur){ return (cur||'USD')==='USD'?('$'+((c||0)/100).toFixed(2)):(((c||0)/100).toFixed(2)+' '+cur) }
  function setAvatarEls(url,name,email){
    var ini=initial(name||email);
    // left panel + preview
    var av=g('set-av'), pv=g('avatar-prev');
    [av,pv].forEach(function(el){ if(!el)return; el.innerHTML=url?('<img src="'+url+'" alt="" style="width:100%;height:100%;border-radius:50%;object-fit:cover">'):ini; });
    show(g('avatar-remove'), !!url);
    // topbar avatar + menu (if present)
    var ta=g('avatar-initial'); if(ta) ta.innerHTML=url?('<img src="'+url+'" alt="">'):ini;
    var ma=g('menu-avatar'); if(ma) ma.innerHTML=url?('<img src="'+url+'" alt="" style="width:100%;height:100%;border-radius:50%;object-fit:cover">'):ini;
  }

  /* ---- section switching ---- */
  function initNav(){
    GSUI.qa('.gs-settings-nav a[data-sec]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault();
        GSUI.qa('.gs-settings-nav a[data-sec]').forEach(function(x){x.classList.remove('on')}); a.classList.add('on');
        GSUI.qa('.gs-settings-body section[data-panel]').forEach(function(s){ s.hidden = s.dataset.panel!==a.dataset.sec });
        if(a.dataset.sec==='invoices') loadInvoices();
        if(a.dataset.sec==='billing') loadBilling();
        if(a.dataset.sec==='address') loadAddress();
        if(a.dataset.sec==='reports') loadReports();
        if(a.dataset.sec==='tracking') loadTracking();
        if(a.dataset.sec==='counter') loadCounter();
        if(a.dataset.sec==='insights') loadInsights();
        if(a.dataset.sec==='affiliate') loadAffiliate();
      });
    });
    // open a section from the URL hash (e.g. /user-settings#billing) or ?sec=
    (function(){
      function go(){ var w=((location.hash||'').replace('#','')||new URLSearchParams(location.search).get('sec')||'').replace(/[^a-z0-9_-]/gi,''); if(!w) return; var t=document.querySelector('.gs-settings-nav a[data-sec="'+w+'"]'); if(t) t.click(); }
      go(); window.addEventListener('hashchange', go);
    })();
  }

  /* ---- profile + avatar ---- */
  function loadProfile(){
    var u=GS.user||{};
    var name=u.name||'', email=u.email||'';
    if(g('set-name')) g('set-name').textContent=name||email.split('@')[0];
    if(g('set-email')) g('set-email').textContent=email;
    if(g('profile-name')) g('profile-name').value=name;
    if(g('profile-email')) g('profile-email').value=email;
    if(g('profile-tz')) g('profile-tz').value=u.timezone||'UTC';
    if(g('profile-show-forum')) g('profile-show-forum').checked=(u.show_forum!==false);
    setAvatarEls(avUrl(u.avatar), name, email);
    if(g('del-expect')) g('del-expect').textContent = name || email;
  }
  async function uploadAvatar(file){
    var err=g('avatar-error'); show(err,false);
    if(!file || !/^image\//.test(file.type)){ err.textContent='Please choose an image file.'; show(err,true); return; }
    if(file.size>2*1024*1024){ err.textContent='Image must be under 2 MB.'; show(err,true); return; }
    var fd=new FormData(); fd.append('avatar',file);
    var res=await fetch((GS.apiBase||'')+'/me/avatar',{method:'POST',credentials:'include',headers:GS.csrf?{'X-CSRF-Token':GS.csrf}:{},body:fd});
    var data=null; try{data=await res.json()}catch(e){}
    if(res.ok && data && data.avatar){ GS.user.avatar=data.avatar; setAvatarEls(avUrl(data.avatar),GS.user.name,GS.user.email); }
    else { err.textContent = (data&&data.error==='too_large')?'Image must be under 2 MB.':(data&&data.error==='bad_type')?'Unsupported image type.':T('ix.upload_failed'); show(err,true); }
  }
  function initAvatar(){
    var drop=g('avatar-drop'), input=g('avatar-input');
    if(!drop) return;
    g('avatar-browse') && g('avatar-browse').addEventListener('click',function(e){e.stopPropagation(); input.click()});
    drop.addEventListener('click',function(){ input.click() });
    input.addEventListener('change',function(){ if(input.files[0]) uploadAvatar(input.files[0]) });
    ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.add('over')}) });
    ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.remove('over')}) });
    drop.addEventListener('drop',function(e){ var f=e.dataTransfer.files[0]; if(f) uploadAvatar(f) });
    g('avatar-remove') && g('avatar-remove').addEventListener('click',async function(e){ e.stopPropagation();
      await GS.api('/me/avatar',{method:'DELETE'}); GS.user.avatar=null; setAvatarEls('',GS.user.name,GS.user.email); });
  }
  function initProfileSave(){
    var sf=g('profile-show-forum');
    if(sf && !sf._w){ sf._w=1; sf.addEventListener('change', async function(){
      var on = sf.checked ? 1 : 0;
      var r = await GS.api('/me/show-forum',{method:'POST',body:JSON.stringify({value:on})});
      if(r && r.ok){ if(GS.user) GS.user.show_forum = !!on;
        document.querySelectorAll('[data-forum-only]').forEach(function(el){ el.classList.toggle('d-none', !on); });
        show(g('profile-ok'),true); setTimeout(function(){show(g('profile-ok'),false)},2000); }
    }); }
    var b=g('profile-save'); if(!b) return;
    b.addEventListener('click',async function(){ show(g('profile-ok'),false);
      var name=g('profile-name').value; var tz=(g('profile-tz')||{}).value||'UTC';
      var r=await GS.api('/me/profile',{method:'POST',body:JSON.stringify({name:name,timezone:tz})});
      if(r.ok){ GS.user.name=name; GS.user.timezone=tz; GS.tz=tz; loadProfile(); show(g('profile-ok'),true); if(g('menu-name'))g('menu-name').textContent=name||GS.user.email; } });
    var td=g('tz-detect'); if(td&&!td._w){ td._w=1; td.addEventListener('click',async function(){
      var tz='UTC'; try{tz=Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC'}catch(e){}
      if(g('profile-tz'))g('profile-tz').value=tz;
      var r=await GS.api('/me/profile',{method:'POST',body:JSON.stringify({name:(g('profile-name')||{}).value||'',timezone:tz})});
      if(r.ok){ if(GS.user){GS.user.timezone=tz;} GS.tz=tz; show(g('profile-ok'),true); setTimeout(function(){show(g('profile-ok'),false)},2500); } }); }
    var pb=g('pw-save'); if(pb) pb.addEventListener('click',async function(){ show(g('pw-error'),false); show(g('pw-ok'),false);
      var r=await GS.api('/me/password',{method:'POST',body:JSON.stringify({current:g('pw-current').value,new:g('pw-new').value})});
      if(r.ok){ show(g('pw-ok'),true); g('pw-current').value=''; g('pw-new').value=''; }
      else { g('pw-error').textContent=(r.data&&r.data.error==='wrong_current')?'Current password is incorrect.':(r.data&&r.data.error==='weak')?'New password must be at least 10 characters.':T('ix.could_not_update_password'); show(g('pw-error'),true); } });
  }

  /* ---- billing / invoices / address ---- */
  async function loadBilling(){
    var r=await GS.api('/me/billing'); if(!(r.ok&&r.data)) return; var d=r.data;
    if(g('bill-plan'))g('bill-plan').textContent=d.plan;
    if(g('bill-price'))g('bill-price').textContent=money(d.price_cents);
    if(g('bill-status'))g('bill-status').textContent=d.subscription?('Status: '+d.subscription.status):'';
    var ret=new URLSearchParams(location.search).get('billing');
    if(ret&&g('bill-ok')){ var ok=g('bill-ok'); ok.textContent=ret==='success'?'Your plan is now active. Thank you!':(ret==='cancel'?'Checkout canceled.':T('ix.something_went_wrong_with_checkout'));
      ok.classList.remove('d-none'); ok.classList.toggle('alert-success',ret==='success'); ok.classList.toggle('alert-warning',ret!=='success'); }
    var host=g('bill-plans'); if(!host) return;
    var plans=(d.plans||[]);
    var others=plans.filter(function(p){return p.id!==d.plan_id;});
    if(!others.length){ host.innerHTML=''; if(g('bill-note'))g('bill-note').textContent="You're on our top plan."; return; }

    function hum(n){ n=+n||0; return n>=1e6?((n/1e6).toFixed(n%1e6?1:0)+'M'):n>=1e3?((n/1e3).toFixed(n%1e3?1:0)+'k'):(''+n); }
    function feat(p){
      var f=['Up to '+p.max_sites+' site'+(p.max_sites===1?'':'s'),
             (p.max_events>0?hum(p.max_events)+' events / month':T('ix.unlimited_events')),
             (p.retention_days?p.retention_days+'-day':T('ix.unlimited'))+' data retention'];
      if(p.trial_days) f.unshift(p.trial_days+'-day free trial');
      return f;
    }
    var interval='month';
    function yearlyOf(p){ return p.price_cents_yearly || (p.price_cents?p.price_cents*10:0); }
    function priceLabel(p){ if(p.price_cents<=0) return 'Free';
      if(p.is_lifetime) return money(p.price_cents)+'<small> '+T('ix.once')+'</small>';   // lifetime: one payment, no renewal
      return (interval==='year') ? money(yearlyOf(p))+'<small>/yr</small>' : money(p.price_cents)+'<small>/mo</small>'; }
    function subPrice(p){ if(p.is_lifetime) return '<div class="up-subprice">'+T('ix.lifetime_no_renewal')+'</div>';
      if(p.price_cents<=0||interval!=='year') return '';
      return '<div class="up-subprice">'+money(Math.round(yearlyOf(p)/12))+'/mo &middot; billed yearly</div>'; }
    function savePct(){ var paid=plans.filter(function(p){return p.price_cents>0;}); if(!paid.length) return 0;
      var p=paid[0], full=p.price_cents*12; return full>0?Math.round((full-yearlyOf(p))/full*100):0; }
    function card(p){
      var current=p.id===d.plan_id;
      return '<button type="button" class="up-card'+(current?' current':'')+'" data-plan="'+p.id+'"'+(current?' disabled':'')+'>'
        +'<div class="up-card-head"><span class="up-name">'+p.name+'</span>'
        +(current?'<span class="gs-badge pos">'+T('ix.current')+'</span>':'<span class="up-tick" aria-hidden="true"></span>')+'</div>'
        +'<div class="up-price">'+priceLabel(p)+'</div>'+subPrice(p)
        +'<ul class="up-feats">'+feat(p).map(function(x){return '<li>'+x+'</li>';}).join('')+'</ul>'
        +'</button>';
    }

    host.innerHTML=
      '<div class="up-head d-flex align-items-center justify-content-between mb-2">'
      +'  <div class="fw-semibold">'+T('ix.choose_a_plan')+'</div>'
      +'  <div class="gs-seg up-interval" data-gs="up-interval">'
      +'    <button type="button" data-iv="month" class="on">'+T('ix.monthly')+'</button>'
      +'    <button type="button" data-iv="year">Yearly'+(savePct()>0?' <span class="up-save">-'+savePct()+'%</span>':'')+'</button>'
      +'  </div>'
      +'</div>'
      +'<div class="up-grid" data-gs="up-grid">'+plans.map(card).join('')+'</div>'
      +'  <div class="up-coupon"><div class="gs-muted small mb-1">'+T('ix.coupon_code')+'</div><input class="form-control" data-gs="up-coupon" placeholder="'+T('ix.enter_a_code_optional')+'"><span class="small" data-gs="up-coupon-msg"></span></div>'
      +'<div class="up-foot">'
      +'  <div class="up-pay">'
      +'    <div class="gs-muted small mb-1">'+T('ix.payment_method')+'</div>'
      +'    <div class="up-methods" data-gs="up-methods">'
      +'      <button type="button" class="up-method on" data-prov="stripe"><i class="bi bi-credit-card-2-front"></i><span><b>'+TR('js.credit_debit_card')+'</b><small>'+T('ix.secure_checkout_via_stripe')+'</small></span></button>'
      +'      <button type="button" class="up-method" data-prov="paypal"><i class="bi bi-paypal"></i><span><b>'+TR('js.paypal')+'</b><small>'+T('ix.pay_with_your_paypal_account')+'</small></span></button>'
      +'    </div>'
      +'  </div>'
      +'  <button class="btn btn-primary up-go" data-gs="up-go" disabled>'+T('ix.select_a_plan')+'</button>'
      +'</div>';

    var prov='stripe', selected=0, couponData=null;
    var go=host.querySelector('[data-gs="up-go"]');
    var couponEl=host.querySelector('[data-gs="up-coupon"]'), couponMsg=host.querySelector('[data-gs="up-coupon-msg"]');
    function discounted(cents){ if(!couponData) return cents;
      if(couponData.kind==='percent') return Math.max(0,Math.round(cents*(100-couponData.percent_off)/100));
      if(couponData.kind==='fixed')   return Math.max(0,cents-couponData.amount_off_cents); return cents; }
    /* One place for the button text: the price of the chosen interval, minus a valid coupon (card only). */
    function updateGo(){ goText(); }
    if(couponEl){ var ct; couponEl.addEventListener('input',function(){ clearTimeout(ct); ct=setTimeout(async function(){
      var code=couponEl.value.trim(); couponData=null;
      if(!code){ if(couponMsg)couponMsg.textContent=''; updateGo(); return; }
      var r=await GS.api('/coupon/validate',{method:'POST',body:JSON.stringify({code:code,context:'upgrade'})});
      if(r.ok&&r.data&&r.data.ok){ couponData=r.data.coupon;
        if(couponData.kind==='plan'&&couponData.plan){ unlock(couponData.plan, code); }   // special plan: show its card, select it
        if(couponMsg&&couponData.kind!=='plan') couponMsg.textContent=couponData.kind==='percent'?(couponData.percent_off+'% off applied'):couponData.kind==='fixed'?(money(couponData.amount_off_cents)+' off applied'):T('ix.coupon_applied');
      } else if(couponMsg){ couponMsg.textContent='That code isn\'t valid.'; }
      updateGo();
    },400); }); }
    var methods=host.querySelector('[data-gs="up-methods"]');
    var grid=host.querySelector('[data-gs="up-grid"]');
    function goText(){ if(!selected){ go.disabled=true; go.textContent='Select a plan'; return; }
      var pl=plans.filter(function(p){return p.id===selected;})[0]; if(!pl){ return; } go.disabled=false;
      var full=(interval==='year'&&!pl.is_lifetime)?yearlyOf(pl):pl.price_cents, c=discounted(full), per=pl.is_lifetime?(' '+T('ix.once')):(interval==='year'?'/yr':'/mo');
      var amt=pl.price_cents<=0?'Free':(c>0?money(c)+per:T('ix.free'))+((couponData&&c!==full)?(' (was '+money(full)+')'):'');
      go.textContent='Upgrade to '+pl.name+' · '+amt; }
    function wireCards(){ grid.querySelectorAll('.up-card:not(.current)').forEach(function(c){ c.addEventListener('click',function(){
      selected=+c.dataset.plan; grid.querySelectorAll('.up-card').forEach(function(x){x.classList.toggle('on',x===c);}); goText();
    }); }); }
    wireCards();
    /* A special-plan code (typed here, or saved at sign-up) unlocks a plan that is not on the public list:
       add its card if needed, select it, and keep the code so checkout knows it was unlocked. */
    function unlock(pl, code){
      if(!plans.some(function(p){return p.id===pl.id;})){ plans.push(pl); grid.innerHTML=plans.map(card).join(''); wireCards(); }
      selected=pl.id; grid.querySelectorAll('.up-card').forEach(function(x){ x.classList.toggle('on', +x.dataset.plan===pl.id); });
      couponData={kind:'plan', plan_id:pl.id};
      if(couponEl){ couponEl.value=code; couponEl.disabled=false; }
      if(couponMsg) couponMsg.textContent=T('ix.code_unlocks_plan',{code:code, plan:pl.name});
      goText(); }
    if(d.offer){ var op=plans.filter(function(p){return p.id===d.offer.plan_id;})[0]; if(op) unlock(op, d.offer.code); }
    host.querySelector('[data-gs="up-interval"]').addEventListener('click',function(e){ var b=e.target.closest('button[data-iv]'); if(!b)return;
      interval=b.dataset.iv; this.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});
      grid.innerHTML=plans.map(card).join(''); wireCards();
      if(selected){ var sel=grid.querySelector('.up-card[data-plan="'+selected+'"]'); if(sel) sel.classList.add('on'); } goText(); });
    methods.addEventListener('click',function(e){ var b=e.target.closest('button[data-prov]'); if(!b)return;
      prov=b.dataset.prov; methods.querySelectorAll('.up-method').forEach(function(x){x.classList.toggle('on',x===b);});
      /* A PayPal subscription has a fixed price per PayPal plan: no per-checkout discount. Say so instead of
         showing a discount the customer would not get. */
      /* A special-plan code (it unlocks a plan, no discount) works with both methods. */
      if(couponEl&&!(couponData&&couponData.kind==='plan')){ couponEl.disabled=(prov==='paypal');
        if(prov==='paypal'){ if(couponEl.value.trim()&&couponMsg) couponMsg.textContent=T('ix.coupon_card_only'); couponData=null; }
        else if(couponEl.value.trim()){ couponEl.dispatchEvent(new Event('input')); } else if(couponMsg){ couponMsg.textContent=''; } }
      goText(); });

    if(g('bill-note'))g('bill-note').textContent=(d.provider_ready&&(d.provider_ready.stripe||d.provider_ready.paypal))?'Secure checkout by Stripe or PayPal. Cancel anytime.':T('ix.test_mode_u2014_checkout_is_simulated_until_');

    go.addEventListener('click',async function(){
      if(!selected) return;
      go.disabled=true; go.textContent='Redirecting\u2026';
      var code=(couponData&&couponEl&&(prov==='stripe'||couponData.kind==='plan'))?couponEl.value.trim():'';   // a validated code; discounts only for card
      var cr=await GS.api('/me/billing/checkout',{method:'POST',body:JSON.stringify({plan_id:selected,provider:prov,interval:interval,coupon:code})});
      if(cr.ok&&cr.data&&cr.data.url){ var u=cr.data.url; location.href=(u.charAt(0)==='/'?((GS.apiBase||'')+u):u); }
      else { go.disabled=false; goText();
        var err=(cr.data&&cr.data.error)||'', m=err==='invalid_coupon'||err==='coupon_not_for_upgrade'?T('ix.coupon_not_usable')
          :err==='coupon_card_only'?T('ix.coupon_card_only'):err==='plan_not_mapped'?T('ix.plan_not_ready_for_method')
          :T('ix.couldn_t_start_checkout_please_try_again');
        if((err==='invalid_coupon'||err==='coupon_not_for_upgrade'||err==='coupon_card_only')&&couponMsg){ couponMsg.textContent=m; }
        else if(window.GSUI&&GSUI.toast){ GSUI.toast(m,'error'); } }
    });
  }
  async function loadInvoices(){ var tb=g('inv-rows'); if(!tb)return; var r=await GS.api('/me/invoices'); var inv=(r.ok&&r.data&&r.data.invoices)||[];
    tb.innerHTML = inv.length ? inv.map(function(i){ return '<tr><td>'+i.number+'</td><td>'+(i.created_at||'').slice(0,10)+'</td><td class="r">'+money(i.amount_cents,i.currency)+'</td><td><span class="gs-badge">'+i.status+'</span></td><td class="r">'+(i.pdf_url?'<a href="'+i.pdf_url+'">PDF</a>':'')+'</td></tr>' }).join('')
      : '<tr><td colspan="5" class="text-center gs-muted">'+T('ix.no_invoices_yet')+'</td></tr>'; }
  async function loadAddress(){ var r=await GS.api('/me/address'); if(!(r.ok&&r.data))return; ['company','address1','address2','city','region','postal','country','vat'].forEach(function(k){ var el=g('addr-'+k); if(el) el.value=r.data[k]||''; }); }
  function initAddressSave(){ var b=g('addr-save'); if(!b)return; b.addEventListener('click',async function(){ show(g('addr-ok'),false);
    var body={}; ['company','address1','address2','city','region','postal','country','vat'].forEach(function(k){ body[k]=(g('addr-'+k)||{}).value||'' });
    var r=await GS.api('/me/address',{method:'POST',body:JSON.stringify(body)}); if(r.ok) show(g('addr-ok'),true); }); }

  /* ---- email reports (per site or all) ---- */
  var repData={reports:[],sites:[]};
  function repState(scope){ var m={}; repData.reports.forEach(function(r){ if(+r.site_id===+scope) m[r.frequency]=+r.enabled; }); return m; }
  function paintReports(){ var scope=+(g('rep-scope')||{value:0}).value||0, st=repState(scope);
    GSUI.qa('[data-rep]').forEach(function(t){ t.checked = !!st[t.dataset.rep]; }); }
  async function loadReportSections(){
    if(!GSUI.qa('[data-repsec]').length) return;
    var r=await GS.api('/me/email-report-sections'); if(!(r.ok&&r.data&&r.data.sections)) return;
    var sec=r.data.sections;
    GSUI.qa('[data-repsec]').forEach(function(cb){
      cb.checked = !!+sec[cb.dataset.repsec];
      if(cb._w) return; cb._w=1;
      cb.addEventListener('change', async function(){
        var payload={}; GSUI.qa('[data-repsec]').forEach(function(x){ payload[x.dataset.repsec]=x.checked?1:0; });
        var st=g('rep-sections-status');
        var r2=await GS.api('/me/email-report-sections',{method:'POST',body:JSON.stringify(payload)});
        if(st){ st.textContent = r2.ok ? 'Saved.' : 'Could not save.'; setTimeout(function(){ st.textContent=''; },1500); }
      });
    });
  }
  async function loadReports(){ var sel=g('rep-scope'); if(!sel)return;
    loadReportSections();
    var bill=await GS.api('/me/billing'); var paid=bill.ok&&bill.data&&+bill.data.price_cents>0;
    if(!paid){
      GSUI.qa('[data-rep]').forEach(function(t){ t.disabled=true; t.checked=false; });
      sel.disabled=true;
      var card=sel.closest('.gs-card, section')||sel.parentElement; if(card) card.style.opacity='.6';
      var status=g('rep-status');
      if(status){ status.style.opacity='1';
        status.innerHTML='<div class="alert alert-info d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2" style="opacity:1">'
          +'<span>'+T('ix.email_reports_are_a_pro_feature_upgrade_to_g')+'</span>'
          +'<a class="btn btn-primary btn-sm" href="/user-settings#billing" onclick="var b=document.querySelector(\'[data-sec=billing]\');if(b){b.click();return false;}">'+T('ix.upgrade_account')+'</a></div>'; }
      return;
    }
    var r=await GS.api('/me/email-reports'); if(!(r.ok&&r.data))return;
    repData=r.data; sel.innerHTML='<option value="0">'+T('ix.all_sites')+'</option>'+ (repData.sites||[]).map(function(s){return '<option value="'+s.id+'">'+s.name+'</option>'}).join('');
    paintReports();
    sel.onchange=paintReports;
    GSUI.qa('[data-rep]').forEach(function(t){ if(t._w)return; t._w=1; t.addEventListener('change',async function(){
      var scope=+sel.value||0; var r2=await GS.api('/me/email-reports',{method:'POST',body:JSON.stringify({site_id:scope,frequency:t.dataset.rep,enabled:t.checked})});
      if(r2.ok){ var found=false; repData.reports.forEach(function(x){ if(+x.site_id===scope&&x.frequency===t.dataset.rep){x.enabled=t.checked?1:0;found=true;} }); if(!found) repData.reports.push({site_id:scope,frequency:t.dataset.rep,enabled:t.checked?1:0});
        if(g('rep-status')){ g('rep-status').textContent='Saved.'; setTimeout(function(){g('rep-status').textContent=''},1500); } }
    }); });
  }

  /* ---- tracking: self-exclusion IPs ---- */
  async function loadTracking(){
    var r=await GS.api('/me/tracking'); if(r.ok&&r.data&&g('trk-ips')) g('trk-ips').value=r.data.excluded_ips||'';
    var ip=await GS.api('/me/my-ip'); if(ip.ok&&ip.data&&g('trk-myip-val')) g('trk-myip-val').textContent=ip.data.ip||'—';
    var my=g('trk-myip'); if(my&&!my._w){ my._w=1; my.addEventListener('click',function(){ var v=(g('trk-myip-val').textContent||'').trim(); if(!v||v==='—')return; var ta=g('trk-ips'); var lines=(ta.value||'').split(/\s+/).filter(Boolean); if(lines.indexOf(v)<0){ lines.push(v); ta.value=lines.join('\n'); } }); }
    var s=g('trk-save'); if(s&&!s._w){ s._w=1; s.addEventListener('click',async function(){ show(g('trk-ok'),false); var r2=await GS.api('/me/tracking',{method:'POST',body:JSON.stringify({excluded_ips:g('trk-ips').value})}); if(r2.ok){ if(r2.data) g('trk-ips').value=r2.data.excluded_ips||''; show(g('trk-ok'),true); } }); }
  }

  /* ---- counter on/off + clickable ---- */
  async function saveCounter(){ var r=await GS.api('/me/tracking',{method:'POST',body:JSON.stringify({excluded_ips:(g('trk-ips')||{}).value||GS._exips||'', counter_enabled:g('cnt-enabled').checked, counter_clickable:g('cnt-clickable').checked})}); if(r.ok){ show(g('cnt-ok'),true); setTimeout(function(){show(g('cnt-ok'),false)},2500); } }
  async function loadCounter(){
    var r=await GS.api('/me/tracking'); if(!(r.ok&&r.data))return; GS._exips=r.data.excluded_ips||'';
    if(g('cnt-enabled')) g('cnt-enabled').checked=!!r.data.counter_enabled;
    if(g('cnt-clickable')) g('cnt-clickable').checked=!!r.data.counter_clickable;
    /* Free accounts: the counter and the clickable counter are always on (server rule FreeListing, sent as listing_locked). */
    var locked=!!+r.data.listing_locked;
    ['cnt-enabled','cnt-clickable'].forEach(function(k){ var el=g(k); if(!el)return; if(locked){ el.checked=true; el.disabled=true; } else el.disabled=false; });
    if(g('cnt-clickable-note')) g('cnt-clickable-note').classList.toggle('d-none',!locked);
    ['cnt-enabled','cnt-clickable'].forEach(function(k){ var el=g(k); if(el&&!el._w){ el._w=1; el.addEventListener('change',function(){ show(g('cnt-ok'),false); saveCounter(); }); } });
  }

  /* ---- insights (pro-gated) ---- */
  async function loadInsights(){
    var el=g('ins-forecast-state'); if(!el) return;
    var r=await GS.api('/me/billing'); var pro=r.ok&&r.data&&(+r.data.price_cents>0);
    el.innerHTML = pro
      ? '<span class="text-success fw-semibold"><i class="bi bi-check-circle-fill"></i> Enabled</span>'
      : '<a class="btn btn-primary btn-sm" href="/user-settings#billing" onclick="document.querySelector(\'[data-sec=billing]\').click();return false;">'+T('ix.upgrade_to_pro')+'</a>';
  }

  /* ---- affiliate ---- */
  async function loadAffiliate(){
    var r=await GS.api('/me/affiliate'); if(!(r.ok&&r.data)) return; var d=r.data;
    if(g('aff-rate'))g('aff-rate').textContent=Math.round(d.rate_bps/100)+'%';
    if(g('aff-link'))g('aff-link').value=d.link;
    if(g('aff-referrals'))g('aff-referrals').textContent=d.referrals;
    if(g('aff-available'))g('aff-available').textContent=money(d.balance_cents);
    if(g('aff-earned'))g('aff-earned').textContent=money(d.earned_cents);
    if(g('aff-paid'))g('aff-paid').textContent=money(d.paid_cents);
    if(g('aff-min'))g('aff-min').textContent=money(d.min_payout_cents);
    var rows=g('aff-rows'); if(rows){ rows.innerHTML=(d.commissions&&d.commissions.length)?d.commissions.map(function(c){
      return '<tr><td>'+c.referred+'</td><td class="text-end">'+money(c.commission_cents)+'</td><td class="text-end gs-muted small">'+(c.created_at||'').slice(0,10)+'</td></tr>';
    }).join(''):'<tr><td class="gs-muted small">'+T('ix.no_commissions_yet')+'</td></tr>'; }
  }
  function initAffiliate(){
    var cp=g('aff-copy'); if(cp) cp.addEventListener('click',function(){ var i=g('aff-link'); if(!i)return; i.select();
      if(navigator.clipboard) navigator.clipboard.writeText(i.value); else { try{document.execCommand('copy');}catch(e){} }
      cp.textContent='Copied'; setTimeout(function(){cp.textContent='Copy';},1200); });
    var pb=g('aff-payout'); if(pb) pb.addEventListener('click',async function(){ var msg=g('aff-msg'); var dest=(g('aff-dest')||{}).value||'';
      var r=await GS.api('/me/affiliate/payout',{method:'POST',body:JSON.stringify({destination:dest})});
      if(msg){ msg.classList.remove('d-none','alert-success','alert-warning');
        if(r.ok&&r.data&&r.data.ok){ msg.textContent='Payout of '+money(r.data.amount_cents)+' requested.'; msg.classList.add('alert-success'); loadAffiliate(); }
        else { var e=r.data&&r.data.error; msg.textContent=e==='below_minimum'?('You need at least '+money((r.data&&r.data.min_payout_cents)||5000)+' to withdraw.'):(e==='bad_destination'?'Enter a valid PayPal email.':T('ix.could_not_request_payout')); msg.classList.add('alert-warning'); }
      }
    });
  }

  /* ---- delete account ---- */
  function initDelete(){ var inp=g('del-confirm'), btn=g('del-btn'); if(!inp||!btn)return;
    function expect(){ return (GS.user.name||GS.user.email||'').trim().toLowerCase() }
    inp.addEventListener('input',function(){ btn.disabled = inp.value.trim().toLowerCase()!==expect(); });
    btn.addEventListener('click',async function(){ show(g('del-error'),false);
      var r=await GS.api('/me/delete',{method:'POST',body:JSON.stringify({confirm:inp.value})});
      if(r.ok){ location.href='/login'; } else { g('del-error').textContent='Confirmation did not match.'; show(g('del-error'),true); } });
  }

  function boot(){ if(!GS.user) return; loadProfile(); }
  document.addEventListener('DOMContentLoaded',function(){ initNav(); initAvatar(); initProfileSave(); initAddressSave(); initDelete(); initAffiliate();
  document.querySelectorAll('[data-goto]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); var n=document.querySelector('.gs-settings-nav a[data-sec="'+a.dataset.goto+'"]'); if(n)n.click(); }); }); });
  document.addEventListener('gs:ready', boot);
  if(window.GS&&GS.user) boot();
})();

/* ===== user-settings ===== */
// user-settings.js — email report subscription toggles
(function(){
  async function load(){
    const r=await GS.api('/me/email-subscriptions'); if(!r.ok||!r.data) return;
    ['daily','weekly','monthly'].forEach(f=>{ const c=document.querySelector('[data-sub="'+f+'"]'); if(c) c.checked=!!r.data.subscriptions[f]; });
  }
  document.addEventListener('gs:ready', load);
  document.addEventListener('DOMContentLoaded', ()=>{
    GSUI.qa('[data-sub]').forEach(c=>c.addEventListener('change', async ()=>{
      const st=GSUI.gs('sub-status'); if(st) st.textContent='Saving…';
      const r=await GS.api('/me/email-subscriptions',{method:'POST',body:JSON.stringify({frequency:c.dataset.sub,enabled:c.checked})});
      if(st) st.textContent = r.ok ? 'Saved.' : T('ix.could_not_save');
    }));
  });
})();

/* ===== user-settings: white-label report branding + extra recipients =====
   Ported from the orphaned app/js/user-settings.js. Nothing loads that file — the app router sets
   $page_script=null and footer.php only emits a page <script> when it's set — so its wl-save click
   handler was never bound and the button did nothing. Same fix as the site-settings audit block. */
(function(){
  function g(k){ return GSUI.gs(k); }
  function fill(b){
    var map={'wl-brand-name':'brand_name','wl-from-name':'from_name','wl-logo':'logo_url',
             'wl-reply-to':'reply_to','wl-footer':'footer_text','wl-recipients':'recipients'};
    Object.keys(map).forEach(function(id){ var el=g(id); if(el) el.value=(b&&b[map[id]])||''; });
    var ac=g('wl-accent'); if(ac&&b&&b.accent_hex) ac.value=b.accent_hex;
    var en=g('wl-enabled'); if(en) en.checked=b?(+b.enabled===1):true;
  }
  async function load(){
    if(!g('wl-save')) return;                       // not on the reports panel — bail
    var r=await GS.api('/me/report-branding'); if(!r||!r.ok||!r.data) return;
    fill(r.data.branding||{});
    var locked=g('wl-locked'); if(locked) GSUI.show(locked, r.data.allowed===false);
  }
  async function save(){
    var body={
      brand_name:(g('wl-brand-name')||{}).value||'', from_name:(g('wl-from-name')||{}).value||'',
      logo_url:(g('wl-logo')||{}).value||'', accent_hex:(g('wl-accent')||{}).value||'',
      reply_to:(g('wl-reply-to')||{}).value||'', footer_text:(g('wl-footer')||{}).value||'',
      recipients:(g('wl-recipients')||{}).value||'', enabled:(g('wl-enabled')||{}).checked?1:0
    };
    var ok=g('wl-saved');
    var r=await GS.api('/me/report-branding',{method:'POST',body:JSON.stringify(body)});
    if(!ok) return;
    if(r&&r.ok){ var m=T('wl.saved_ok'); ok.textContent=(m&&m!=='wl.saved_ok')?m:'Saved.';
      ok.classList.remove('alert-danger'); ok.classList.add('alert-success'); }
    else { ok.textContent=T('ix.could_not_save'); ok.classList.remove('alert-success'); ok.classList.add('alert-danger'); }
    ok.classList.remove('d-none'); setTimeout(function(){ ok.classList.add('d-none'); }, 2800);
  }
  document.addEventListener('gs:ready', load);
  document.addEventListener('DOMContentLoaded', function(){
    var sv=g('wl-save'); if(sv) sv.addEventListener('click', save);
  });
})();

/* ===== site-settings ===== */
// site-settings.js — edit a site, snippet, public toggle, delete
(function(){
  function current(){ return GS.sites.find(s=>s.public_key===GS.site) || GS.sites[0]; }
  var ssPlugins = [];   // plugin slugs the user has ticked to include in the snippet
  function buildSnippet(key){
    var flags = ssPlugins.map(function(sl){ return ' data-' + sl + '="1"'; }).join('');
    return '<script defer data-site="' + key + '" data-api="https://api.ghoststat.me" src="https://cdn.ghoststat.me/gs.js"' + flags + '></script>';
  }
  function refreshSnippet(){ var s=current(); if(s && GSUI.gs('ss-snippet')) GSUI.gs('ss-snippet').value = buildSnippet(s.public_key); }
  async function ssLoadPlugins(){
    var host = GSUI.gs('ss-plugins'); if(!host) return;
    var s = current();
    var r = await GS.api('/plugins' + (s ? '?site_id=' + s.id : '')); var items = (r.ok && r.data && r.data.plugins) || [];
    // snippet flags apply only to plugins that actually need a tracker tag
    ssPlugins = items.filter(function(p){ return p.enabled && p.needs_tracker !== false; }).map(function(p){ return p.slug; });
    host.innerHTML = items.length ? items.map(function(p){
      if (p.needs_tracker === false) {
        return '<label class="ss-plug ss-plug--info"><span>' + (p.name||p.slug) + '</span>' +
               '<span class="gs-muted small">Reads your existing traffic &mdash; no tag needed</span></label>';
      }
      return '<label class="ss-plug"><input type="checkbox" data-ssplug="' + p.slug + '"' + (p.enabled?' checked':'') + '><span>' + (p.name||p.slug) + '</span></label>';
    }).join('') : '<span class="gs-muted small">'+T('ix.no_plugins_available_on_your_plan_yet')+'</span>';
    refreshSnippet();
    GSUI.qa('[data-ssplug]').forEach(function(c){ c.addEventListener('change', async function(){
      ssPlugins = []; GSUI.qa('[data-ssplug]').forEach(function(x){ if(x.checked) ssPlugins.push(x.getAttribute('data-ssplug')); });
      refreshSnippet();
      var st = current(); if(st){
        await GS.api(c.checked ? '/plugins/enable' : '/plugins/disable', {method:'POST', body:JSON.stringify({site_id: st.id, slug: c.getAttribute('data-ssplug')})});
      }
    }); });
  }
  document.addEventListener('gs:ready', ssLoadPlugins);
  function fill(){
    const s=current(); if(!s) return;
    const nameEl=GSUI.gs('ss-name'); if(!nameEl) return;   // not on the site-settings page — bail
    nameEl.value=s.name; GSUI.gs('ss-domain').value=s.domain;
    GSUI.gs('ss-public').checked=!!(+s.public_stats);
    /* Free accounts: public stats always on, the site is listed on counter.ghoststat.me (FreeListing). */
    GSUI.gs('ss-public').disabled=!!(+s.listing_locked); if(+s.listing_locked) GSUI.gs('ss-public').checked=true;
    if(GSUI.gs('ss-public-locked')) GSUI.gs('ss-public-locked').classList.toggle('d-none',!(+s.listing_locked));
    if(GSUI.gs('ss-subdomains'))GSUI.gs('ss-subdomains').checked=!!(+s.track_subdomains); if(GSUI.gs('ss-stitch'))GSUI.gs('ss-stitch').checked=!!(+s.stitch_visitors); fillCategorySelect(GSUI.gs('ss-category'),s.category_id);
    /* The audit block was written into the standalone app/js/site-settings.js, which no page ever
       loads — footer.php only emits a <script> when $page_script is set and site-settings.php never
       sets it. The live logic is here, and it had never heard of these three controls: the toggle
       was never read, never sent, and never filled in. */
    if(GSUI.gs('ss-audit-enabled')) GSUI.gs('ss-audit-enabled').checked=!!(+s.audit_enabled);
    if(GSUI.gs('ss-audit-exclude')) GSUI.gs('ss-audit-exclude').value=s.audit_exclude||'';
    if(GSUI.gs('ss-audit-sitemaps')) GSUI.gs('ss-audit-sitemaps').value=s.audit_sitemaps||'';
    GSUI.gs('ss-snippet').value = buildSnippet(s.public_key);
  }
  document.addEventListener('gs:ready', fill);
  document.addEventListener('gs:site-change', fill);
  document.addEventListener('DOMContentLoaded', ()=>{
    const save=GSUI.gs('ss-save'); if(!save) return;
    save.addEventListener('click', async ()=>{
      const s=current(); const ok=GSUI.gs('ss-ok'); GSUI.show(ok,false);
      const r=await GS.api('/sites/update',{method:'POST',body:JSON.stringify({
        id:s.id, name:GSUI.gs('ss-name').value, domain:GSUI.gs('ss-domain').value, public_stats:GSUI.gs('ss-public').checked, track_subdomains:(GSUI.gs('ss-subdomains')||{}).checked, stitch_visitors:(GSUI.gs('ss-stitch')||{}).checked, category_id:(GSUI.gs('ss-category')||{}).value||'',
        audit_enabled:GSUI.gs('ss-audit-enabled')?GSUI.gs('ss-audit-enabled').checked:!!(+s.audit_enabled),
        audit_exclude:GSUI.gs('ss-audit-exclude')?GSUI.gs('ss-audit-exclude').value:(s.audit_exclude||''),
        audit_sitemaps:GSUI.gs('ss-audit-sitemaps')?GSUI.gs('ss-audit-sitemaps').value:(s.audit_sitemaps||'') })});
      /* The cached site object has to learn what was just saved, or the next fill() — any site
         change, any revisit — repaints the box from the stale value and it looks like the save
         was lost. */
      if(r.ok){ s.name=GSUI.gs('ss-name').value; s.domain=GSUI.gs('ss-domain').value; s.public_stats=GSUI.gs('ss-public').checked?1:0; if(GSUI.gs('ss-subdomains'))s.track_subdomains=GSUI.gs('ss-subdomains').checked?1:0; if(GSUI.gs('ss-stitch'))s.stitch_visitors=GSUI.gs('ss-stitch').checked?1:0; s.category_id=(GSUI.gs('ss-category')||{}).value||null;
        /* The server has the last word on public stats and the category (Free sites: always public, "Personal / Other" when empty). */
        if(r.data&&r.data.public_stats!==undefined){ s.public_stats=+r.data.public_stats; GSUI.gs('ss-public').checked=!!s.public_stats; }
        if(r.data&&r.data.category_id!==undefined){ s.category_id=r.data.category_id; if(GSUI.gs('ss-category')&&s.category_id) fillCategorySelect(GSUI.gs('ss-category'),s.category_id); }
        if(GSUI.gs('ss-audit-enabled')) s.audit_enabled=GSUI.gs('ss-audit-enabled').checked?1:0;
        if(GSUI.gs('ss-audit-exclude')) s.audit_exclude=GSUI.gs('ss-audit-exclude').value;
        if(GSUI.gs('ss-audit-sitemaps')) s.audit_sitemaps=GSUI.gs('ss-audit-sitemaps').value;
        GSUI.show(ok,true); }
    });
    /* "Find my pages" — read-only. Reports what a bulk audit would cover before anything is
       fetched in anger. Ported from the file that never loads. */
    const scan=GSUI.gs('ss-audit-scan'), scanOut=GSUI.gs('ss-audit-scan-out');
    if(scan&&scanOut) scan.addEventListener('click', async ()=>{
      if(!window.GS||!GS.api||!GS.site) return;
      scan.disabled=true; scanOut.textContent='Looking for a sitemap\u2026';
      try{
        const r=await GS.api('/stats/sitemap?site='+encodeURIComponent(GS.site));
        const d=(r&&r.data)?r.data:r; scan.disabled=false;
        if(!d||!d.ok){ scanOut.textContent=(d&&d.error)||'Could not read a sitemap.'; return; }
        const hosts={}; (d.urls||[]).forEach(u=>{ hosts[u.hostname]=(hosts[u.hostname]||0)+1; });
        const bits=Object.keys(hosts).map(h=>h+' ('+hosts[h]+')');
        scanOut.textContent='Found '+d.total+' page'+(d.total===1?'':'s')+' across '+bits.join(', ')
          +'. '+d.auditable+' would be audited'
          +(d.total>d.auditable ? ' \u2014 '+(d.total-d.auditable)+' excluded by your list.' : '.')
          +(d.enabled ? '' : ' Auditing is currently off.');
      }catch(e){ scan.disabled=false; scanOut.textContent='Scan failed ('+((e&&e.message)||'request failed')+').'; }
    });
    GSUI.gs('ss-delete').addEventListener('click', async ()=>{
      const s=current(); if(!confirm('Delete '+s.name+'? This removes all its data.')) return;
      const r=await GS.api('/sites/delete',{method:'POST',body:JSON.stringify({id:s.id})});
      if(r.ok) location.href='/sites';
    });
  });
})();

/* ===== site-settings: per-site data-limits override ===== */
(function(){
  var KEYS=[
    ['sample',T('ix.sampling'),T('ix.percent_of_eligible_visits_captured_for_heat')],
    ['cap',T('ix.daily_cap'),T('ix.max_heavy_capture_rows_per_day_0_unlimited')],
    ['rec_days',T('ix.recording_retention'),T('ix.days_to_keep_session_recordings')],
    ['shot_days',T('ix.screenshot_retention'),T('ix.days_to_keep_heatmap_screenshots')],
    ['storage_mb',T('ix.storage_budget_mb'),T('ix.heavy_capture_storage_ceiling_in_mb')],
    ['mode',T('ix.capture_mode'),T('ix.trigger_only_notable_sessions_full_every_sam')]
  ];
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function sid(){ var a=(GS.sites||[]); var s=a.filter(function(x){return x.public_key===GS.site;})[0]||a[0]; return s?s.id:0; }
  function host(){ return document.querySelector('[data-gs="dl-fields"]'); }

  function field(k,label,help,eff,ov){
    var ph='Plan default ('+esc(eff[k]!==undefined?eff[k]:0)+')';
    if(k==='mode'){
      var v=ov.mode||'';
      return '<div class="col-12 col-md-6"><label class="form-label small mb-1">'+esc(label)+'</label>'+
        '<select class="form-select form-select-sm" data-dl="mode">'+
          '<option value="">Plan default ('+esc(eff.mode||'trigger')+')</option>'+
          '<option value="trigger"'+(v==='trigger'?' selected':'')+'>'+T('ix.trigger')+'</option>'+
          '<option value="full"'+(v==='full'?' selected':'')+'>'+T('ix.full')+'</option>'+
        '</select><div class="gs-muted small mt-1">'+esc(help)+'</div></div>';
    }
    var val=(ov[k]!==undefined&&ov[k]!==null)?ov[k]:'';
    return '<div class="col-12 col-md-6"><label class="form-label small mb-1">'+esc(label)+'</label>'+
      '<input type="number" min="0" class="form-control form-control-sm" data-dl="'+k+'" value="'+esc(val)+'" placeholder="'+ph+'">'+
      '<div class="gs-muted small mt-1">'+esc(help)+'</div></div>';
  }
  function load(){
    var h=host(); if(!h) return;                                   // not on the site-settings page
    var s=sid(); if(!s){ h.innerHTML='<div class="col-12 gs-muted small">'+T('ix.no_site_selected')+'</div>'; return; }
    GS.api('/sites/data-limits?site_id='+s).then(function(r){
      if(!r.ok||!r.data){ h.innerHTML='<div class="col-12 gs-muted small">'+T('ix.unavailable')+'</div>'; return; }
      var eff=r.data.plan_effective||{}, ov=r.data.override||{};
      h.innerHTML=KEYS.map(function(k){ return field(k[0],k[1],k[2],eff,ov); }).join('');
    });
  }
  function collect(){
    var dl={};
    document.querySelectorAll('[data-dl]').forEach(function(el){
      var k=el.getAttribute('data-dl'), v=el.value;
      if(v===''||v===null) return;                                 // blank -> omit -> plan default
      dl[k]=(k==='mode')?v:(+v||0);
    });
    return dl;
  }
  function post(dl){
    var s=sid(); if(!s) return Promise.resolve({ok:false});
    return GS.api('/sites/data-limits',{method:'POST',body:JSON.stringify({site_id:s,data_limits:dl})});
  }
  function save(){ var ok=document.querySelector('[data-gs="dl-ok"]'); GSUI.show(ok,false);
    post(collect()).then(function(r){ if(r.ok){ GSUI.show(ok,true); setTimeout(function(){GSUI.show(ok,false);},1500); load(); } }); }
  function reset(){ if(!confirm(T('ix.reset_this_site_to_plan_defaults'))) return; post({}).then(function(){ load(); }); }

  document.addEventListener('gs:ready', function(){
    if(!host()) return;
    load();
    var sv=document.querySelector('[data-gs="dl-save"]'); if(sv&&!sv._dl){ sv._dl=1; sv.addEventListener('click',save); }
    var rs=document.querySelector('[data-gs="dl-reset"]'); if(rs&&!rs._dl){ rs._dl=1; rs.addEventListener('click',reset); }
  });
  document.addEventListener('gs:site-change', load);
})();
// global.js — global stats across all sites
(function(){
  const fmt=n=>(+n||0).toLocaleString();
  async function load(){
    const tl=await GS.api('/global/timeline');
    if(tl.ok&&tl.data){ const s=tl.data.series||tl.data.rows||[];
      const pv=s.reduce((a,x)=>a+(+x.pv||+x.pageviews||0),0);
      const vs=s.reduce((a,x)=>a+(+x.uniques||+x.visitors||0),0);
      GSUI.gs('gpv')&&(GSUI.gs('gpv').textContent=fmt(pv)); GSUI.gs('gvis')&&(GSUI.gs('gvis').textContent=fmt(vs)); }
    for(const m of ['countries','browsers','os','devices','utm']){
      const r=await GS.api('/global/'+m); const tb=GSUI.gs('g-'+m); if(!tb) continue;
      const rows=(r.ok&&r.data&&(r.data.rows||r.data[m]))||[];
      tb.innerHTML = rows.length ? rows.slice(0,10).map(x=>`<tr><td>${x.label||x.name||x.country||'—'}</td><td>${fmt(x.pageviews||x.hits||x.count)}</td></tr>`).join('')
        : '<tr><td colspan="2" class="gs-muted">'+T('ix.no_data_yet')+'</td></tr>';
      if(m==='countries'&&GSUI.gs('gcountries')) GSUI.gs('gcountries').textContent=fmt(rows.length);
    }
    try{ const pr=await GS.api('/global/plugins'); const box=GSUI.gs('global-plugins');
      if(box&&pr.ok&&pr.data&&pr.data.html) box.innerHTML=pr.data.html; }catch(e){}
  }
  document.addEventListener('gs:ready', load);
})();

/* ===== public-preview ===== */
// public-preview.js — public URL + iframe for the selected site
(function(){
  function cur(){ return GS.sites.find(s=>s.public_key===GS.site)||GS.sites[0]; }
  function fill(){
    const s=cur(); if(!s) return;
    const urlEl=GSUI.gs('pp-url'); if(!urlEl) return;   // not on the public-preview page — bail
    const url='https://app.ghoststat.me/public-stats?s='+s.public_key;
    urlEl.value=url;
    const note=GSUI.gs('pp-note'), frame=GSUI.gs('pp-frame'); if(!note||!frame) return;
    if(+s.public_stats){ note.textContent='Live.'; frame.src='/public-stats?s='+s.public_key; }
    else { note.textContent='Enable public stats in Site settings to share this page.'; frame.removeAttribute('src'); }
  }
  document.addEventListener('gs:ready', fill);
  document.addEventListener('gs:site-change', fill);
  document.addEventListener('DOMContentLoaded', ()=>{
    const c=GSUI.gs('pp-copy'); if(c) c.addEventListener('click',()=>{ navigator.clipboard&&navigator.clipboard.writeText(GSUI.gs('pp-url').value); });
  });
})();


/* ===== install tracking code ===== */
(function(){
  function snippet(key){
    return '<script defer data-site="'+key+'" data-api="https://api.ghoststat.me" src="https://cdn.ghoststat.me/gs.js"><\/script>';
  }
  function checkVerify(pending){
    var st=GSUI.gs('verify-status'); if(!st || !GS.site) return;
    if(pending){ st.className='gs-badge gray'; st.textContent='Checking\u2026'; }
    var to=new Date(), from=new Date(); from.setFullYear(to.getFullYear()-2); var f=function(d){return d.toISOString().slice(0,10);};
    GS.api('/stats/overview?site='+encodeURIComponent(GS.site)+'&from='+f(from)+'&to='+f(to)).then(function(r){
      var pv=(r.ok&&r.data)?(+r.data.pageviews||0):0;
      if(pv>0){ st.className='gs-badge'; st.textContent='\u2713 Verified \u2014 receiving data ('+GSUI.fmt(pv)+' pageviews)'; }
      else if(pending){ st.className='gs-badge warn'; st.textContent='No data yet \u2014 add the snippet & load a page'; }
    }).catch(function(){});
  }
  function render(){
    if(!GS.site) return;
    var site=(GS.sites||[]).find(function(s){return s.public_key===GS.site;})||{public_key:GS.site};
    var snip=GSUI.gs('snippet'); if(snip) snip.textContent=snippet(site.public_key);
    var key=GSUI.gs('site-key'); if(key) key.value=site.public_key;
    var nm=GSUI.gs('site-name-inline'); if(nm && site.name) nm.textContent=site.name;
    checkVerify(false);   // once a site has ever received data it stays "Verified" across reloads (server truth)
  }
  document.addEventListener('gs:ready', render);
  document.addEventListener('gs:site-change', render);
  document.addEventListener('DOMContentLoaded', function(){
    var cp=GSUI.gs('copy-snippet');
    if(cp) cp.addEventListener('click', function(){ var s=GSUI.gs('snippet');
      if(s&&navigator.clipboard){ navigator.clipboard.writeText(s.textContent); cp.textContent='Copied!'; setTimeout(function(){cp.textContent=cp.dataset.label||'Copy';},1500);} });
    var vf=GSUI.gs('verify-install');
    if(vf) vf.addEventListener('click', function(){ checkVerify(true); });
  });
})();

/* ===== account warnings (low events / upcoming renewal) + dashboard-toast prefs ===== */
(function(){
  function pref(k,def){ try{ var v=localStorage.getItem(k); return v===null?def:v==='1'; }catch(e){ return def; } }
  function setPref(k,on){ try{ localStorage.setItem(k,on?'1':'0'); }catch(e){} }

  // user-settings toast toggles <-> localStorage (dashboard reads these)
  document.addEventListener('DOMContentLoaded', function(){
    [['ins-toast','gs_show_insights'],['cnt-toast','gs_show_counter']].forEach(function(p){
      var el=GSUI.gs(p[0]); if(!el) return;
      el.checked = pref(p[1],true);
      el.addEventListener('change', function(){ setPref(p[1], el.checked); });
    });
  });

  function _ahash(s){ var h=0,i; for(i=0;i<s.length;i++){ h=((h<<5)-h+s.charCodeAt(i))|0; } return (h>>>0).toString(36); }
  var _ACOLOR={ warn:'#F59E0B' };   // ok=green / error=red / data=gray come from CSS; warn=orange added here
  function banner(type,html){
    var slot=document.getElementById('gs-announce-slot'); if(!slot) return;
    var key='gs_dismiss_'+type+'_'+_ahash(html);
    try{ if(localStorage.getItem(key)==='1') return; }catch(e){}          // stays dismissed until the message itself changes
    if(slot.querySelector('[data-warn="'+type+'"]')) return;
    var d=document.createElement('div'); d.className='gs-announce '+type; d.setAttribute('data-warn',type);
    if(_ACOLOR[type]) d.style.background=_ACOLOR[type];
    d.innerHTML='<div>'+html+'</div><button class="close" type="button" aria-label="'+T('ix.dismiss')+'">&times;</button>';
    d.querySelector('.close').addEventListener('click', function(){ try{localStorage.setItem(key,'1')}catch(e){} d.remove(); });
    slot.appendChild(d);
  }
  async function warnings(){
    if(!GS.user) return;
    var lim=await GS.api('/me/limits');
    if(lim.ok&&lim.data&&lim.data.events){ var e=lim.data.events, max=+e.max||0, used=+e.used||0;
      if(max>0 && used>=max*0.8){ var pct=Math.min(100,Math.round(used/max*100)), over=used>=max;
        banner(over?'error':'warn', over
          ? 'You have used all '+max.toLocaleString()+' events on your plan this period — new events may be paused. <a href="/user-settings">'+T('ix.upgrade')+'</a> for more.'
          : 'You have used '+pct+'% of your '+max.toLocaleString()+' monthly events. <a href="/user-settings">'+T('ix.upgrade')+'</a> to avoid interruptions.'); }
    }
    var bill=await GS.api('/me/billing');
    if(bill.ok&&bill.data&&+bill.data.price_cents>0&&bill.data.subscription&&bill.data.subscription.current_period_end){
      var end=new Date(String(bill.data.subscription.current_period_end).replace(' ','T')+'Z');
      var days=Math.ceil((end-new Date())/86400000);
      if(days>=0&&days<=5){ banner('data','Your '+(bill.data.plan||'plan')+' plan renews in '+days+' day'+(days===1?'':'s')+' ('+end.toISOString().slice(0,10)+').'); }
    }
  }
  document.addEventListener('gs:ready', warnings);
})();

/* ===== left-nav: admin gating + installed plugins ===== */
(function(){
  document.addEventListener('gs:ready', function(){
    if(!(GS.user && GS.user.role==='admin'))
      document.querySelectorAll('.gs-nav [data-admin-only]').forEach(function(a){ a.remove(); });
  });
  document.addEventListener('gs:ready', async function(){
    var host=document.querySelector('.gs-nav [data-gs="nav-plugins"]'); if(!host) return;
    host.innerHTML='';   // plugins live under their real category groups now, not under "Plugins"
    var GROUP={visitors:'nav-visitors',acquisition:'nav-acquisition',behaviour:'nav-behaviour',intelligence:'nav-intelligence',experience:'nav-experience',seo:'nav-seo',conversions:'nav-conversions',tools:'nav-tools',other:'nav-tools'};
    // Builder tools sit together under Development, whatever their marketplace category.
    var SLUG_GROUP={'software-development':'nav-development','app-insights':'nav-development'};
    function grp(cat,slug){ return SLUG_GROUP[slug]||GROUP[cat]||'nav-tools'; }
    function pluginName(p){ var k='plugin.'+(p.slug||''); var tr=(window.GS&&GS.t)?GS.t(k):k; return (tr&&tr!==k)?tr:(p.name||p.slug||'Plugin'); }
    function linkHTML(p){ var active=(location.pathname==='/'+(p.slug||''))?' active':'';
      return '<a class="gs-nav-link'+active+'" href="/'+(p.slug||'')+'"><i class="bi '+(p.icon_bi||'bi-puzzle')+'"></i><span>'+pluginName(p)+'</span></a>'; }
    function navSiteId(){ var a=(GS.sites||[]); var x=a.filter(function(s){return s.public_key===GS.site;})[0]||a[0]; return x?x.id:0; }
    try{
      var r=await GS.api('/plugins'+(navSiteId()?('?site_id='+navSiteId()):''));
      var all=((r.ok&&r.data&&r.data.plugins)||[]);
      var HIDE={'icon-library':1,'example-hello':1};                    // internal libs / demos, not user views
      var items=all.filter(function(p){return p.enabled!==false && !HIDE[p.slug];});
      if(!items.length && all.length) items=all.filter(function(p){return !HIDE[p.slug];});  // resilience: never empty

      // Built-in route takeover: when an *-intelligence plugin that supersedes a built-in report is
      // enabled for this user, route the familiar built-in nav entry to it and redirect direct hits.
      // Free / not-enabled users are untouched (the plugin isn't in `items`), so they keep the built-in.
      var TAKEOVER={referrers:'referrers-intelligence',times:'times-intelligence',segments:'segments-intelligence'};
      var onSlug={}; items.forEach(function(p){ onSlug[p.slug]=1; });
      var _bi=(location.pathname.match(/^\/([a-z-]+)\/?$/)||[])[1];
      if(_bi && TAKEOVER[_bi] && onSlug[TAKEOVER[_bi]]){ location.replace('/'+TAKEOVER[_bi]); return; }

      items.forEach(function(p){ var box=document.getElementById(grp(p.category,p.slug)); if(box) box.insertAdjacentHTML('beforeend', linkHTML(p)); });
      // Development: Install, Software Development, App Insights, then Ecosystem last
      (function(){ var d=document.getElementById('nav-development'), e=d&&d.querySelector('a[href="/ecosystem"]'); if(e) d.appendChild(e); })();

      Object.keys(TAKEOVER).forEach(function(bi){ var slug=TAKEOVER[bi]; if(!onSlug[slug]) return;
        document.querySelectorAll('.gs-nav a[href="/'+slug+'"]').forEach(function(a){ a.remove(); });                 // drop the duplicate plugin-injected link
        document.querySelectorAll('.gs-nav a[href="/'+bi+'"]').forEach(function(a){ a.setAttribute('href','/'+slug); }); // point the built-in "Referrers"/"Times" entry at the intelligence viewer
      });
      // Highlight the current page's nav link and open the group that ACTUALLY contains it. Deriving the
      // group from the link (not from the plugin's category) keeps this correct after route takeovers,
      // where a built-in entry (e.g. "Referrers" in Acquisition) is repointed at a plugin route.
      var cur=(location.pathname.match(/^\/([a-z0-9-]+)/)||[])[1];
      var lk=cur?document.querySelector('.gs-nav a[href="/'+cur+'"]'):null;
      if(lk){ lk.classList.add('active');
        var grpEl=lk.closest('.gs-nav-group'), coll=grpEl?grpEl.querySelector('.collapse'):null, gid=coll?coll.id:null;
        if(gid){
          document.querySelectorAll('.gs-nav-acc .collapse').forEach(function(c){ c.classList.toggle('show', c.id===gid); });
          document.querySelectorAll('.gs-nav-acc .gs-nav-head').forEach(function(h){ var on=h.getAttribute('data-bs-target')==='#'+gid; h.classList.toggle('active', on); h.setAttribute('aria-expanded', on?'true':'false'); });
        }
      }
      // A group is now rendered even with no static links, because it HOSTS plugins by category
      // (removing "Pages" emptied Behaviour, where 14 plugins live — skipping the group would have
      // deleted their menu home). If nothing landed in one at all, hide it rather than show a
      // header that opens onto nothing.
      ['nav-visitors','nav-acquisition','nav-behaviour','nav-intelligence','nav-experience','nav-seo','nav-conversions','nav-development','nav-tools','nav-plugins'].forEach(function(id){
        var box=document.getElementById(id); if(!box) return;
        var g=box.closest('.gs-nav-group'); if(!g) return;
        g.hidden = !box.querySelector('a');
      });
      if(window.GS_fitNav) window.GS_fitNav();
    }catch(e){}
  });
})();

/* ===== analytics report page (Matomo-style: bars/donut/table + row-hover chart popups) ===== */
(function(){
  var PAL=['#1FA463','#3B82F6','#F59E0B','#EF4444','#8B5CF6','#14B8A6','#EC4899','#0EA5E9','#84CC16','#F97316'];
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function fmt(n){ n=+n||0; return n>=1e6?(n/1e6).toFixed(1)+'M':n>=1e3?(n/1e3).toFixed(n%1e3?1:0)+'k':(''+n); }
  function g(k){ return document.querySelector('[data-gs="'+k+'"]'); }
  function segGet(){ try{ return localStorage.getItem('gs_segment')||''; }catch(e){ return ''; } }
  function segSet(v){ try{ v?localStorage.setItem('gs_segment',v):localStorage.removeItem('gs_segment'); }catch(e){} }
  function segParam(){ var s=segGet(); return s?('&segment='+encodeURIComponent(s)):''; }
  var METRIC_NOUN={pages:T('ix.page'),referrers:T('ix.referrer'),devices:T('ix.device'),browsers:T('ix.browser'),countries:T('ix.country'),utm:T('ix.campaign'),software:'OS'};

  /* An inline brand/category icon for a report row, or '' when there is nothing sensible to show.
     Scoped to the metrics where an icon is meaningful — a browser, an OS, a device, or a referrer
     host all have a recognisable mark; pages, campaigns and countries do not (countries get their
     flag elsewhere). GSIcons.svg() itself returns '' on a miss, so an unknown browser or a "Direct"
     referrer simply renders no icon and no gap. Guarded so a page without gs-icons.js loaded just
     renders text, exactly as before. */
  var ICON_METRICS={browsers:1,devices:1,software:1,referrers:1};
  function repIcon(metric,label){
    if(!ICON_METRICS[metric]) return '';
    if(typeof window==='undefined' || !window.GSIcons || !window.GSIcons.svg) return '';
    var svg=window.GSIcons.svg(label,16);
    return svg ? '<span class="gs-rep-ico" aria-hidden="true">'+svg+'</span>' : '';
  }

  function donutSVG(rows){
    var R=68,C=2*Math.PI*R,total=rows.reduce(function(a,b){return a+(+b.hits||0);},0)||1,off=0;
    var segs=rows.slice(0,8).map(function(d,idx){ var frac=(+d.hits||0)/total;
      var s='<circle class="gs-seg" data-idx="'+idx+'" r="'+R+'" cx="84" cy="84" fill="none" stroke="'+PAL[idx%PAL.length]+'" stroke-width="16" stroke-dasharray="'+(frac*C)+' '+C+'" stroke-dashoffset="'+(-off)+'" transform="rotate(-90 84 84)"/>';
      off+=frac*C; return s; }).join('');
    return '<svg viewBox="0 0 168 168" class="gs-donut-svg">'+segs+'</svg>';
  }
  function niceCeil(n){ n=+n||0; if(n<=5) return 5; var p=Math.pow(10,Math.floor(Math.log10(n))); var d=n/p; return (d<=1?1:d<=2?2:d<=5?5:10)*p; }
  function barsHTML(rows){
    if(!rows.length) return '<div class="gs-muted small p-3">'+T('ix.no_data_yet')+'</div>';
    var W=1000,H=300,padL=38,padB=30,padT=12;
    var niceMax=niceCeil(Math.max.apply(null,rows.map(function(r){return +r.hits||0;}).concat([1])));
    var plotH=H-padT-padB, plotW=W-padL-10, n=rows.length, slot=plotW/n, bw=Math.min(slot*0.62,44), steps=4, svg='';
    for(var i=0;i<=steps;i++){ var val=Math.round(niceMax*(steps-i)/steps), y=padT+plotH*i/steps;
      svg+='<line x1="'+padL+'" x2="'+(W-10)+'" y1="'+y.toFixed(1)+'" y2="'+y.toFixed(1)+'" stroke="#EDEFF4"/>';
      svg+='<text x="'+(padL-7)+'" y="'+(y+3).toFixed(1)+'" text-anchor="end" font-size="11" fill="#8C95A1">'+fmt(val)+'</text>'; }
    svg+='<line x1="'+padL+'" x2="'+padL+'" y1="'+padT+'" y2="'+(H-padB)+'" stroke="#CDD3DD"/>';
    var every=Math.max(1,Math.ceil(n/16));
    rows.forEach(function(r,i){ var v=+r.hits||0, h=v/niceMax*plotH, x=padL+slot*i+(slot-bw)/2, y=H-padB-h;
      svg+='<rect class="gs-svbar" data-i="'+i+'" x="'+x.toFixed(1)+'" y="'+y.toFixed(1)+'" width="'+bw.toFixed(1)+'" height="'+Math.max(h,0).toFixed(1)+'" rx="2" fill="#3B7DD8"><title>'+esc(r.label)+' \u2014 '+fmt(v)+' visits</title></rect>';
      if(i%every===0){ var t=String(r.label); if(t.length>10) t=t.slice(0,9)+'\u2026';
        svg+='<text x="'+(padL+slot*i+slot/2).toFixed(1)+'" y="'+(H-padB+15)+'" text-anchor="middle" font-size="10" fill="#8C95A1">'+esc(t)+'</text>'; }
    });
    return '<svg viewBox="0 0 '+W+' '+H+'" class="gs-svbars" preserveAspectRatio="xMidYMid meet" width="100%">'+svg+'</svg>';
  }
  function donutView(rows,metric){
    var R=68,C=2*Math.PI*R,total=rows.reduce(function(a,b){return a+(+b.hits||0);},0)||1,off=0;
    var segs=rows.slice(0,8).map(function(d,idx){ var frac=(+d.hits||0)/total;
      var s='<circle class="seg" data-idx="'+idx+'" r="'+R+'" cx="84" cy="84" fill="none" stroke="'+PAL[idx%PAL.length]+'" stroke-dasharray="'+(frac*C)+' '+C+'" stroke-dashoffset="'+(-off)+'"/>';
      off+=frac*C; return s; }).join('');
    var leg=rows.slice(0,8).map(function(d,idx){ return '<div class="k" data-idx="'+idx+'"><i style="background:'+PAL[idx%PAL.length]+'"></i>'+repIcon(metric,d.label)+'<span class="nm" title="'+esc(d.label)+'">'+esc(d.label)+'</span><b>'+fmt(d.hits)+'</b></div>'; }).join('');
    return '<div class="gsdonut"><div class="donutwrap"><div class="donut"><svg viewBox="0 0 168 168">'+segs+'</svg>'
      +'<div class="ctr"><b>'+fmt(total)+'</b><span>visits</span></div></div><div class="dleg">'+leg+'</div></div></div>';
  }
  function wireDonut(host){
    var segEls=host.querySelectorAll('.seg'), legEls=host.querySelectorAll('.dleg .k');
    function focus(idx){ segEls.forEach(function(s){var on=+s.dataset.idx===idx;s.style.opacity=on?1:.35;s.style.strokeWidth=on?'23':'16';});
      legEls.forEach(function(l){var on=+l.dataset.idx===idx;l.style.opacity=on?1:.4;l.style.fontWeight=on?'800':'600';l.style.transform=on?'scale(1.06)':'none';}); }
    function clr(){ segEls.forEach(function(s){s.style.opacity=1;s.style.strokeWidth='16';});
      legEls.forEach(function(l){l.style.opacity=1;l.style.fontWeight='600';l.style.transform='none';}); }
    segEls.forEach(function(s){s.addEventListener('mouseenter',function(){focus(+s.dataset.idx);});s.addEventListener('mouseleave',clr);});
    legEls.forEach(function(l){l.addEventListener('mouseenter',function(){focus(+l.dataset.idx);});l.addEventListener('mouseleave',clr);});
  }
  function lineSVG(rows){
    var W=680,H=220,p=24; var vals=rows.map(function(r){return +(r.hits||r.pageviews||r.visits||0);});
    var max=Math.max.apply(null,vals.concat([1])), n=vals.length||1;
    var pts=vals.map(function(v,i){ var x=p+(W-2*p)*(n<2?0:i/(n-1)), y=H-p-(H-2*p)*(v/max); return x+','+y; });
    var area='M'+p+','+(H-p)+' L'+pts.join(' L')+' L'+(W-p)+','+(H-p)+' Z';
    return '<svg viewBox="0 0 '+W+' '+H+'" class="gs-line" preserveAspectRatio="none" width="100%" height="220">'
      +'<path d="'+area+'" fill="var(--accent-soft,#E6F4EC)"/>'
      +'<polyline points="'+pts.join(' ')+'" fill="none" stroke="var(--accent,#1FA463)" stroke-width="2.5"/></svg>';
  }
  function tableRows(rows,total,metric){
    return rows.map(function(r,i){ var share=Math.round((+r.hits||0)/total*100);
      return '<tr data-i="'+i+'"><td class="gs-rank">'+(i+1)+'</td>'
        +'<td class="gs-rep-name">'+repIcon(metric,r.label)+'<span title="'+esc(r.label)+'">'+esc(r.label)+'</span></td>'
        +'<td class="text-end">'+fmt(r.hits)+'</td><td class="text-end">'+fmt(r.sessions)+'</td>'
        +'<td class="gs-rep-share">'+sparkMini(sparkMap[r.label])+'<b>'+share+'%</b></td></tr>'; }).join('');
  }

  function sparkMini(series){
    if(!series||!series.length) return '<span class="gs-muted">–</span>';
    var W=88,H=20,p=2, max=Math.max.apply(null,series.concat([1])), n=series.length;
    var pts=series.map(function(v,i){ var x=p+(W-2*p)*(n<2?0:i/(n-1)), y=H-p-(H-2*p)*(v/max); return x.toFixed(1)+','+y.toFixed(1); });
    return '<svg viewBox="0 0 '+W+' '+H+'" width="'+W+'" height="'+H+'" class="gs-sparkmini" preserveAspectRatio="none"><polyline points="'+pts.join(' ')+'" fill="none" stroke="#1FA463" stroke-width="1.5"/></svg>';
  }
  function sparkSVG(series){
    var vals=series.map(function(p){return +p.hits||0;}); var W=108,H=26,p=3;
    var max=Math.max.apply(null,vals.concat([1])), n=vals.length||1;
    var pts=vals.map(function(v,i){ var x=p+(W-2*p)*(n<2?0:i/(n-1)), y=H-p-(H-2*p)*(v/max); return x.toFixed(1)+','+y.toFixed(1); });
    return '<svg viewBox="0 0 '+W+' '+H+'" width="100%" height="'+H+'" preserveAspectRatio="none">'
      +'<path d="M'+p+','+(H-p)+' L'+pts.join(' L')+' L'+(W-p)+','+(H-p)+' Z" fill="var(--accent-soft,#E6F4EC)"/>'
      +'<polyline points="'+pts.join(' ')+'" fill="none" stroke="var(--accent,#1FA463)" stroke-width="1.5"/></svg>';
  }
  var evoCache={}, sparkMap={};
  function rowPopup(metric,rows,i){
    var pop=g('rowpop'); if(!pop) return; var r=rows[i]; if(!r) return;
    var total=rows.reduce(function(a,b){return a+(+b.hits||0);},0)||1, share=Math.round((+r.hits||0)/total*100);
    pop.innerHTML='<div class="gs-rowpop-h">'+esc(r.label)+'</div>'
      +'<div class="gs-rowpop-spark" data-spark><span class="gs-muted small">Loading trend…</span></div>'
      +'<div class="gs-rowpop-big"><b>'+fmt(r.hits)+'</b><span>visits</span></div>'
      +'<div class="gs-rowpop-sub">'+fmt(r.sessions)+' sessions &middot; '+share+'% share</div>';
    pop.hidden=false;
    function draw(series){ var sp=pop.querySelector('[data-spark]'); if(!sp) return;
      sp.innerHTML = (series&&series.length) ? sparkSVG(series) : '<span class="gs-muted small">'+T('ix.no_trend')+'</span>'; }
    var key=metric+'|'+r.label;
    if(evoCache[key]){ draw(evoCache[key]); return; }
    GS.api('/stats/evolution?site='+encodeURIComponent(GS.site)+'&metric='+encodeURIComponent(metric)+'&label='+encodeURIComponent(r.label)+segParam()).then(function(res){
      var series=(res.ok&&res.data&&res.data.series)||[]; evoCache[key]=series;
      var h=pop.querySelector('.gs-rowpop-h'); if(h && h.textContent===r.label) draw(series);
    }).catch(function(){});
  }
  function rowPopupOLD(rows,i){
    var pop=g('rowpop'); if(!pop) return; var r=rows[i]; if(!r) return;
    var total=rows.reduce(function(a,b){return a+(+b.hits||0);},0)||1, share=Math.round((+r.hits||0)/total*100);
    var mini=[{hits:+r.hits||0},{label:T('ix.others'),hits:Math.max(total-(+r.hits||0),0)}];
    pop.innerHTML='<div class="gs-rowpop-h">'+esc(r.label)+'</div>'
      +'<div class="gs-rowpop-b"><div class="gs-rowpop-donut">'+donutSVG(mini,86,14)+'<span class="gs-rowpop-pct">'+share+'%</span></div>'
      +'<div class="gs-rowpop-n"><div><b>'+fmt(r.hits)+'</b><span>visits</span></div><div><b>'+fmt(r.sessions)+'</b><span>sessions</span></div></div></div>';
    pop.hidden=false;
  }
  function placePop(e){ var pop=g('rowpop'); if(!pop||pop.hidden) return;
    var pad=14, w=pop.offsetWidth, h=pop.offsetHeight, x=e.clientX+pad, y=e.clientY+pad;
    if(x+w>innerWidth-8) x=e.clientX-w-pad; if(y+h>innerHeight-8) y=e.clientY-h-pad;
    pop.style.left=x+'px'; pop.style.top=y+'px'; }

  function renderSegChip(){
    var host=g('rep-seg'); if(!host) return; var s=segGet();
    if(!s || s.indexOf(':')<0){ host.innerHTML=''; return; }
    var parts=s.split(':'), noun=METRIC_NOUN[parts[0]]||parts[0];
    host.innerHTML='<span class="gs-seg-chip">Filtered: <b>'+esc(noun)+'</b> = '+esc(parts.slice(1).join(':'))
      +'<button type="button" data-seg-clear aria-label="'+T('ix.clear_filter')+'">&times;</button></span>';
    var b=host.querySelector('[data-seg-clear]'); if(b) b.addEventListener('click',function(){ segSet(''); location.reload(); });
  }
  function vflag(cc){ if(!cc||cc.length!==2) return '\uD83C\uDF10'; try{ return String.fromCodePoint(0x1F1E6+cc.toUpperCase().charCodeAt(0)-65)+String.fromCodePoint(0x1F1E6+cc.toUpperCase().charCodeAt(1)-65); }catch(e){ return '\uD83C\uDF10'; } }
  function renderFeed(visits){
    var host=g('rep-chart'); if(!host) return;
    if(!visits.length){ host.innerHTML='<div class="gs-muted small p-3">'+T('ix.no_visits_in_this_range')+'</div>'; return; }
    host.innerHTML='<div class="gs-vlog">'+visits.map(function(v){
      var tags=[v.device,v.browser,v.os].filter(Boolean).map(function(t){return '<span class="gs-vtag">'+esc(t)+'</span>';}).join('');
      return '<div class="gs-vcard">'
        +'<div class="gs-vhead"><span class="gs-vwhen">'+esc(v.time)+'</span>'+tags
          +'<span class="gs-vact">'+v.actions+' action'+(v.actions===1?'':'s')+'</span></div>'
        +'<div class="gs-vbody">'
          +'<div class="gs-vloc">'+vflag(v.country)+'<span>'+esc(v.country||'Unknown')+'</span></div>'
          +'<div class="gs-vline"><i class="bi bi-file-earmark-text"></i><span title="'+esc(v.entry)+'">'+esc(v.entry)+'</span></div>'
          +'<div class="gs-vline gs-vref"><i class="bi bi-box-arrow-in-right"></i><span title="'+esc(v.referrer)+'">'+esc(v.referrer)+'</span></div>'
        +'</div></div>';
    }).join('')+'</div>';
  }
  var _wired=false, _metric='', _rows=[];
  function wireGlobal(){
    if(_wired) return; _wired=true;
    document.body.addEventListener('click',function(e){
      var el=e.target.closest('.gs-report-table tr[data-i], .gs-svbars .gs-svbar[data-i], .gsdonut .dleg .k[data-idx], .gsdonut .seg[data-idx]');
      if(!el || e.target.closest('[data-seg-clear]')) return;
      var i = el.hasAttribute('data-i') ? +el.getAttribute('data-i') : +el.getAttribute('data-idx');
      var r=_rows[i]; if(!r) return;
      segSet(_metric+':'+r.label); location.reload();
    });
  }
  function heatmapHTML(grid){
    if(!grid||!grid.length) return '<div class="gs-muted small p-3">'+T('ix.no_data_yet')+'</div>';
    var days=['Mon','Tue','Wed','Thu','Fri','Sat','Sun'], max=1;
    grid.forEach(function(row){row.forEach(function(v){if(v>max)max=v;});});
    var head='<div class="gs-heat-row"><span class="gs-heat-day"></span>';
    for(var h=0;h<24;h++) head+='<span class="gs-heat-lbl">'+(h%2===0?h:'')+'</span>';
    head+='</div>';
    var body=grid.map(function(row,d){ return '<div class="gs-heat-row"><span class="gs-heat-day">'+days[d]+'</span>'
      +row.map(function(v){ var a=v?(0.12+(v/max)*0.88):0;
        return '<span class="gs-heat-cell" title="'+days[d]+' '+v+' visits" style="background:'+(v?'rgba(59,125,216,'+a.toFixed(2)+')':'var(--bg)')+'"></span>'; }).join('')
      +'</div>'; }).join('');
    return '<div class="gs-heat">'+head+body+'</div>';
  }
  function render(metric,data){
    renderSegChip();
    if(metric==='times'){
      var host=g('rep-chart'); if(!host) return; var rows=(data&&data.rows)||[], grid=(data&&data.heatmap)||[];
      var view='bars', seg=g('rep-view');
      function drawT(){ host.innerHTML = view==='heatmap' ? heatmapHTML(grid) : barsHTML(rows); }
      if(seg) seg.addEventListener('click',function(e){ var b=e.target.closest('button[data-v]'); if(!b)return;
        view=b.dataset.v; seg.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);}); drawT(); });
      drawT(); return;
    }
    if(metric==='rtmap'){
      var host=g('rep-chart'); if(!host) return;
      function mapTip(){ var t=document.getElementById('gs-map-tip'); if(!t){ t=document.createElement('div'); t.id='gs-map-tip'; t.className='gs-map-tip'; document.body.appendChild(t); } return t; }
      function colorMap(rows){
        var svg=host.querySelector('.worldmap'); if(!svg) return;
        var byCC={}; rows.forEach(function(r){ byCC[String(r.label).toUpperCase()]=+r.hits||0; });
        var max=Math.max.apply(null,rows.map(function(r){return +r.hits||0;}).concat([1]));
        svg.querySelectorAll('[data-cc]').forEach(function(p){ var v=byCC[p.getAttribute('data-cc')]||0;
          if(v>0){ p.setAttribute('fill','rgba(31,164,99,'+(0.2+(v/max)*0.8).toFixed(2)+')'); p.setAttribute('data-v',v); }
          else { p.setAttribute('fill','#E7ECF2'); p.removeAttribute('data-v'); } });
      }
      function ensureMap(rows){
        if(host.querySelector('.worldmap')){ colorMap(rows); return; }
        host.innerHTML='<div class="rtmap"><div class="gs-muted small p-2">Loading map\u2026</div></div>';
        fetch('/assets/svg/world.svg').then(function(r){return r.text();}).then(function(txt){
          var wrap=host.querySelector('.rtmap'); if(!wrap) return; wrap.innerHTML=txt+'<div class="rtmap-note">Countries shaded by visits \u00b7 hover for detail \u00b7 updates every 15s</div>';
          var svg=host.querySelector('.worldmap');
          if(svg && !svg._tw){ svg._tw=1;
            svg.addEventListener('mousemove',function(e){ var t=mapTip(), p=e.target.closest('[data-cc]'); if(!p){t.style.opacity=0;return;}
              var v=p.getAttribute('data-v'); t.textContent=p.getAttribute('data-cc')+(v?(' \u2014 '+v+' visits'):' \u2014 no visits'); t.style.opacity=1;
              t.style.left=Math.min(e.clientX+12,innerWidth-t.offsetWidth-8)+'px'; t.style.top=Math.max(8,e.clientY-t.offsetHeight-10)+'px'; });
            svg.addEventListener('mouseleave',function(){ mapTip().style.opacity=0; }); }
          colorMap(rows);
        }).catch(function(){ var wrap=host.querySelector('.rtmap'); if(wrap) wrap.innerHTML='<div class="gs-muted small p-2">'+T('ix.map_could_not_load')+'</div>'; });
      }
      ensureMap((data&&data.rows)||[]);
      if(!host._rm) host._rm=setInterval(function(){ if(!GS.site)return; GS.api('/stats/countries?site='+encodeURIComponent(GS.site)).then(function(r){ if(r.ok&&r.data) ensureMap(r.data.rows||[]); }).catch(function(){}); }, 15000);
      return;
    }
        if(metric==='visitslog'){ renderFeed((data&&data.visits)||[]); return; }
    var rows=(data&&data.rows)||[]; var host=g('rep-chart'); if(!host) return;
    _metric=metric; _rows=rows; wireGlobal();
    if(metric==='timeline'){ host.innerHTML = rows.length?lineSVG(rows):'<div class="gs-muted small p-3">'+T('ix.no_data_yet')+'</div>'; return; }
    var tb=g('rep-rows'), total=rows.reduce(function(a,b){return a+(+b.hits||0);},0)||1;
    if(tb) tb.innerHTML = rows.length?tableRows(rows,total,metric):'<tr><td colspan="5" class="gs-muted p-3">'+T('ix.no_data_yet')+'</td></tr>';
    var view=(metric==='times')?'bar':'donut', seg=g('rep-view');
    if(seg){ seg.querySelectorAll('button').forEach(function(b){ b.classList.toggle('on', b.dataset.v===view); }); }
    function draw(){ if(!rows.length){ host.innerHTML='<div class="gs-muted small p-3">'+T('ix.no_data_yet')+'</div>'; return; }
      if(view==='donut'){ host.innerHTML=donutView(rows,metric); wireDonut(host); }
      else if(view==='table'){ host.innerHTML='<div class="gs-muted small p-3">'+T('ix.see_the_table_below')+'</div>'; }
      else { host.innerHTML=barsHTML(rows); } }
    if(seg) seg.addEventListener('click',function(e){ var b=e.target.closest('button[data-v]'); if(!b)return;
      view=b.dataset.v; seg.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);}); draw(); });
    draw();
  }

  function boot(){
    var el=document.querySelector('[data-report]'); if(!el) return;
    var metric=el.getAttribute('data-report');
    if(!GS.site){ return; }
    var q='?site='+encodeURIComponent(GS.site)+segParam();
    var noSpark = (metric==='timeline'||metric==='visitslog'||metric==='times'||metric==='realtime'||metric==='rtmap');
    var ep = (metric==='rtmap') ? 'countries' : metric;
    Promise.all([
      GS.api('/stats/'+ep+q),
      noSpark ? Promise.resolve(null) : GS.api('/stats/sparklines?metric='+encodeURIComponent(metric)+'&site='+encodeURIComponent(GS.site)+segParam())
    ]).then(function(res){
      var r=res[0], sp=res[1];
      sparkMap = (sp&&sp.ok&&sp.data&&sp.data.series) || {};
      if(r&&r.ok&&r.data) render(metric,r.data);
      else { var h=g('rep-chart'); if(h) h.innerHTML='<div class="gs-muted small p-3">'+T('ix.could_not_load_this_report')+'</div>'; }
    }).catch(function(){ var h=g('rep-chart'); if(h) h.innerHTML='<div class="gs-muted small p-3">Could not load this report. Retrying\u2026</div>'; });
  }
  document.addEventListener('gs:ready', boot);
  document.addEventListener('gs:site-change', boot);
})();

/* ---- Segments page (saved named filters) ---- */
(function(){
  var NOUN={countries:T('ix.country'),devices:T('ix.device'),browsers:T('ix.browser'),software:T('ix.operating_system'),referrers:T('ix.referrer'),pages:T('ix.page'),utm:'Campaign source'};
  function q(k,root){ return (root||document).querySelector('[data-gs="'+k+'"]'); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function segGet(){ try{return localStorage.getItem('gs_segment')||'';}catch(e){return '';} }
  function segSet(v){ try{ v?localStorage.setItem('gs_segment',v):localStorage.removeItem('gs_segment'); }catch(e){} }
  function renderActive(){
    var host=q('seg-active'); if(!host) return; var s=segGet();
    if(!s||s.indexOf(':')<0){ host.innerHTML=''; return; }
    var p=s.split(':'), noun=NOUN[p[0]]||p[0];
    host.innerHTML='<div class="gs-seg-chip">Active filter: <b>'+esc(noun)+'</b> = '+esc(p.slice(1).join(':'))
      +'<button type="button" data-gs="seg-clear" aria-label="'+T('ix.clear')+'">&times;</button></div>';
    var b=q('seg-clear'); if(b) b.addEventListener('click',function(){ segSet(''); renderActive(); });
  }
  function renderList(items){
    var host=q('seg-list'); if(!host) return;
    if(!items.length){ host.innerHTML='<div class="gs-muted small">'+T('ix.no_saved_segments_yet_create_one_above')+'</div>'; return; }
    host.innerHTML='<div class="seg-rows">'+items.map(function(it){
      var noun=NOUN[it.dim]||it.dim;
      return '<div class="seg-row"><div class="seg-meta"><div class="seg-name">'+esc(it.name)+'</div>'
        +'<div class="gs-muted small">'+esc(noun)+' = '+esc(it.val)+'</div></div>'
        +'<div class="seg-actions"><button type="button" class="btn btn-outline btn-sm" data-apply="'+esc(it.dim)+':'+esc(it.val)+'">'+T('ix.apply')+'</button>'
        +'<button type="button" class="btn btn-link btn-sm text-danger" data-del="'+it.id+'">'+T('ix.delete')+'</button></div></div>';
    }).join('')+'</div>';
  }
  function load(){ GS.api('/segments').then(function(r){ renderList((r&&r.ok&&r.data&&r.data.segments)||[]); }).catch(function(){}); }
  function boot(){
    var root=document.querySelector('[data-page="segments"]'); if(!root) return;
    renderActive(); load();
    var save=q('seg-save');
    if(save) save.addEventListener('click',function(){
      var name=(q('seg-name').value||'').trim(), dim=q('seg-dim').value, val=(q('seg-val').value||'').trim();
      if(!name||!val){ alert(T('ix.please_enter_a_name_and_a_value')); return; }
      save.disabled=true;
      GS.api('/segments',{method:'POST',body:JSON.stringify({name:name,dim:dim,val:val})}).then(function(r){
        save.disabled=false;
        if(r&&r.ok){ q('seg-name').value=''; q('seg-val').value=''; load(); }
        else alert(T('ix.could_not_save_the_segment'));
      }).catch(function(){ save.disabled=false; alert(T('ix.could_not_save_the_segment')); });
    });
    root.addEventListener('click',function(e){
      var ap=e.target.closest('[data-apply]');
      if(ap){ segSet(ap.getAttribute('data-apply')); location.href='/timeline'; return; }
      var del=e.target.closest('[data-del]');
      if(del){ if(!confirm(T('ix.delete_this_segment'))) return;
        GS.api('/segments/delete',{method:'POST',body:JSON.stringify({id:+del.getAttribute('data-del')})}).then(load).catch(function(){}); }
    });
  }
  document.addEventListener('gs:ready', boot);
})();


/* ===== free-account plugin-page gate (funnel) ===== */
// Data is refused server-side for a gated free account; this only draws the centered Upgrade overlay
// over the (now empty) content area. Removing it in devtools reveals nothing.
(function(){
  "use strict";
  var CORE={dashboard:1,sites:1,"site-settings":1,"counter-customizer":1,"public-stats":1,"global-stats":1,plugins:1,admin:1,"user-settings":1,login:1,register:1,"forgot-password":1,support:1,analyze:1,directory:1,global:1};
  function slug(){ if(window.GS_PLUGIN) return window.GS_PLUGIN; var m=location.pathname.match(/^\/([a-z0-9-]+)\/?$/); var sl=m?m[1]:""; return CORE[sl]?"":sl; }
  function geom(){
    var tb=document.querySelector(".topbar,.gs-topbar,header"); var top=tb?Math.max(0,tb.getBoundingClientRect().bottom):58;
    var sb=document.querySelector("nav.gs-nav"); var left=(sb&&window.innerWidth>=992)?Math.max(0,sb.getBoundingClientRect().right):0;
    return {top:top,left:left};
  }
  function showGate(reason, balance){
    if(document.getElementById("gs-gate-ov")) return;
    var g=geom();
    var ov=document.createElement("div"); ov.id="gs-gate-ov";
    ov.style.cssText="position:fixed;top:"+g.top+"px;left:"+g.left+"px;right:0;bottom:0;z-index:1050;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(247,249,252,.72);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)";
    var msg=(reason==="quota")?"You\u2019ve used your free monthly views for this report.":T('ix.this_report_is_part_of_pro');
    var b=+balance||0;
    var credLine=b>0?'<p style="color:#8A5A00;font-size:.82rem;margin:-.4rem 0 1rem"><i class="bi bi-coin" style="margin-right:.3rem;color:#D97706"></i>You have '+b+' credit'+(b===1?'':'s')+' \u2014 not enough for this report.</p>':'';
    ov.innerHTML='<div style="max-width:420px;width:100%;text-align:center;background:#fff;border:1px solid #E7ECF3;border-radius:14px;box-shadow:0 18px 50px rgba(20,40,80,.18);padding:32px 28px">'
      +'<i class="bi bi-stars" style="font-size:2rem;color:#1F5FD0;line-height:1"></i>'
      +'<h3 style="margin:.5rem 0 .3rem;font-size:1.15rem;font-weight:700">'+T('ix.upgrade_to_unlock')+'</h3>'
      +'<p style="color:#6b7280;font-size:.9rem;margin:0 0 1.1rem">'+msg+' Your dashboard widget stays free.</p>'
      +credLine
      +'<div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap">'
      +'<a href="/user-settings#billing" style="display:inline-block;background:#1F8A50;color:#fff;text-decoration:none;padding:.6rem 1.2rem;border-radius:8px;font-weight:600">'+T('ix.see_pro_plans')+'</a>'
      +'<button type="button" data-gs-buycred style="background:#fff;color:#1F5FD0;border:1px solid #1F5FD0;border-radius:8px;padding:.6rem 1.2rem;font-weight:600;cursor:pointer"><i class="bi bi-coin" style="margin-right:.35rem"></i>'+T('ix.buy_credits')+'</button>'
      +'</div></div>';
    document.body.appendChild(ov);
    var bc=ov.querySelector("[data-gs-buycred]"); if(bc) bc.addEventListener("click", function(){ showCreditsModal(slug()); });
    window.addEventListener("resize", function(){ var q=geom(); ov.style.top=q.top+"px"; ov.style.left=q.left+"px"; });
  }
  /* The "Buy credits" purchase flow. Credit packs unlock extra report views without upgrading. The
     pack catalog + prices come from the server (/me/credits/packs), so this UI can't drift from the
     real pricing. Buying POSTs /me/credits/checkout and redirects to the returned URL — a Stripe/PayPal
     Checkout page when keys are live, or a signed local dev-confirm that grants immediately when they
     aren't. Both the quota banner and the per-report info bar open this. */
  var CREDIT_PACKS_FALLBACK = [
    { id:"pack_100", credits:100, price_cents:999 },
    { id:"pack_250", credits:250, price_cents:1999 },
    { id:"pack_600", credits:600, price_cents:3999 }
  ];
  function creditPrice(c){ return "$" + (c/100).toFixed(2); }
  window.GSCredits = window.GSCredits || { buy: function (slug) { showCreditsModal(slug); } };
  function showCreditsModal(slug){
    if(document.getElementById("gs-credits-ov")) return;
    slug = slug || "";
    var ov=document.createElement("div"); ov.id="gs-credits-ov";
    ov.style.cssText="position:fixed;inset:0;z-index:1060;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(20,40,80,.34);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)";
    ov.innerHTML='<div style="max-width:400px;width:100%;background:#fff;border:1px solid #E7ECF3;border-radius:14px;box-shadow:0 18px 50px rgba(20,40,80,.22);padding:26px 24px 22px;position:relative">'
      +'<button type="button" data-gs-x aria-label="'+T('ix.close')+'" style="position:absolute;top:10px;right:13px;background:0;border:0;font-size:1.3rem;line-height:1;color:#9AA4B2;cursor:pointer">&times;</button>'
      +'<div data-gs-body><div style="text-align:center;color:#9AA4B2;font-size:.85rem;padding:20px">Loading&#8230;</div></div>'
      +'<div style="border-top:1px solid #EEF1F6;margin:14px 0 12px"></div>'
      +'<div style="text-align:center;font-size:.88rem;color:#6b7280">Prefer unlimited views? '
      +'<a href="/user-settings#billing" style="color:#1F8A50;font-weight:600;text-decoration:none">'+T('ix.see_pro_plans')+'</a></div></div>';
    document.body.appendChild(ov);
    function close(){ if(ov.parentNode) ov.parentNode.removeChild(ov); document.removeEventListener("keydown", onEsc); }
    function onEsc(e){ if(e.key==="Escape") close(); }
    ov.addEventListener("click", function(e){ if(e.target===ov) close(); });
    var x=ov.querySelector("[data-gs-x]"); if(x) x.addEventListener("click", close);
    document.addEventListener("keydown", onEsc);
    var body=ov.querySelector("[data-gs-body]");

    function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }

    /* ---- BUY mode: purchase credit packs ---- */
    function renderBuy(packs){
      body.innerHTML='<div style="text-align:center;margin-bottom:14px"><i class="bi bi-coin" style="font-size:1.9rem;color:#D97706;line-height:1"></i>'
        +'<h3 style="margin:.45rem 0 .25rem;font-size:1.15rem;font-weight:700">'+T('ix.buy_credits')+'</h3>'
        +'<p style="color:#6b7280;font-size:.88rem;margin:0">'+T('ix.credit_packs_unlock_extra_report_views_witho')+'</p></div>'
        +'<div data-gs-packs>'+packs.map(function(p){
          return '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;border:1px solid #E7ECF3;border-radius:10px;padding:10px 12px;margin-bottom:8px">'
            +'<div style="text-align:left"><div style="font-weight:700;color:#1f2937">'+p.credits+' credits</div>'
            +'<div style="font-size:.8rem;color:#6b7280">'+creditPrice(p.price_cents)+'</div></div>'
            +'<button type="button" data-gs-pack="'+esc(p.id)+'" style="background:#1F5FD0;color:#fff;border:0;border-radius:8px;padding:.45rem .9rem;font-weight:600;font-size:.85rem;cursor:pointer">Buy</button></div>';
        }).join("")+'</div>'
        +'<div data-gs-buy-msg style="color:#B42318;font-size:.82rem;text-align:center;min-height:1em;margin-top:2px"></div>';
      var wrap=body.querySelector("[data-gs-packs]"), msg=body.querySelector("[data-gs-buy-msg]");
      wrap.addEventListener("click", function(e){ var b=e.target.closest("[data-gs-pack]"); if(b) buy(b.getAttribute("data-gs-pack"), b, msg); });
    }
    function buy(packId, btn, msg){
      if(btn){ btn.disabled=true; btn.textContent="\u2026"; } if(msg) msg.textContent="";
      GS.api("/me/credits/checkout",{method:"POST",body:JSON.stringify({pack:packId,provider:"stripe"})}).then(function(r){
        var url=r&&r.ok&&r.data&&r.data.url;
        if(url){ window.location.href=url; return; }             // Checkout page or dev-confirm redirect
        if(btn){ btn.disabled=false; btn.textContent="Buy"; }
        var e=(r&&r.data&&r.data.error)||"";
        if(msg) msg.textContent = e==="stripe_unavailable"||e==="paypal_unavailable"
          ? "Card payments aren't enabled yet - check back soon." : T('ix.couldn_t_start_checkout_please_try_again');
      }).catch(function(){ if(btn){ btn.disabled=false; btn.textContent="Buy"; } if(msg) msg.textContent="Couldn't start checkout. Please try again."; });
    }

    /* ---- SPEND mode: turn existing credits into views for THIS plugin ---- */
    function renderSpend(d){
      var cost=+d.cost||1, bal=+d.balance||0, name=d.plugin_name||"this report", bank=+d.bank||0;
      var maxV=Math.max(1, Math.floor(bal/cost));
      body.innerHTML='<div style="text-align:center;margin-bottom:12px"><i class="bi bi-coin" style="font-size:1.9rem;color:#D97706;line-height:1"></i>'
        +'<h3 style="margin:.45rem 0 .25rem;font-size:1.15rem;font-weight:700">'+T('ix.use_your_credits')+'</h3>'
        +'<p style="color:#6b7280;font-size:.88rem;margin:0">'+T('ix.you_have')+'<b>'+bal+'</b> credits &mdash; enough for <b>'+maxV+'</b> view'+(maxV===1?'':'s')+' of <b>'+esc(name)+'</b> ('+cost+'/view).</p></div>'
        +(bank>0?'<p style="text-align:center;color:#1F8A50;font-size:.82rem;margin:-.3rem 0 .8rem">You already have '+bank+' prepaid view'+(bank===1?'':'s')+' for this report.</p>':'')
        +'<div style="display:flex;align-items:center;gap:10px;border:1px solid #E7ECF3;border-radius:10px;padding:10px 12px;margin-bottom:10px">'
        +'<label style="font-weight:600;color:#1f2937;font-size:.9rem;flex:1 1 auto">'+T('ix.views_to_unlock')+'</label>'
        +'<input type="number" data-gs-views min="1" max="'+maxV+'" value="1" style="width:78px;border:1px solid #D7DEE8;border-radius:8px;padding:.35rem .5rem;font-weight:600;text-align:center">'
        +'</div>'
        +'<div data-gs-cost style="text-align:center;color:#6b7280;font-size:.82rem;margin-bottom:10px">Unlock 1 view &middot; '+cost+' credits</div>'
        +'<button type="button" data-gs-unlock style="width:100%;background:#1F8A50;color:#fff;border:0;border-radius:8px;padding:.55rem;font-weight:600;font-size:.9rem;cursor:pointer">'+T('ix.unlock_views')+'</button>'
        +'<div data-gs-buy-msg style="color:#B42318;font-size:.82rem;text-align:center;min-height:1em;margin-top:6px"></div>'
        +'<div style="text-align:center;font-size:.82rem;color:#6b7280;margin-top:8px">or <a href="#" data-gs-buymore style="color:#1F5FD0;font-weight:600;text-decoration:none">buy more credits</a></div>';
      var input=body.querySelector("[data-gs-views]"), costLine=body.querySelector("[data-gs-cost]"),
          unlock=body.querySelector("[data-gs-unlock]"), msg=body.querySelector("[data-gs-buy-msg]");
      function clampN(){ var n=parseInt(input.value,10)||1; if(n<1)n=1; if(n>maxV)n=maxV; return n; }
      function refresh(){ var n=clampN(); costLine.innerHTML="Unlock "+n+" view"+(n===1?"":"s")+" &middot; "+(n*cost)+" credits"; }
      input.addEventListener("input", refresh); input.addEventListener("change", function(){ input.value=clampN(); refresh(); });
      unlock.addEventListener("click", function(){ input.value=clampN(); spend(clampN(), unlock, msg, name); });
      var more=body.querySelector("[data-gs-buymore]");
      if(more) more.addEventListener("click", function(e){ e.preventDefault(); renderBuy((d.packs&&d.packs.length)?d.packs:CREDIT_PACKS_FALLBACK); });
    }
    function spend(views, btn, msg, name){
      if(btn){ btn.disabled=true; btn.textContent="\u2026"; } if(msg) msg.textContent="";
      GS.api("/me/credits/spend-views",{method:"POST",body:JSON.stringify({slug:slug,views:views})}).then(function(r){
        var d=r&&r.data;
        if(r&&r.ok&&d&&d.ok){
          body.innerHTML='<div style="text-align:center;padding:6px 0"><i class="bi bi-check-circle-fill" style="font-size:2rem;color:#1F8A50;line-height:1"></i>'
            +'<h3 style="margin:.5rem 0 .3rem;font-size:1.12rem;font-weight:700">'+T('ix.views_unlocked')+'</h3>'
            +'<p style="color:#6b7280;font-size:.9rem;margin:0 0 14px">'+T('ix.added')+'<b>'+d.views_added+'</b> view'+(d.views_added===1?'':'s')+' for <b>'+esc(name||"this report")+'</b>. You have <b>'+d.balance+'</b> credits left.</p>'
            +'<button type="button" data-gs-done style="background:#1F8A50;color:#fff;border:0;border-radius:8px;padding:.5rem 1.4rem;font-weight:600;cursor:pointer">'+T('ix.done')+'</button></div>';
          var done=body.querySelector("[data-gs-done]"); if(done) done.addEventListener("click", close);
          return;
        }
        if(btn){ btn.disabled=false; btn.textContent="Unlock views"; }
        if(msg) msg.textContent=(d&&d.error==="insufficient")?"Not enough credits for that many views.":T('ix.couldn_t_unlock_please_try_again');
      }).catch(function(){ if(btn){ btn.disabled=false; btn.textContent="Unlock views"; } if(msg) msg.textContent="Couldn't unlock. Please try again."; });
    }

    /* Decide the mode: if the account holds enough credits for at least one view of this plugin, offer
       to spend them; otherwise show the packs to buy. */
    GS.api("/me/credits/packs"+(slug?("?slug="+encodeURIComponent(slug)):"")).then(function(r){
      var d=(r&&r.ok&&r.data)?r.data:{};
      var packs=(d.packs&&d.packs.length)?d.packs:CREDIT_PACKS_FALLBACK;
      if(slug && (+d.cost>0) && (+d.balance||0) >= +d.cost) renderSpend(d);
      else renderBuy(packs);
    }).catch(function(){ renderBuy(CREDIT_PACKS_FALLBACK); });
  }
  function showQuotaInfo(remaining, quota){
    if(document.getElementById("gs-quota-info")) return;
    var main=document.querySelector(".gs-main")||document.body;
    var bar=document.createElement("div"); bar.id="gs-quota-info";
    bar.style.cssText="display:flex;align-items:center;gap:.6rem;background:#EAF2FE;border:1px solid #BBD6FA;color:#134E9A;border-radius:10px;padding:10px 14px;margin:0 0 16px;font-size:.9rem;width:100%;box-sizing:border-box";
    bar.innerHTML='<i class="bi bi-info-circle-fill" style="font-size:1.05rem;color:#1F5FD0;flex:0 0 auto"></i><span>Free plan: you have <strong>'+remaining+'</strong> of '+quota+' views left for this report this month.</span>'
      +'<button type="button" data-gs-buy style="margin-left:auto;flex:0 0 auto;background:#1F5FD0;color:#fff;border:0;border-radius:8px;padding:.35rem .8rem;font-weight:600;font-size:.82rem;cursor:pointer;white-space:nowrap"><i class="bi bi-coin" style="margin-right:.35rem"></i>'+T('ix.buy_credits')+'</button>';
    var buy=bar.querySelector("[data-gs-buy]"); if(buy) buy.addEventListener("click", function(){ showCreditsModal(slug()); });
    // Place it right after the page header. Core pages use .head, plugin pages .page-head — the
    // banner used to know only the first, so on a plugin page it fell through to the card fallback
    // and landed INSIDE a grid column, rendering at half width.
    placeBanner(main, bar);
  }
  /* Shown once the free views for a report are gone and the account paid with credits: the view still
     loads, and this says what it cost and what's left, with the same Buy credits top-up. */
  function showCreditInfo(cost, balance){
    if(document.getElementById("gs-quota-info")) return;
    var main=document.querySelector(".gs-main")||document.body;
    var bar=document.createElement("div"); bar.id="gs-quota-info";
    bar.style.cssText="display:flex;align-items:center;gap:.6rem;background:#FEF6E7;border:1px solid #F5D98B;color:#8A5A00;border-radius:10px;padding:10px 14px;margin:0 0 16px;font-size:.9rem;width:100%;box-sizing:border-box";
    var c=+cost||1, b=+balance||0;
    bar.innerHTML='<i class="bi bi-coin" style="font-size:1.05rem;color:#D97706;flex:0 0 auto"></i><span>Out of free views for this report &mdash; used <strong>'+c+'</strong> credit'+(c===1?'':'s')+', <strong>'+b+'</strong> left.</span>'
      +'<button type="button" data-gs-buy style="margin-left:auto;flex:0 0 auto;background:#D97706;color:#fff;border:0;border-radius:8px;padding:.35rem .8rem;font-weight:600;font-size:.82rem;cursor:pointer;white-space:nowrap"><i class="bi bi-coin" style="margin-right:.35rem"></i>'+T('ix.buy_credits')+'</button>';
    var buy=bar.querySelector("[data-gs-buy]"); if(buy) buy.addEventListener("click", function(){ showCreditsModal(slug()); });
    placeBanner(main, bar);
  }
  /* Shown when a view was covered by a prepaid view the user bought for this report. */
  function showPrepaidInfo(bank){
    if(document.getElementById("gs-quota-info")) return;
    var main=document.querySelector(".gs-main")||document.body;
    var bar=document.createElement("div"); bar.id="gs-quota-info";
    bar.style.cssText="display:flex;align-items:center;gap:.6rem;background:#E9F7EF;border:1px solid #A9E0C2;color:#1F6B45;border-radius:10px;padding:10px 14px;margin:0 0 16px;font-size:.9rem;width:100%;box-sizing:border-box";
    var b=Math.max(0,+bank||0);
    bar.innerHTML='<i class="bi bi-coin" style="font-size:1.05rem;color:#1F8A50;flex:0 0 auto"></i><span>Used a prepaid view for this report &mdash; <strong>'+b+'</strong> left.</span>'
      +'<button type="button" data-gs-buy style="margin-left:auto;flex:0 0 auto;background:#1F8A50;color:#fff;border:0;border-radius:8px;padding:.35rem .8rem;font-weight:600;font-size:.82rem;cursor:pointer;white-space:nowrap"><i class="bi bi-coin" style="margin-right:.35rem"></i>'+T('ix.add_views')+'</button>';
    var buy=bar.querySelector("[data-gs-buy]"); if(buy) buy.addEventListener("click", function(){ showCreditsModal(slug()); });
    placeBanner(main, bar);
  }
  function placeBanner(main, bar){
    // Core pages use .head, plugin pages .page-head. The banner used to know only the first, so on a
    // plugin page it fell through to the card fallback and landed INSIDE a grid column at half width.
    var head=main.querySelector(".head")||main.querySelector(".page-head");
    if(head){
      /* The header is usually followed by a one-line description of the page. Dropping the banner
         straight after the header split that pair, so the heading was followed by a quota notice and
         only then by the sentence explaining what the page is. Skip past an immediately-following
         intro paragraph so the title keeps its description. */
      var anchor=head, next=head.nextElementSibling;
      if(next && next.tagName==="P" && next.textContent.trim().length>0 &&
         !next.querySelector("input,button,select,a.btn")) anchor=next;
      anchor.insertAdjacentElement("afterend", bar);
    }
    else {
      // Never insert inside a grid cell: a banner in a .col-* renders at that column's width.
      var card=main.querySelector(".gs-card")||main.querySelector("section")||main.querySelector(".card")||main.querySelector(".gs-table-wrap")||main.querySelector("div");
      while(card && card.parentElement && /(^|\s)col(-|\s|$)/.test(card.parentElement.className||"")) card=card.parentElement;
      while(card && /(^|\s)(row|col)(-|\s|$)/.test(card.className||"") && card.parentElement && card.parentElement!==main) card=card.parentElement;
      if(card && card.parentElement){ card.parentElement.insertBefore(bar, card); }
      else { var h1=main.querySelector("h1"); if(h1){ h1.insertAdjacentElement("afterend", bar); } else { main.insertBefore(bar, main.firstChild); } }
    }
  }
  document.addEventListener("gs:ready", function(){
    var sl=slug(); if(!sl || !window.GS || !GS.api) return;
    GS.api("/plugins/gate?slug="+encodeURIComponent(sl)).then(function(r){
      var g=r&&r.data; if(!g) return;
      if(g.allowed===false){ showGate(g.reason, g.balance); return; }
      if(g.prepaid){ showPrepaidInfo(g.bank); return; }                        // used a prepaid view
      if(g.credited){ showCreditInfo(g.cost, g.balance); return; }              // free views used up, paid with credits
      if(g.quota>0 && g.remaining!=null) showQuotaInfo(g.remaining, g.quota);   // free plan with a monthly allowance
    }).catch(function(){});
  });
})();

/* ===== left-nav scroll fix: bound the sidebar to the viewport so ITS body scrolls (never the page) ===== */
(function(){
  function fitNav(){
    var nav=document.querySelector('nav.gs-nav'); if(!nav) return;
    var nb=nav.querySelector('.gs-nav-body'); if(!nb) return;
    if(window.innerWidth<992){
      ['position','top','height','display','flex-direction','align-self'].forEach(function(k){nav.style.removeProperty(k);});
      ['flex','min-height','max-height','overflow-y','overscroll-behavior'].forEach(function(k){nb.style.removeProperty(k);});
      return;
    }
    var tbEl=document.querySelector('.topbar,.gs-topbar,header'); var tb=tbEl?Math.round(tbEl.getBoundingClientRect().height):58;
    nav.style.setProperty('position','sticky','important');
    nav.style.setProperty('top',tb+'px','important');
    nav.style.setProperty('height','calc(100vh - '+tb+'px)','important');
    nav.style.setProperty('display','flex','important');
    nav.style.setProperty('flex-direction','column','important');
    nav.style.setProperty('align-self','flex-start','important');
    nb.style.setProperty('flex','1 1 auto','important');
    nb.style.setProperty('min-height','0','important');
    nb.style.setProperty('max-height','none','important');
    nb.style.setProperty('overflow-y','auto','important');
    nb.style.setProperty('overscroll-behavior','contain','important');
  }
  window.GS_fitNav=fitNav;
  document.addEventListener('gs:ready', function(){ fitNav(); setTimeout(fitNav,300); });
  window.addEventListener('resize', fitNav);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fitNav); else setTimeout(fitNav,0);
})();

/* ===== community forum offcanvas (Pro+ and admin) =====
   Reveals the topbar trigger for Pro+ (plan_id 10) and admins, and fills the offcanvas with recent
   discuss.ghoststat.me posts each time it opens (server proxy /forum/recent, cached 60s). */
(function () {
  function fesc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function fago(iso){ if(!iso) return ''; var d=new Date(iso), s=(Date.now()-d.getTime())/1000; if(isNaN(s)) return '';
    if(s<3600) return Math.max(1,Math.round(s/60))+'m'; if(s<86400) return Math.round(s/3600)+'h'; return Math.round(s/86400)+'d'; }
  async function loadForum(){
    var host = GSUI.gs('forum-list'); if(!host) return;
    try {
      var r = await GS.api('/forum/recent');
      var items = (r && r.ok && r.data && r.data.items) ? r.data.items : [];  // GS.api wraps the body in .data
      if(!items.length){ host.innerHTML = '<div class="gs-muted small">'+T('forum.empty')+'</div>'; return; }
      host.innerHTML = items.map(function(it){
        var meta = [];
        if(it.tag) meta.push('<span class="gs-forum-tag">'+fesc(it.tag)+'</span>');
        if(it.author) meta.push('<span>'+fesc(it.author)+'</span>');
        if(it.when) meta.push('<span>'+fesc(fago(it.when))+'</span>');
        if(it.comments) meta.push('<span><i class="bi bi-chat"></i> '+(+it.comments)+'</span>');
        return '<a class="gs-forum-card" href="'+fesc(it.url)+'" target="_blank" rel="noopener">'
          + '<div class="gs-forum-title">'+fesc(it.title)+'</div>'
          + '<div class="gs-forum-meta">'+meta.join('')+'</div></a>';
      }).join('');
    } catch(e){ host.innerHTML = '<div class="gs-muted small">'+T('forum.empty')+'</div>'; }
  }
  document.addEventListener('gs:ready', function(){
    if(!(window.GS && GS.user && GS.user.show_forum !== false)) return;  // shown to everyone unless hidden in settings
    document.querySelectorAll('[data-forum-only]').forEach(function(el){ el.classList.remove('d-none'); });
    var oc = document.getElementById('gsForum');
    if(oc) oc.addEventListener('show.bs.offcanvas', loadForum);
  });
})();
